class $426c06cb104d4dd1$export$2e2bcd8739ae039 extends HTMLElement {
    static get observedAttributes() {
        return [
            'disabled'
        ];
    }
    async connectedCallback() {
        const disabledAttr = this.hasAttribute('disabled') ? ' disabled' : '';
        const classAttr = this.classList.contains('danger') ? ' class="danger"' : '';
        this.innerHTML = `<button type="submit"${disabledAttr}${classAttr}>${this.innerHTML}</button>`;
        const button = this.querySelector('button');
        const form = button.form;
        if (form) form.addEventListener('submit', ()=>{
            button.setAttribute('disabled', 'disabled');
            document.body.insertAdjacentHTML('afterbegin', '<div id="loader-backdrop"><div class="loader"></div></div>');
            const backdrop = document.getElementById('loader-backdrop');
            setTimeout(()=>backdrop.classList.add('visible'), 50);
            setTimeout(()=>{
                // Timeout
                backdrop.classList.remove('visible');
                backdrop.parentNode.removeChild(backdrop);
                button.removeAttribute('disabled');
            }, 20000);
        });
        else console.warn(`${this.tagName} is not enclosed by a <form> element`);
    }
    async attributeChangedCallback() {
        const button = this.querySelector('button');
        if (button) {
            if (this.hasAttribute('disabled')) button.setAttribute('disabled', 'disabled');
            else button.removeAttribute('disabled');
        }
    }
}


/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $87e6acd7396d97dc$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $87e6acd7396d97dc$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $87e6acd7396d97dc$export$869b26d4e1bbdb63(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $87e6acd7396d97dc$export$dbf961a8d278dbef(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $87e6acd7396d97dc$export$aa35ef1f24408ab9(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $87e6acd7396d97dc$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $87e6acd7396d97dc$var$hex = [
    ...'0123456789ABCDEF'
];
const $87e6acd7396d97dc$var$h1 = (b)=>$87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$h2 = (b)=>$87e6acd7396d97dc$var$hex[(b & 0xF0) >> 4] + $87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $87e6acd7396d97dc$var$isShort = (v)=>$87e6acd7396d97dc$var$eq(v.r) && $87e6acd7396d97dc$var$eq(v.g) && $87e6acd7396d97dc$var$eq(v.b) && $87e6acd7396d97dc$var$eq(v.a);
function $87e6acd7396d97dc$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $87e6acd7396d97dc$var$map$1[str[1]] * 17,
            g: 255 & $87e6acd7396d97dc$var$map$1[str[2]] * 17,
            b: 255 & $87e6acd7396d97dc$var$map$1[str[3]] * 17,
            a: len === 5 ? $87e6acd7396d97dc$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $87e6acd7396d97dc$var$map$1[str[1]] << 4 | $87e6acd7396d97dc$var$map$1[str[2]],
            g: $87e6acd7396d97dc$var$map$1[str[3]] << 4 | $87e6acd7396d97dc$var$map$1[str[4]],
            b: $87e6acd7396d97dc$var$map$1[str[5]] << 4 | $87e6acd7396d97dc$var$map$1[str[6]],
            a: len === 9 ? $87e6acd7396d97dc$var$map$1[str[7]] << 4 | $87e6acd7396d97dc$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $87e6acd7396d97dc$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $87e6acd7396d97dc$export$1b06654353ef9f67(v) {
    var f = $87e6acd7396d97dc$var$isShort(v) ? $87e6acd7396d97dc$var$h1 : $87e6acd7396d97dc$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $87e6acd7396d97dc$var$alpha(v.a, f) : undefined;
}
const $87e6acd7396d97dc$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $87e6acd7396d97dc$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $87e6acd7396d97dc$var$hwb2rgbn(h, w, b) {
    const rgb = $87e6acd7396d97dc$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $87e6acd7396d97dc$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $87e6acd7396d97dc$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $87e6acd7396d97dc$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $87e6acd7396d97dc$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($87e6acd7396d97dc$export$ed9bd8dcaeba14f6);
}
function $87e6acd7396d97dc$export$4c15bd42559b811d(h, s, l) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsl2rgbn, h, s, l);
}
function $87e6acd7396d97dc$export$e2710022c70fc9ee(h, w, b) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hwb2rgbn, h, w, b);
}
function $87e6acd7396d97dc$export$b785a357c84e4a04(h, s, v) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsv2rgbn, h, s, v);
}
function $87e6acd7396d97dc$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $87e6acd7396d97dc$export$5e91288c399be4f9(str) {
    const m = $87e6acd7396d97dc$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(+m[5]) : $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $87e6acd7396d97dc$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $87e6acd7396d97dc$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $87e6acd7396d97dc$export$b785a357c84e4a04(h, p1, p2);
    else v = $87e6acd7396d97dc$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $87e6acd7396d97dc$export$bb628a54ab399bc9(v, deg) {
    var h = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    h[0] = $87e6acd7396d97dc$var$hue(h[0] + deg);
    h = $87e6acd7396d97dc$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $87e6acd7396d97dc$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[1]);
    const l = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $87e6acd7396d97dc$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $87e6acd7396d97dc$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $87e6acd7396d97dc$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($87e6acd7396d97dc$var$names$1);
    const tkeys = Object.keys($87e6acd7396d97dc$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $87e6acd7396d97dc$var$map[k]);
        }
        k = parseInt($87e6acd7396d97dc$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $87e6acd7396d97dc$var$names;
function $87e6acd7396d97dc$export$b2f06b640faad956(str) {
    if (!$87e6acd7396d97dc$var$names) {
        $87e6acd7396d97dc$var$names = $87e6acd7396d97dc$var$unpack();
        $87e6acd7396d97dc$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $87e6acd7396d97dc$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $87e6acd7396d97dc$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$export$91aedb20f296e541(str) {
    const m = $87e6acd7396d97dc$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) : $87e6acd7396d97dc$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(r) : $87e6acd7396d97dc$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(g) : $87e6acd7396d97dc$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(b) : $87e6acd7396d97dc$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $87e6acd7396d97dc$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $87e6acd7396d97dc$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $87e6acd7396d97dc$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $87e6acd7396d97dc$var$interpolate(rgb1, rgb2, t) {
    const r = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.r));
    const g = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.g));
    const b = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(r + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(g + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(b + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $87e6acd7396d97dc$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $87e6acd7396d97dc$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $87e6acd7396d97dc$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $87e6acd7396d97dc$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $87e6acd7396d97dc$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $87e6acd7396d97dc$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $87e6acd7396d97dc$export$91aedb20f296e541(str);
    return $87e6acd7396d97dc$export$5e91288c399be4f9(str);
}
class $87e6acd7396d97dc$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $87e6acd7396d97dc$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $87e6acd7396d97dc$var$fromObject(input);
        else if (type === 'string') v = $87e6acd7396d97dc$export$625a38b961e8b5e9(input) || $87e6acd7396d97dc$export$b2f06b640faad956(input) || $87e6acd7396d97dc$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $87e6acd7396d97dc$var$clone(this._rgb);
        if (v) v.a = $87e6acd7396d97dc$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $87e6acd7396d97dc$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $87e6acd7396d97dc$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $87e6acd7396d97dc$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $87e6acd7396d97dc$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $87e6acd7396d97dc$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $87e6acd7396d97dc$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $87e6acd7396d97dc$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $87e6acd7396d97dc$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $87e6acd7396d97dc$export$2e2bcd8739ae039(input) {
    return new $87e6acd7396d97dc$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $84f61e7391a78632$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $84f61e7391a78632$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $84f61e7391a78632$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $84f61e7391a78632$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $84f61e7391a78632$export$c4ce752e73470fba(value, defaultValue) {
    return $84f61e7391a78632$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $84f61e7391a78632$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $84f61e7391a78632$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $84f61e7391a78632$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $84f61e7391a78632$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $84f61e7391a78632$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($84f61e7391a78632$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $84f61e7391a78632$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $84f61e7391a78632$export$667d3bf0c5f83305(source) {
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(source)) return source.map($84f61e7391a78632$export$667d3bf0c5f83305);
    if ($84f61e7391a78632$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $84f61e7391a78632$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $84f61e7391a78632$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $84f61e7391a78632$export$317a3d46287192d8(key, target, source, options) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
function $84f61e7391a78632$export$efca4cbe5dd06740(target, source, options) {
    const sources = $84f61e7391a78632$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$84f61e7391a78632$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $84f61e7391a78632$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$84f61e7391a78632$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $84f61e7391a78632$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $84f61e7391a78632$export$efca4cbe5dd06740(target, source, {
        merger: $84f61e7391a78632$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $84f61e7391a78632$export$1ee57be6f6687d2c(key, target, source) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) $84f61e7391a78632$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $84f61e7391a78632$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $84f61e7391a78632$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $84f61e7391a78632$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $84f61e7391a78632$var$_getKeyResolver(key) {
    const keys = $84f61e7391a78632$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $84f61e7391a78632$export$2d1720544b23b823(obj, key) {
    const resolver = $84f61e7391a78632$var$keyResolvers[key] || ($84f61e7391a78632$var$keyResolvers[key] = $84f61e7391a78632$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $84f61e7391a78632$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $84f61e7391a78632$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $84f61e7391a78632$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $84f61e7391a78632$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $84f61e7391a78632$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $84f61e7391a78632$export$56c0d5a1e737357d = Math.PI;
const $84f61e7391a78632$export$971d5caa766a69d7 = 2 * $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$2ec5befb9e6c97d4 = $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $84f61e7391a78632$export$39c1cc7c062529d4 = $84f61e7391a78632$export$56c0d5a1e737357d / 180;
const $84f61e7391a78632$export$7f8ddf7c7c20b3cd = $84f61e7391a78632$export$56c0d5a1e737357d / 2;
const $84f61e7391a78632$export$7a0bdf7d4a91ea88 = $84f61e7391a78632$export$56c0d5a1e737357d / 4;
const $84f61e7391a78632$export$c18d01048907ea92 = $84f61e7391a78632$export$56c0d5a1e737357d * 2 / 3;
const $84f61e7391a78632$export$faec65b429be379 = Math.log10;
const $84f61e7391a78632$export$2408f22a0fab9ae5 = Math.sign;
function $84f61e7391a78632$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $84f61e7391a78632$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $84f61e7391a78632$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $84f61e7391a78632$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $84f61e7391a78632$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $84f61e7391a78632$export$d141bba7fdc215a3(n) {
    return !$84f61e7391a78632$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $84f61e7391a78632$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $84f61e7391a78632$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $84f61e7391a78632$export$625550452a3fa3ec(degrees) {
    return degrees * ($84f61e7391a78632$export$56c0d5a1e737357d / 180);
}
function $84f61e7391a78632$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $84f61e7391a78632$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $84f61e7391a78632$export$91477dc880baac21(x) {
    if (!$84f61e7391a78632$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $84f61e7391a78632$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $84f61e7391a78632$export$56c0d5a1e737357d) angle += $84f61e7391a78632$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $84f61e7391a78632$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $84f61e7391a78632$export$f074adc9fbd50943(a, b) {
    return (a - b + $84f61e7391a78632$export$2ec5befb9e6c97d4) % $84f61e7391a78632$export$971d5caa766a69d7 - $84f61e7391a78632$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $84f61e7391a78632$export$3d12bd131bb975d1(a) {
    return (a % $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$971d5caa766a69d7) % $84f61e7391a78632$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $84f61e7391a78632$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $84f61e7391a78632$export$3d12bd131bb975d1(angle);
    const s = $84f61e7391a78632$export$3d12bd131bb975d1(start);
    const e = $84f61e7391a78632$export$3d12bd131bb975d1(end);
    const angleToStart = $84f61e7391a78632$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $84f61e7391a78632$export$3d12bd131bb975d1(e - a);
    const startToAngle = $84f61e7391a78632$export$3d12bd131bb975d1(a - s);
    const endToAngle = $84f61e7391a78632$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $84f61e7391a78632$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $84f61e7391a78632$export$71cec2538cb2c617(value) {
    return $84f61e7391a78632$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $84f61e7391a78632$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $84f61e7391a78632$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $84f61e7391a78632$export$ef35774e6d314e91 = (table, key, value, last)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $84f61e7391a78632$export$ebd11618f299a286 = (table, key, value)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $84f61e7391a78632$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $84f61e7391a78632$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $84f61e7391a78632$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $84f61e7391a78632$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $84f61e7391a78632$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $84f61e7391a78632$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $84f61e7391a78632$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $84f61e7391a78632$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $84f61e7391a78632$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $84f61e7391a78632$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $84f61e7391a78632$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $84f61e7391a78632$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $84f61e7391a78632$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $84f61e7391a78632$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $84f61e7391a78632$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($84f61e7391a78632$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $84f61e7391a78632$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($84f61e7391a78632$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $84f61e7391a78632$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $84f61e7391a78632$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $84f61e7391a78632$var$atEdge = (t)=>t === 0 || t === 1;
const $84f61e7391a78632$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p));
const $84f61e7391a78632$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $84f61e7391a78632$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($84f61e7391a78632$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $84f61e7391a78632$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $84f61e7391a78632$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $84f61e7391a78632$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $84f61e7391a78632$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $84f61e7391a78632$export$db3b6bfb95261072(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value);
}
function $84f61e7391a78632$export$d377dcb2b61d6c4e(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $84f61e7391a78632$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $84f61e7391a78632$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $84f61e7391a78632$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $84f61e7391a78632$var$colors
        },
        numbers: {
            type: 'number',
            properties: $84f61e7391a78632$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $84f61e7391a78632$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $84f61e7391a78632$var$intlCache = new Map();
function $84f61e7391a78632$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $84f61e7391a78632$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $84f61e7391a78632$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $84f61e7391a78632$export$ae1af26003f05816(num, locale, options) {
    return $84f61e7391a78632$var$getNumberFormat(locale, options).format(num);
}
const $84f61e7391a78632$var$formatters = {
    values (value) {
        return $84f61e7391a78632$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $84f61e7391a78632$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $84f61e7391a78632$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $84f61e7391a78632$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $84f61e7391a78632$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $84f61e7391a78632$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $84f61e7391a78632$export$9f4f30ee63539e24 = {
    formatters: $84f61e7391a78632$var$formatters
};
function $84f61e7391a78632$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $84f61e7391a78632$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $84f61e7391a78632$export$6559d589eb85fbb6 = Object.create(null);
const $84f61e7391a78632$export$2e2af4578d910ddf = Object.create(null);
function $84f61e7391a78632$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $84f61e7391a78632$var$set(root, scope, values) {
    if (typeof scope === 'string') return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, scope), values);
    return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, ''), scope);
}
class $84f61e7391a78632$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $84f61e7391a78632$var$set(this, scope, values);
    }
    get(scope) {
        return $84f61e7391a78632$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $84f61e7391a78632$var$getScope$1(this, scope);
        const targetScopeObject = $84f61e7391a78632$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($84f61e7391a78632$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $84f61e7391a78632$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $84f61e7391a78632$export$4368d992c4eafac0 = /* #__PURE__ */ new $84f61e7391a78632$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $84f61e7391a78632$var$applyAnimationsDefaults,
    $84f61e7391a78632$var$applyLayoutsDefaults,
    $84f61e7391a78632$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $84f61e7391a78632$export$e171bab687b50e0(font) {
    if (!font || $84f61e7391a78632$export$342063e11d6c3cad(font.size) || $84f61e7391a78632$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $84f61e7391a78632$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(thing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($84f61e7391a78632$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(nestedThing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $84f61e7391a78632$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $84f61e7391a78632$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $84f61e7391a78632$export$1fbe638ecf81657e(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $84f61e7391a78632$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $84f61e7391a78632$export$56c0d5a1e737357d, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad + $84f61e7391a78632$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $84f61e7391a78632$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $84f61e7391a78632$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $84f61e7391a78632$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $84f61e7391a78632$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $84f61e7391a78632$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $84f61e7391a78632$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $84f61e7391a78632$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $84f61e7391a78632$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $84f61e7391a78632$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $84f61e7391a78632$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $84f61e7391a78632$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $84f61e7391a78632$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $84f61e7391a78632$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $84f61e7391a78632$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $84f61e7391a78632$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($84f61e7391a78632$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $84f61e7391a78632$var$numberOrZero = (v)=>+v || 0;
function $84f61e7391a78632$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $84f61e7391a78632$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $84f61e7391a78632$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$84f61e7391a78632$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $84f61e7391a78632$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$92108d983e8ee699(value) {
    return $84f61e7391a78632$export$ab83b03e4111b1d0(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$9fa96a7d116ea3ce(value) {
    return $84f61e7391a78632$export$ab83b03e4111b1d0(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $84f61e7391a78632$export$a9c23c6ac3fc3eca(value) {
    const obj = $84f61e7391a78632$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $84f61e7391a78632$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $84f61e7391a78632$export$4368d992c4eafac0.font;
    let size = $84f61e7391a78632$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $84f61e7391a78632$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($84f61e7391a78632$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $84f61e7391a78632$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $84f61e7391a78632$export$d29e374196577086($84f61e7391a78632$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $84f61e7391a78632$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $84f61e7391a78632$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $84f61e7391a78632$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $84f61e7391a78632$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $84f61e7391a78632$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $84f61e7391a78632$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $84f61e7391a78632$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $84f61e7391a78632$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$84f61e7391a78632$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $84f61e7391a78632$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $84f61e7391a78632$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$84f61e7391a78632$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$84f61e7391a78632$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $84f61e7391a78632$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $84f61e7391a78632$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $84f61e7391a78632$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $84f61e7391a78632$var$readKey = (prefix, name)=>prefix ? prefix + $84f61e7391a78632$export$a8550f7dbe79f93a(name) : name;
const $84f61e7391a78632$var$needsSubResolver = (prop, value)=>$84f61e7391a78632$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $84f61e7391a78632$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $84f61e7391a78632$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($84f61e7391a78632$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $84f61e7391a78632$var$_resolveScriptable(prop, value, target, receiver);
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(value) && value.length) value = $84f61e7391a78632$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $84f61e7391a78632$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $84f61e7391a78632$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $84f61e7391a78632$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $84f61e7391a78632$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($84f61e7391a78632$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $84f61e7391a78632$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($84f61e7391a78632$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $84f61e7391a78632$var$resolveFallback(fallback, prop, value) {
    return $84f61e7391a78632$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $84f61e7391a78632$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $84f61e7391a78632$export$2d1720544b23b823(parent, key) : undefined;
function $84f61e7391a78632$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $84f61e7391a78632$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $84f61e7391a78632$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $84f61e7391a78632$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $84f61e7391a78632$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $84f61e7391a78632$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$84f61e7391a78632$var$subGetTarget(resolver, prop, value));
}
function $84f61e7391a78632$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $84f61e7391a78632$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $84f61e7391a78632$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(target) && $84f61e7391a78632$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $84f61e7391a78632$var$_resolve($84f61e7391a78632$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $84f61e7391a78632$var$needsSubResolver(prop, value) ? $84f61e7391a78632$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $84f61e7391a78632$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $84f61e7391a78632$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $84f61e7391a78632$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $84f61e7391a78632$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $84f61e7391a78632$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($84f61e7391a78632$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $84f61e7391a78632$var$EPSILON = Number.EPSILON || 1e-14;
const $84f61e7391a78632$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $84f61e7391a78632$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $84f61e7391a78632$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $84f61e7391a78632$export$cf2f7c5792f80b46(current, previous);
    const d12 = $84f61e7391a78632$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($84f61e7391a78632$export$23ebac1979863676(deltaK[i], 0, $84f61e7391a78632$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK);
    $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis);
}
function $84f61e7391a78632$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $84f61e7391a78632$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $84f61e7391a78632$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $84f61e7391a78632$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $84f61e7391a78632$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $84f61e7391a78632$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $84f61e7391a78632$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $84f61e7391a78632$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $84f61e7391a78632$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $84f61e7391a78632$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $84f61e7391a78632$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $84f61e7391a78632$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $84f61e7391a78632$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $84f61e7391a78632$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $84f61e7391a78632$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $84f61e7391a78632$export$fef3dfd9bad05307(el, property) {
    return $84f61e7391a78632$var$getComputedStyle(el).getPropertyValue(property);
}
const $84f61e7391a78632$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $84f61e7391a78632$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $84f61e7391a78632$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $84f61e7391a78632$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $84f61e7391a78632$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($84f61e7391a78632$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $84f61e7391a78632$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
    const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $84f61e7391a78632$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $84f61e7391a78632$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $84f61e7391a78632$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $84f61e7391a78632$var$getComputedStyle(container);
            const containerBorder = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $84f61e7391a78632$export$53c86fa97d611818,
        maxHeight: maxHeight || $84f61e7391a78632$export$53c86fa97d611818
    };
}
const $84f61e7391a78632$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const margins = $84f61e7391a78632$var$getPositionedStyle(style, 'margin');
    const maxWidth = $84f61e7391a78632$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $84f61e7391a78632$export$53c86fa97d611818;
    const maxHeight = $84f61e7391a78632$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $84f61e7391a78632$export$53c86fa97d611818;
    const containerSize = $84f61e7391a78632$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $84f61e7391a78632$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $84f61e7391a78632$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $84f61e7391a78632$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $84f61e7391a78632$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $84f61e7391a78632$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $84f61e7391a78632$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($84f61e7391a78632$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $84f61e7391a78632$export$b4171a6734a65d42(element, property) {
    const value = $84f61e7391a78632$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $84f61e7391a78632$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $84f61e7391a78632$export$d24c54395ce0c509(p1, cp1, t);
    const b = $84f61e7391a78632$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $84f61e7391a78632$export$d24c54395ce0c509(cp2, p2, t);
    const d = $84f61e7391a78632$export$d24c54395ce0c509(a, b, t);
    const e = $84f61e7391a78632$export$d24c54395ce0c509(b, c, t);
    return $84f61e7391a78632$export$d24c54395ce0c509(d, e, t);
}
const $84f61e7391a78632$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $84f61e7391a78632$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $84f61e7391a78632$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $84f61e7391a78632$var$getRightToLeftAdapter(rectX, width) : $84f61e7391a78632$var$getLeftToRightAdapter();
}
function $84f61e7391a78632$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $84f61e7391a78632$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $84f61e7391a78632$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $84f61e7391a78632$export$ffb5f4729a158638,
        compare: $84f61e7391a78632$export$f074adc9fbd50943,
        normalize: $84f61e7391a78632$export$3d12bd131bb975d1
    };
    return {
        between: $84f61e7391a78632$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $84f61e7391a78632$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $84f61e7391a78632$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $84f61e7391a78632$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $84f61e7391a78632$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($84f61e7391a78632$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($84f61e7391a78632$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $84f61e7391a78632$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $84f61e7391a78632$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $84f61e7391a78632$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $84f61e7391a78632$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $84f61e7391a78632$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $84f61e7391a78632$var$splitByStyles(line, $84f61e7391a78632$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $84f61e7391a78632$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $84f61e7391a78632$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $84f61e7391a78632$var$readStyle(segmentOptions.setContext($84f61e7391a78632$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($84f61e7391a78632$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $84f61e7391a78632$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $84f61e7391a78632$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$84f61e7391a78632$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $84f61e7391a78632$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $84f61e7391a78632$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $84f61e7391a78632$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $84f61e7391a78632$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $216d2bdc6f281bf6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $84f61e7391a78632$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $216d2bdc6f281bf6$export$a424a0aa8f687495 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Animator();
const $216d2bdc6f281bf6$var$transparent = 'transparent';
const $216d2bdc6f281bf6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $84f61e7391a78632$export$db3b6bfb95261072)(from || $216d2bdc6f281bf6$var$transparent);
        const c1 = c0.valid && (0, $84f61e7391a78632$export$db3b6bfb95261072)(to || $216d2bdc6f281bf6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $216d2bdc6f281bf6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $216d2bdc6f281bf6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $84f61e7391a78632$export$f1e1789686576879)[cfg.easing] || (0, $84f61e7391a78632$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $216d2bdc6f281bf6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $216d2bdc6f281bf6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $216d2bdc6f281bf6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $216d2bdc6f281bf6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $216d2bdc6f281bf6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $216d2bdc6f281bf6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $216d2bdc6f281bf6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $216d2bdc6f281bf6$var$scaleClip(xScale, allowedOverflow);
    const y = $216d2bdc6f281bf6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $216d2bdc6f281bf6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $216d2bdc6f281bf6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) === (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $216d2bdc6f281bf6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $216d2bdc6f281bf6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $216d2bdc6f281bf6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $216d2bdc6f281bf6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $216d2bdc6f281bf6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $216d2bdc6f281bf6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $216d2bdc6f281bf6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $216d2bdc6f281bf6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $216d2bdc6f281bf6$var$createDatasetContext(parent, index) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $216d2bdc6f281bf6$var$createDataContext(parent, index, element) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $216d2bdc6f281bf6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $216d2bdc6f281bf6$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $216d2bdc6f281bf6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $216d2bdc6f281bf6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $216d2bdc6f281bf6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.xAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.yAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.rAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $84f61e7391a78632$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $84f61e7391a78632$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $216d2bdc6f281bf6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $84f61e7391a78632$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $216d2bdc6f281bf6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $216d2bdc6f281bf6$var$updateStacks(this, meta._parsed);
            meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $216d2bdc6f281bf6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $216d2bdc6f281bf6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $216d2bdc6f281bf6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $216d2bdc6f281bf6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $216d2bdc6f281bf6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $84f61e7391a78632$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $216d2bdc6f281bf6$var$toClip((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.options.clip, $216d2bdc6f281bf6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $216d2bdc6f281bf6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $216d2bdc6f281bf6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(index);
        if (cached) return $216d2bdc6f281bf6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($216d2bdc6f281bf6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $216d2bdc6f281bf6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $216d2bdc6f281bf6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $216d2bdc6f281bf6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $216d2bdc6f281bf6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i) {
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(entry)) $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $216d2bdc6f281bf6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $216d2bdc6f281bf6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $216d2bdc6f281bf6$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$216d2bdc6f281bf6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$216d2bdc6f281bf6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $216d2bdc6f281bf6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $216d2bdc6f281bf6$var$swap(edge, a, b);
        edge = $216d2bdc6f281bf6$var$startEnd(edge, b, a);
    } else edge = $216d2bdc6f281bf6$var$startEnd(edge, a, b);
    return edge;
}
function $216d2bdc6f281bf6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $216d2bdc6f281bf6$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $216d2bdc6f281bf6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $216d2bdc6f281bf6$export$e97d5dc64e999004 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($216d2bdc6f281bf6$var$parseValue((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $216d2bdc6f281bf6$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $216d2bdc6f281bf6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index);
            $216d2bdc6f281bf6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $216d2bdc6f281bf6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $216d2bdc6f281bf6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) !== (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $216d2bdc6f281bf6$export$19b5c4773f17abe extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $84f61e7391a78632$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $84f61e7391a78632$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d) + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $216d2bdc6f281bf6$export$e04603e7d8b77172 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $84f61e7391a78632$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $84f61e7391a78632$export$971d5caa766a69d7);
        let max = -(0, $84f61e7391a78632$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $84f61e7391a78632$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $84f61e7391a78632$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $84f61e7391a78632$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $216d2bdc6f281bf6$export$2a270b3a0d973c85 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $84f61e7391a78632$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $216d2bdc6f281bf6$export$b21a3f1286706191 extends $216d2bdc6f281bf6$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $216d2bdc6f281bf6$export$48dbc6ac651bf8be extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $216d2bdc6f281bf6$export$b2f2bae6713db87 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $216d2bdc6f281bf6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $216d2bdc6f281bf6$export$e97d5dc64e999004,
    BubbleController: $216d2bdc6f281bf6$export$19b5c4773f17abe,
    DoughnutController: $216d2bdc6f281bf6$export$e04603e7d8b77172,
    LineController: $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0,
    PieController: $216d2bdc6f281bf6$export$b21a3f1286706191,
    PolarAreaController: $216d2bdc6f281bf6$export$2a270b3a0d973c85,
    RadarController: $216d2bdc6f281bf6$export$48dbc6ac651bf8be,
    ScatterController: $216d2bdc6f281bf6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $216d2bdc6f281bf6$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $216d2bdc6f281bf6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($216d2bdc6f281bf6$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    parse() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    format() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    add() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    diff() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    startOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    endOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
}
var $216d2bdc6f281bf6$export$f32766ea09ec8bc4 = {
    _date: $216d2bdc6f281bf6$var$DateAdapterBase
};
function $216d2bdc6f281bf6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $84f61e7391a78632$export$ebd11618f299a286) : (0, $84f61e7391a78632$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $216d2bdc6f281bf6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $84f61e7391a78632$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $216d2bdc6f281bf6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $216d2bdc6f281bf6$export$a13296960cae0384 = {
    evaluateInteractionItems: $216d2bdc6f281bf6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $216d2bdc6f281bf6$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $216d2bdc6f281bf6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$216d2bdc6f281bf6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $216d2bdc6f281bf6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $216d2bdc6f281bf6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $216d2bdc6f281bf6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$216d2bdc6f281bf6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$setLayoutDims(layouts, params) {
    const stacks = $216d2bdc6f281bf6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $216d2bdc6f281bf6$var$wrapBoxes(boxes);
    const fullSize = $216d2bdc6f281bf6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'right'));
    const top = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $216d2bdc6f281bf6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $216d2bdc6f281bf6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $216d2bdc6f281bf6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $216d2bdc6f281bf6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $216d2bdc6f281bf6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $216d2bdc6f281bf6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $216d2bdc6f281bf6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $216d2bdc6f281bf6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $216d2bdc6f281bf6$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $216d2bdc6f281bf6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $216d2bdc6f281bf6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $84f61e7391a78632$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $216d2bdc6f281bf6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $216d2bdc6f281bf6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($216d2bdc6f281bf6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$handleMaxPadding(chartArea);
        $216d2bdc6f281bf6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $216d2bdc6f281bf6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $216d2bdc6f281bf6$export$a40a96b24b46cf35 extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $216d2bdc6f281bf6$var$EXPANDO_KEY = '$chartjs';
const $216d2bdc6f281bf6$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $216d2bdc6f281bf6$var$isNullOrEmpty = (value)=>value === null || value === '';
function $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $216d2bdc6f281bf6$var$eventListenerOptions = (0, $84f61e7391a78632$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $216d2bdc6f281bf6$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$fromNativeEvent(event, chart) {
    const type = $216d2bdc6f281bf6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $84f61e7391a78632$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $216d2bdc6f281bf6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $216d2bdc6f281bf6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $216d2bdc6f281bf6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $216d2bdc6f281bf6$var$drpListeningCharts = new Map();
let $216d2bdc6f281bf6$var$oldDevicePixelRatio = 0;
function $216d2bdc6f281bf6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $216d2bdc6f281bf6$var$oldDevicePixelRatio) return;
    $216d2bdc6f281bf6$var$oldDevicePixelRatio = dpr;
    $216d2bdc6f281bf6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.addEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
    $216d2bdc6f281bf6$var$drpListeningCharts.set(chart, resize);
}
function $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart) {
    $216d2bdc6f281bf6$var$drpListeningCharts.delete(chart);
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.removeEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
}
function $216d2bdc6f281bf6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $84f61e7391a78632$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $216d2bdc6f281bf6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart);
}
function $216d2bdc6f281bf6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $84f61e7391a78632$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($216d2bdc6f281bf6$var$fromNativeEvent(event, chart));
    }, chart);
    $216d2bdc6f281bf6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $216d2bdc6f281bf6$export$f02da7f882cf6b2e extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $216d2bdc6f281bf6$var$createAttachObserver,
            detach: $216d2bdc6f281bf6$var$createDetachObserver,
            resize: $216d2bdc6f281bf6$var$createResizeObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $216d2bdc6f281bf6$var$releaseObserver,
            detach: $216d2bdc6f281bf6$var$releaseObserver,
            resize: $216d2bdc6f281bf6$var$releaseObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $84f61e7391a78632$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $216d2bdc6f281bf6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $216d2bdc6f281bf6$export$a40a96b24b46cf35;
    return $216d2bdc6f281bf6$export$f02da7f882cf6b2e;
}
class $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.x) && (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $216d2bdc6f281bf6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $216d2bdc6f281bf6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $216d2bdc6f281bf6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, last, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $216d2bdc6f281bf6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $216d2bdc6f281bf6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $84f61e7391a78632$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $216d2bdc6f281bf6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $84f61e7391a78632$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $84f61e7391a78632$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $216d2bdc6f281bf6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $216d2bdc6f281bf6$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $216d2bdc6f281bf6$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $216d2bdc6f281bf6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $216d2bdc6f281bf6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $216d2bdc6f281bf6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $216d2bdc6f281bf6$var$garbageCollect(caches, length) {
    (0, $84f61e7391a78632$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $216d2bdc6f281bf6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $216d2bdc6f281bf6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $84f61e7391a78632$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $216d2bdc6f281bf6$var$createScaleContext(parent, scale) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $216d2bdc6f281bf6$var$createTickContext(parent, index, tick) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $216d2bdc6f281bf6$var$titleAlign(align, position, reverse) {
    let ret = (0, $84f61e7391a78632$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $216d2bdc6f281bf6$var$reverseAlign(ret);
    return ret;
}
function $216d2bdc6f281bf6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) : (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $216d2bdc6f281bf6$export$d60cfc58d3c358b6 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, min)),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $84f61e7391a78632$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $216d2bdc6f281bf6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $216d2bdc6f281bf6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $216d2bdc6f281bf6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $84f61e7391a78632$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $216d2bdc6f281bf6$var$getTickMarkLength(options.grid) - tickOpts.padding - $216d2bdc6f281bf6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $216d2bdc6f281bf6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $216d2bdc6f281bf6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $216d2bdc6f281bf6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(label) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) {
                width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(nestedLabel) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $216d2bdc6f281bf6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $84f61e7391a78632$export$71cec2538cb2c617)(this._alignToPixels ? (0, $84f61e7391a78632$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $216d2bdc6f281bf6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $216d2bdc6f281bf6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $84f61e7391a78632$export$34aec0b863436764)(title.font);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $216d2bdc6f281bf6$var$titleArgs(this, offset, position, align);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $216d2bdc6f281bf6$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $216d2bdc6f281bf6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $216d2bdc6f281bf6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($216d2bdc6f281bf6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $84f61e7391a78632$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope]) {
            delete (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $84f61e7391a78632$export$6559d589eb85fbb6)[id];
        }
    }
}
function $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $84f61e7391a78632$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $84f61e7391a78632$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $84f61e7391a78632$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $84f61e7391a78632$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $216d2bdc6f281bf6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $84f61e7391a78632$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $216d2bdc6f281bf6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $84f61e7391a78632$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $216d2bdc6f281bf6$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $216d2bdc6f281bf6$var$Registry {
    constructor(){
        this.controllers = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $216d2bdc6f281bf6$var$TypedRegistry(Object, 'plugins');
        this.scales = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $84f61e7391a78632$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $84f61e7391a78632$export$a8550f7dbe79f93a)(method);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $216d2bdc6f281bf6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Registry();
class $216d2bdc6f281bf6$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $84f61e7391a78632$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $84f61e7391a78632$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $216d2bdc6f281bf6$var$allPlugins(config);
        return options === false && !all ? [] : $216d2bdc6f281bf6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $216d2bdc6f281bf6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($216d2bdc6f281bf6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($216d2bdc6f281bf6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $216d2bdc6f281bf6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $216d2bdc6f281bf6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $216d2bdc6f281bf6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $216d2bdc6f281bf6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $216d2bdc6f281bf6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $216d2bdc6f281bf6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $216d2bdc6f281bf6$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $216d2bdc6f281bf6$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $216d2bdc6f281bf6$var$determineAxis(id, ...scaleOptions) {
    if ($216d2bdc6f281bf6$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $216d2bdc6f281bf6$var$axisFromPosition(opts.position) || id.length > 1 && $216d2bdc6f281bf6$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $216d2bdc6f281bf6$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'x', boundDs[0]) || $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $216d2bdc6f281bf6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $216d2bdc6f281bf6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleConf, $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config), (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $84f61e7391a78632$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $84f61e7391a78632$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $84f61e7391a78632$export$555508cbc6add439)(scale, [
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scale.type],
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $216d2bdc6f281bf6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $216d2bdc6f281bf6$var$mergeScaleConfig(config, options);
}
function $216d2bdc6f281bf6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $216d2bdc6f281bf6$var$initConfig(config) {
    config = config || {};
    config.data = $216d2bdc6f281bf6$var$initData(config.data);
    $216d2bdc6f281bf6$var$initOptions(config);
    return config;
}
const $216d2bdc6f281bf6$var$keyCache = new Map();
const $216d2bdc6f281bf6$var$keysCached = new Set();
function $216d2bdc6f281bf6$var$cachedKeys(cacheKey, generate) {
    let keys = $216d2bdc6f281bf6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $216d2bdc6f281bf6$var$keyCache.set(cacheKey, keys);
        $216d2bdc6f281bf6$var$keysCached.add(keys);
    }
    return keys;
}
const $216d2bdc6f281bf6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $84f61e7391a78632$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $216d2bdc6f281bf6$var$Config {
    constructor(config){
        this._config = $216d2bdc6f281bf6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $216d2bdc6f281bf6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $216d2bdc6f281bf6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $216d2bdc6f281bf6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $216d2bdc6f281bf6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($216d2bdc6f281bf6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {},
            (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $84f61e7391a78632$export$4368d992c4eafac0),
            (0, $84f61e7391a78632$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($216d2bdc6f281bf6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $84f61e7391a78632$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $84f61e7391a78632$export$23f2a1d2818174ef)(context) ? (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $216d2bdc6f281bf6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $84f61e7391a78632$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $216d2bdc6f281bf6$var$hasFunction = (value)=>(0, $84f61e7391a78632$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $84f61e7391a78632$export$a93c5207d687da10)(value[key]));
function $216d2bdc6f281bf6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $84f61e7391a78632$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $84f61e7391a78632$export$a93c5207d687da10)(value) || $216d2bdc6f281bf6$var$hasFunction(value)) || indexable && (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $216d2bdc6f281bf6$var$version = "4.4.9";
const $216d2bdc6f281bf6$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $216d2bdc6f281bf6$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $216d2bdc6f281bf6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $216d2bdc6f281bf6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $216d2bdc6f281bf6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$getCanvas(item) {
    if ((0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $216d2bdc6f281bf6$var$instances = {};
const $216d2bdc6f281bf6$var$getChart = (key)=>{
    const canvas = $216d2bdc6f281bf6$var$getCanvas(key);
    return Object.values($216d2bdc6f281bf6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $216d2bdc6f281bf6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $216d2bdc6f281bf6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $216d2bdc6f281bf6$export$acaa6426d77a227e {
    static defaults = (0, $84f61e7391a78632$export$4368d992c4eafac0);
    static instances = $216d2bdc6f281bf6$var$instances;
    static overrides = (0, $84f61e7391a78632$export$6559d589eb85fbb6);
    static registry = $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    static version = $216d2bdc6f281bf6$var$version;
    static getChart = $216d2bdc6f281bf6$var$getChart;
    static register(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.add(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.remove(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $216d2bdc6f281bf6$var$Config(userConfig);
        const initialCanvas = $216d2bdc6f281bf6$var$getCanvas(item);
        const existingChart = $216d2bdc6f281bf6$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $216d2bdc6f281bf6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $84f61e7391a78632$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $216d2bdc6f281bf6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $84f61e7391a78632$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $216d2bdc6f281bf6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'complete', $216d2bdc6f281bf6$var$onAnimationsComplete);
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'progress', $216d2bdc6f281bf6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $84f61e7391a78632$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $216d2bdc6f281bf6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $84f61e7391a78632$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $84f61e7391a78632$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $84f61e7391a78632$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $84f61e7391a78632$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $216d2bdc6f281bf6$var$positionIsHorizontal(scaleOptions.position, axis) !== $216d2bdc6f281bf6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($216d2bdc6f281bf6$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $84f61e7391a78632$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($216d2bdc6f281bf6$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $216d2bdc6f281bf6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $84f61e7391a78632$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($216d2bdc6f281bf6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) $216d2bdc6f281bf6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $216d2bdc6f281bf6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $84f61e7391a78632$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $216d2bdc6f281bf6$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $84f61e7391a78632$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $216d2bdc6f281bf6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $216d2bdc6f281bf6$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $84f61e7391a78632$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $84f61e7391a78632$export$3b513254972cfc9c)(e);
        const lastEvent = $216d2bdc6f281bf6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $216d2bdc6f281bf6$var$invalidatePlugins() {
    return (0, $84f61e7391a78632$export$d66501df72047452)($216d2bdc6f281bf6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$toRadiusCorners(value) {
    return (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $216d2bdc6f281bf6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $216d2bdc6f281bf6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $84f61e7391a78632$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $216d2bdc6f281bf6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $84f61e7391a78632$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $216d2bdc6f281bf6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $216d2bdc6f281bf6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $216d2bdc6f281bf6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    if (inner) $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $216d2bdc6f281bf6$export$d48203c759d6a1fc extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $84f61e7391a78632$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $84f61e7391a78632$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $84f61e7391a78632$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $84f61e7391a78632$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $84f61e7391a78632$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $216d2bdc6f281bf6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $216d2bdc6f281bf6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $216d2bdc6f281bf6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $216d2bdc6f281bf6$var$getLineMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$493d36ec626b6698;
    return $216d2bdc6f281bf6$var$lineTo;
}
function $216d2bdc6f281bf6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $216d2bdc6f281bf6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const lineMethod = $216d2bdc6f281bf6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $216d2bdc6f281bf6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $216d2bdc6f281bf6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $216d2bdc6f281bf6$var$fastPathSegment : $216d2bdc6f281bf6$var$pathSegment;
}
function $216d2bdc6f281bf6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$8a5498727ef6be21;
    return 0, $84f61e7391a78632$export$d24c54395ce0c509;
}
function $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $216d2bdc6f281bf6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $216d2bdc6f281bf6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $216d2bdc6f281bf6$var$usePath2D = typeof Path2D === 'function';
function $216d2bdc6f281bf6$var$draw(ctx, line, start, count) {
    if ($216d2bdc6f281bf6$var$usePath2D && !line.options.segment) $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count);
    else $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count);
}
class $216d2bdc6f281bf6$export$55e463fa7bcd3469 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $84f61e7391a78632$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $84f61e7391a78632$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $84f61e7391a78632$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $216d2bdc6f281bf6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $216d2bdc6f281bf6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $216d2bdc6f281bf6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $216d2bdc6f281bf6$export$bd159b522b230b7a extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $84f61e7391a78632$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $84f61e7391a78632$export$25ce5a424b770e84)(value, min, max);
}
function $216d2bdc6f281bf6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $84f61e7391a78632$export$92108d983e8ee699)(value);
    return {
        t: $216d2bdc6f281bf6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $216d2bdc6f281bf6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $216d2bdc6f281bf6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $216d2bdc6f281bf6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $216d2bdc6f281bf6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $216d2bdc6f281bf6$var$boundingRects(bar) {
    const bounds = $216d2bdc6f281bf6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $216d2bdc6f281bf6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $216d2bdc6f281bf6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $216d2bdc6f281bf6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $84f61e7391a78632$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $84f61e7391a78632$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $216d2bdc6f281bf6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $216d2bdc6f281bf6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $216d2bdc6f281bf6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $216d2bdc6f281bf6$export$a16ed71bf4b07672 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $216d2bdc6f281bf6$var$boundingRects(this);
        const addRectPath = $216d2bdc6f281bf6$var$hasRadius(outer.radius) ? (0, $84f61e7391a78632$export$d66dc83d8cfc8dd) : $216d2bdc6f281bf6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $216d2bdc6f281bf6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $216d2bdc6f281bf6$export$d48203c759d6a1fc,
    BarElement: $216d2bdc6f281bf6$export$a16ed71bf4b07672,
    LineElement: $216d2bdc6f281bf6$export$55e463fa7bcd3469,
    PointElement: $216d2bdc6f281bf6$export$bd159b522b230b7a
});
const $216d2bdc6f281bf6$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $216d2bdc6f281bf6$var$BACKGROUND_COLORS = /* #__PURE__ */ $216d2bdc6f281bf6$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $216d2bdc6f281bf6$var$getBorderColor(i) {
    return $216d2bdc6f281bf6$var$BORDER_COLORS[i % $216d2bdc6f281bf6$var$BORDER_COLORS.length];
}
function $216d2bdc6f281bf6$var$getBackgroundColor(i) {
    return $216d2bdc6f281bf6$var$BACKGROUND_COLORS[i % $216d2bdc6f281bf6$var$BACKGROUND_COLORS.length];
}
function $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $216d2bdc6f281bf6$var$getBorderColor(i);
    dataset.backgroundColor = $216d2bdc6f281bf6$var$getBackgroundColor(i);
    return ++i;
}
function $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBorderColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBackgroundColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $216d2bdc6f281bf6$export$e04603e7d8b77172) i = $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $216d2bdc6f281bf6$export$2a270b3a0d973c85) i = $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $216d2bdc6f281bf6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $216d2bdc6f281bf6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions() {
    return (0, $84f61e7391a78632$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $84f61e7391a78632$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $216d2bdc6f281bf6$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $216d2bdc6f281bf6$var$containsColorsDefinitions(datasets) || $216d2bdc6f281bf6$var$containsColorsDefinition(chartOptions) || elements && $216d2bdc6f281bf6$var$containsColorsDefinitions(elements) || $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $216d2bdc6f281bf6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(minIndex) && !(0, $84f61e7391a78632$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $216d2bdc6f281bf6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
    });
}
function $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $216d2bdc6f281bf6$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $84f61e7391a78632$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
    }
};
function $216d2bdc6f281bf6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points);
        const bounds = $216d2bdc6f281bf6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $84f61e7391a78632$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $216d2bdc6f281bf6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $84f61e7391a78632$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $216d2bdc6f281bf6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(start);
        end = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $216d2bdc6f281bf6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $216d2bdc6f281bf6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $216d2bdc6f281bf6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $216d2bdc6f281bf6$var$_decodeFill(line, index, count) {
    const fill = $216d2bdc6f281bf6$var$parseFillOption(line);
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $216d2bdc6f281bf6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $216d2bdc6f281bf6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $216d2bdc6f281bf6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $84f61e7391a78632$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $216d2bdc6f281bf6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $216d2bdc6f281bf6$var$getLinesBelow(scale, index);
    linesBelow.push($216d2bdc6f281bf6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $216d2bdc6f281bf6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $216d2bdc6f281bf6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $84f61e7391a78632$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $216d2bdc6f281bf6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return $216d2bdc6f281bf6$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $216d2bdc6f281bf6$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $216d2bdc6f281bf6$var$computeBoundary(source);
    if (boundary instanceof $216d2bdc6f281bf6$var$simpleArc) return boundary;
    return $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line);
}
function $216d2bdc6f281bf6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $216d2bdc6f281bf6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $216d2bdc6f281bf6$var$computeCircularBoundary(source);
    return $216d2bdc6f281bf6$var$computeLinearBoundary(source);
}
function $216d2bdc6f281bf6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $216d2bdc6f281bf6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $216d2bdc6f281bf6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $216d2bdc6f281bf6$var$_drawfill(ctx, source, area) {
    const target = $216d2bdc6f281bf6$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        $216d2bdc6f281bf6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $216d2bdc6f281bf6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.top);
        $216d2bdc6f281bf6$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property,
            clip: clip
        });
        ctx.restore();
        ctx.save();
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.bottom);
    }
    $216d2bdc6f281bf6$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $216d2bdc6f281bf6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $216d2bdc6f281bf6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, notShape && $216d2bdc6f281bf6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $216d2bdc6f281bf6$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $216d2bdc6f281bf6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $216d2bdc6f281bf6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $216d2bdc6f281bf6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($216d2bdc6f281bf6$var$_shouldApplyFill(source)) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$216d2bdc6f281bf6$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $216d2bdc6f281bf6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $216d2bdc6f281bf6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $216d2bdc6f281bf6$var$Legend extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $84f61e7391a78632$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $84f61e7391a78632$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $84f61e7391a78632$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $84f61e7391a78632$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $84f61e7391a78632$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $84f61e7391a78632$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, this.left, this.right) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$216d2bdc6f281bf6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $216d2bdc6f281bf6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $216d2bdc6f281bf6$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $216d2bdc6f281bf6$export$ed247974535929c7 = {
    id: 'legend',
    _element: $216d2bdc6f281bf6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $216d2bdc6f281bf6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $216d2bdc6f281bf6$var$Title extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $84f61e7391a78632$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $216d2bdc6f281bf6$var$createTitle(chart, titleOpts) {
    const title = new $216d2bdc6f281bf6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $216d2bdc6f281bf6$export$f99233281efd08a0 = {
    id: 'title',
    _element: $216d2bdc6f281bf6$var$Title,
    start (chart, _args, options) {
        $216d2bdc6f281bf6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$map = new WeakMap();
var $216d2bdc6f281bf6$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $216d2bdc6f281bf6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
        $216d2bdc6f281bf6$var$map.set(chart, title);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, $216d2bdc6f281bf6$var$map.get(chart));
        $216d2bdc6f281bf6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $216d2bdc6f281bf6$var$map.get(chart);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $216d2bdc6f281bf6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $216d2bdc6f281bf6$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $216d2bdc6f281bf6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $216d2bdc6f281bf6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $84f61e7391a78632$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $216d2bdc6f281bf6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $216d2bdc6f281bf6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $216d2bdc6f281bf6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $216d2bdc6f281bf6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $216d2bdc6f281bf6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $216d2bdc6f281bf6$var$alignX(size, xAlign);
    const y = $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $84f61e7391a78632$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $84f61e7391a78632$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $216d2bdc6f281bf6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $216d2bdc6f281bf6$var$getBeforeAfterBodyLines(callback) {
    return $216d2bdc6f281bf6$var$pushOrConcat([], $216d2bdc6f281bf6$var$splitNewlines(callback));
}
function $216d2bdc6f281bf6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $216d2bdc6f281bf6$var$defaultCallbacks = {
    beforeTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    footer: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346)
};
function $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $216d2bdc6f281bf6$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $216d2bdc6f281bf6$var$Tooltip extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static positioners = $216d2bdc6f281bf6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeTitle));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(title));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context);
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.before, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.lines, $216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.after, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeFooter));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(footer));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($216d2bdc6f281bf6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        const colorX = $216d2bdc6f281bf6$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $84f61e7391a78632$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(chart, options, positionAndSize);
            const point = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $84f61e7391a78632$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $84f61e7391a78632$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $216d2bdc6f281bf6$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $216d2bdc6f281bf6$var$Tooltip,
    positioners: $216d2bdc6f281bf6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $216d2bdc6f281bf6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $216d2bdc6f281bf6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $216d2bdc6f281bf6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $216d2bdc6f281bf6$export$c537fa0d021d010b,
    Decimation: $216d2bdc6f281bf6$export$be17f937e9aa7533,
    Filler: $216d2bdc6f281bf6$export$d19ba4d812bed757,
    Legend: $216d2bdc6f281bf6$export$ed247974535929c7,
    SubTitle: $216d2bdc6f281bf6$export$d5c56664638992a4,
    Title: $216d2bdc6f281bf6$export$f99233281efd08a0,
    Tooltip: $216d2bdc6f281bf6$export$28c660c63b792dea
});
const $216d2bdc6f281bf6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $216d2bdc6f281bf6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $216d2bdc6f281bf6$var$validIndex = (index, max)=>index === null ? null : (0, $84f61e7391a78632$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $216d2bdc6f281bf6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $216d2bdc6f281bf6$export$29e663ba4d09fe7 extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $216d2bdc6f281bf6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, (0, $84f61e7391a78632$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $216d2bdc6f281bf6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $216d2bdc6f281bf6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $216d2bdc6f281bf6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $84f61e7391a78632$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $84f61e7391a78632$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $84f61e7391a78632$export$91477dc880baac21)(spacing), (0, $84f61e7391a78632$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $84f61e7391a78632$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $84f61e7391a78632$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $216d2bdc6f281bf6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $84f61e7391a78632$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $216d2bdc6f281bf6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $216d2bdc6f281bf6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $84f61e7391a78632$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $216d2bdc6f281bf6$var$LinearScaleBase extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $216d2bdc6f281bf6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $216d2bdc6f281bf6$export$e7f4e5e8656f0b93 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $216d2bdc6f281bf6$var$log10Floor = (v)=>Math.floor((0, $84f61e7391a78632$export$faec65b429be379)(v));
const $216d2bdc6f281bf6$var$changeExponent = (v, m)=>Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(v) + m);
function $216d2bdc6f281bf6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(tickVal));
    return remain === 1;
}
function $216d2bdc6f281bf6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $216d2bdc6f281bf6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $216d2bdc6f281bf6$var$log10Floor(range);
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $216d2bdc6f281bf6$var$log10Floor(min));
}
function $216d2bdc6f281bf6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $216d2bdc6f281bf6$var$log10Floor(min);
    let exp = $216d2bdc6f281bf6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $216d2bdc6f281bf6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $216d2bdc6f281bf6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $216d2bdc6f281bf6$export$85295eaf7cb3ac3e extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $216d2bdc6f281bf6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $84f61e7391a78632$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $84f61e7391a78632$export$39b482c5e57630a8)(this._userMin)) this.min = min === $216d2bdc6f281bf6$var$changeExponent(this.min, 0) ? $216d2bdc6f281bf6$var$changeExponent(this.min, -1) : $216d2bdc6f281bf6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($216d2bdc6f281bf6$var$changeExponent(min, -1));
                setMax($216d2bdc6f281bf6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($216d2bdc6f281bf6$var$changeExponent(max, -1));
        if (max <= 0) setMax($216d2bdc6f281bf6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $216d2bdc6f281bf6$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $84f61e7391a78632$export$faec65b429be379)(start);
        this._valueRange = (0, $84f61e7391a78632$export$faec65b429be379)(this.max) - (0, $84f61e7391a78632$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $84f61e7391a78632$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $84f61e7391a78632$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $84f61e7391a78632$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $216d2bdc6f281bf6$var$measureLabelSize(ctx, font, label) {
    label = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $84f61e7391a78632$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $216d2bdc6f281bf6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $216d2bdc6f281bf6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const textSize = $216d2bdc6f281bf6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $216d2bdc6f281bf6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $216d2bdc6f281bf6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $216d2bdc6f281bf6$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)((0, $84f61e7391a78632$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd))));
    const y = $216d2bdc6f281bf6$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $216d2bdc6f281bf6$var$getTextAlignForAngle(angle);
    const left = $216d2bdc6f281bf6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $216d2bdc6f281bf6$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $216d2bdc6f281bf6$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $216d2bdc6f281bf6$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $216d2bdc6f281bf6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $216d2bdc6f281bf6$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $216d2bdc6f281bf6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(opts.borderRadius);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $216d2bdc6f281bf6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $84f61e7391a78632$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $216d2bdc6f281bf6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $216d2bdc6f281bf6$var$createPointLabelContext(parent, index, label) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $216d2bdc6f281bf6$export$cfafc36d95386d38 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)($216d2bdc6f281bf6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $216d2bdc6f281bf6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $216d2bdc6f281bf6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $216d2bdc6f281bf6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $84f61e7391a78632$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $84f61e7391a78632$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $84f61e7391a78632$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $216d2bdc6f281bf6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $216d2bdc6f281bf6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $216d2bdc6f281bf6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $216d2bdc6f281bf6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $216d2bdc6f281bf6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $216d2bdc6f281bf6$var$UNITS = /* #__PURE__ */ Object.keys($216d2bdc6f281bf6$var$INTERVALS);
function $216d2bdc6f281bf6$var$sorter(a, b) {
    return a - b;
}
function $216d2bdc6f281bf6$var$parse(scale, input) {
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $84f61e7391a78632$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $216d2bdc6f281bf6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $216d2bdc6f281bf6$var$UNITS.length;
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $216d2bdc6f281bf6$var$UNITS[i];
    }
    return $216d2bdc6f281bf6$var$UNITS[ilen - 1];
}
function $216d2bdc6f281bf6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.length - 1; i >= $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i--){
        const unit = $216d2bdc6f281bf6$var$UNITS[i];
        if ($216d2bdc6f281bf6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $216d2bdc6f281bf6$var$UNITS[minUnit ? $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit) : 0];
}
function $216d2bdc6f281bf6$var$determineMajorUnit(unit) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(unit) + 1, ilen = $216d2bdc6f281bf6$var$UNITS.length; i < ilen; ++i){
        if ($216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]].common) return $216d2bdc6f281bf6$var$UNITS[i];
    }
}
function $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $84f61e7391a78632$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $216d2bdc6f281bf6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $216d2bdc6f281bf6$export$a894c72689ff3ec extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $216d2bdc6f281bf6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $84f61e7391a78632$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $216d2bdc6f281bf6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $84f61e7391a78632$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $216d2bdc6f281bf6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $216d2bdc6f281bf6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $216d2bdc6f281bf6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $84f61e7391a78632$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $84f61e7391a78632$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($216d2bdc6f281bf6$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $216d2bdc6f281bf6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($216d2bdc6f281bf6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort($216d2bdc6f281bf6$var$sorter));
    }
}
function $216d2bdc6f281bf6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $216d2bdc6f281bf6$export$85df64a8eb6dc986 extends $216d2bdc6f281bf6$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $216d2bdc6f281bf6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $216d2bdc6f281bf6$var$interpolate(table, this.min);
        this._tableRange = $216d2bdc6f281bf6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($216d2bdc6f281bf6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $216d2bdc6f281bf6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $216d2bdc6f281bf6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $216d2bdc6f281bf6$export$29e663ba4d09fe7,
    LinearScale: $216d2bdc6f281bf6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $216d2bdc6f281bf6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $216d2bdc6f281bf6$export$cfafc36d95386d38,
    TimeScale: $216d2bdc6f281bf6$export$a894c72689ff3ec,
    TimeSeriesScale: $216d2bdc6f281bf6$export$85df64a8eb6dc986
});
const $216d2bdc6f281bf6$export$e8959e79e3af550f = [
    $216d2bdc6f281bf6$export$a6506504f799c5d5,
    $216d2bdc6f281bf6$export$7a5d735b2ab6389d,
    $216d2bdc6f281bf6$export$8b3ca321c77fdea6,
    $216d2bdc6f281bf6$export$bcac1c16f1530ec2
];


(0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register(...(0, $216d2bdc6f281bf6$export$e8959e79e3af550f));
var $e24bb3f4f01060dd$export$2e2bcd8739ae039 = (0, $216d2bdc6f281bf6$export$acaa6426d77a227e);


/*! For license information please see embetty.js.LICENSE.txt */ (()=>{
    "use strict";
    var t = {
        710: (t, e, A)=>{
            A.d(e, {
                A: ()=>a
            });
            var i = A(499), o = A.n(i), n = A(33), r = A.n(n)()(o());
            r.push([
                t.id,
                ':host{position:relative;overflow:hidden;display:block;width:100%;font-family:var(--embetty-font-family, Helvetica, Roboto, "Segoe UI", Calibri, sans-serif);border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;box-sizing:border-box;font-size:16px;line-height:1}#powered-by{position:absolute;z-index:3;right:-20px;bottom:0px;padding:20px 46px 5px 20px;font-size:14px;color:#777;text-decoration:none;opacity:.3}#powered-by:hover{opacity:1}#powered-by svg{position:absolute;right:10px;bottom:0;width:40px}:host{width:100%;position:relative;background-color:#333}:host #poster{position:relative;overflow:hidden}:host #poster::before{content:"";display:block;padding-top:56.25%}:host #poster img{position:absolute;top:0;bottom:0;left:0;height:100%;width:100%}:host #playbutton{box-sizing:border-box;display:block;position:absolute;z-index:1;width:100%;height:100%;border:0;opacity:.9;background:none;cursor:pointer;transition:opacity 150ms}:host .video-playbutton{min-width:3.75rem;width:13%;max-width:6rem;transition:transform 300ms ease-out;will-change:transform}:host .video-playbutton:hover{transform:scale(1.07)}:host #playicon{width:100px;height:100px}:host .wrapper{position:relative;padding-bottom:56.25%;padding-top:0px;height:0;overflow:hidden}:host iframe{position:absolute;top:0;left:0;width:100%;height:100%}:host #powered-by{-webkit-font-smoothing:antialiased;color:#fff;opacity:.6}:host #powered-by:hover{opacity:1}',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://./src/_element.scss",
                        "webpack://./src/embed/_powered-by.scss",
                        "webpack://./src/embed/_video.scss"
                    ],
                    names: [],
                    mappings: "AAEA,MACE,iBAAA,CACA,eAAA,CACA,aAAA,CACA,UAAA,CACA,0FAAA,CACA,kDAAA,CACA,gBAAA,CACA,iBAAA,CACA,qBAAA,CACA,cAAA,CACA,aAAA,CCbF,YACE,iBAAA,CACA,SAAA,CACA,WAAA,CACA,UAAA,CACA,0BAAA,CACA,cAAA,CACA,UAAA,CACA,oBAAA,CACA,UAAA,CAEA,kBACE,SAAA,CAGF,gBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,UAAA,CChBJ,MACE,UAAA,CACA,iBAAA,CACA,qBAAA,CAEA,cACE,iBAAA,CACA,eAAA,CAEA,sBACE,UAAA,CACA,aAAA,CACA,kBAAA,CAGF,kBACE,iBAAA,CACA,KAAA,CACA,QAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CAIJ,kBACE,qBAAA,CACA,aAAA,CACA,iBAAA,CACA,SAAA,CACA,UAAA,CACA,WAAA,CACA,QAAA,CACA,UAAA,CACA,eAAA,CACA,cAAA,CACA,wBAAA,CAGF,wBACE,iBAAA,CACA,SAAA,CACA,cAAA,CACA,mCAAA,CACA,qBAAA,CAEA,8BACE,qBAAA,CAIJ,gBACE,WAAA,CACA,YAAA,CAGF,eACE,iBAAA,CACA,qBAAA,CACA,eAAA,CACA,QAAA,CACA,eAAA,CAGF,aACE,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,WAAA,CAGF,kBACE,kCAAA,CAEA,UAAA,CACA,UAAA,CAEA,wBACE,SAAA",
                    sourceRoot: ""
                }
            ]);
            const a = r;
        },
        221: (t, e, A)=>{
            A.d(e, {
                A: ()=>a
            });
            var i = A(499), o = A.n(i), n = A(33), r = A.n(n)()(o());
            r.push([
                t.id,
                ':host{position:relative;overflow:hidden;display:block;width:100%;font-family:var(--embetty-font-family, Helvetica, Roboto, "Segoe UI", Calibri, sans-serif);border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;box-sizing:border-box;font-size:16px;line-height:1}#powered-by{position:absolute;z-index:3;right:-20px;bottom:0px;padding:20px 46px 5px 20px;font-size:14px;color:#777;text-decoration:none;opacity:.3}#powered-by:hover{opacity:1}#powered-by svg{position:absolute;right:10px;bottom:0;width:40px}:host(.answered){margin-top:0;margin-bottom:.5rem;border:0;padding:0}:host(.answered) header{padding-bottom:.5rem}:host(.answered) article{border-left:4px solid #bbb;margin-left:16px;padding-left:2rem;padding-bottom:1rem}:host(.answered) article p{font-size:14px}:host(.answered) article #created-at{display:none}:host(.answered) #powered-by{display:none}:host{position:relative;overflow:hidden;max-width:642px;padding:1rem 1.2rem}@media(min-width: 600px){:host{padding:1.5rem 2rem}}:host .invisible{display:none}:host .ellipsis::after{content:"\u2026"}:host header{display:flex;align-items:center;margin-bottom:.5rem}:host header img{width:36px;height:36px;border-radius:50%}:host header>span{display:inline-block;margin:0 var(--embetty-spacing, 1rem)}:host header strong{font-size:16px;display:block}:host header a,:host header a:hover{font-size:14px;color:#697882;text-decoration:none}:host article p{margin:0 auto .5rem;line-height:1.4;letter-spacing:.01em}@media(min-width: 600px){:host article p{font-size:18px}}:host article p a{color:var(--embetty-link-color, #012469);text-decoration:none}:host article p a:hover{text-decoration:underline}:host #media a{height:100%;display:flex;align-items:center}:host #media a:not(:first-child){display:none}:host #media img{max-width:100%;width:100%;height:100%;object-fit:cover}@media(min-width: 600px){:host #media{display:grid;grid-column-gap:1px;grid-row-gap:1px}:host #media a:not(:first-child){display:block}:host #media.media-2{grid-template-columns:50% 50%}:host #media.media-3{grid-template-columns:auto 40%}:host #media.media-3 a:first-child{grid-row:1/span 2}:host #media.media-4{grid-template-columns:auto 20%}:host #media.media-4 a:first-child{grid-row:1/span 3}}:host .meta-bar{display:flex;justify-content:flex-end;color:#777;stroke:#777;box-sizing:border-box;gap:1rem;margin:.5rem;text-decoration:none}:host .icon{width:1rem;height:1rem;display:inline-block;vertical-align:text-top}:host #links{border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;text-decoration:none;display:flex;flex-direction:column;color:#14171a;font-size:14px}:host #links:hover{background-color:#f5f8fa;border-color:rgba(136,153,166,.5);transition:background-color .15s ease-in-out,border-color .15s ease-in-out}@media(min-width: 600px){:host #links{flex-direction:row}}:host #links img{max-width:100%;object-fit:cover;display:inline-block}@media(min-width: 600px){:host #links img{height:125px;width:125px;min-width:125px}}:host #links>*:last-child{margin-bottom:0}:host #links #link-body{padding:.5rem}@media(min-width: 600px){:host #links #link-body{display:flex;flex-direction:column;padding:.5rem .8rem}}:host #links h3{font-size:14px;line-height:1.3;margin:0;margin-bottom:.3em}:host #links p{display:none}@media(min-width: 600px){:host #links p{display:block;flex-grow:1;-webkit-hyphens:auto;hyphens:auto;line-height:18px;font-size:14px;margin:0;margin-bottom:.3em}}:host #links span{margin-top:auto;color:#999}:host #created-at{margin-top:.5rem;display:block;font-size:14px;color:#777;text-decoration:none}:host #created-at svg{height:22px;vertical-align:middle}',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://./src/embed/mastodon.scss",
                        "webpack://./src/_element.scss",
                        "webpack://./src/embed/_powered-by.scss"
                    ],
                    names: [],
                    mappings: "AAAA,MCEA,iBACE,CAAA,eACA,CAAA,aACA,CAAA,UACA,CAAA,0FACA,CAAA,kDACA,CAAA,gBACA,CAAA,iBACA,CAAA,qBACA,CAAA,cACA,CAAA,aACA,CAAA,YCbF,iBACE,CAAA,SACA,CAAA,WACA,CAAA,UACA,CAAA,0BACA,CAAA,cACA,CAAA,UACA,CAAA,oBACA,CAAA,UACA,CAAA,kBAEA,SACE,CAAA,gBAGF,iBACE,CAAA,UACA,CAAA,QACA,CAAA,UACA,CAAA,iBFZJ,YACE,CAAA,mBACA,CAAA,QACA,CAAA,SACA,CAAA,wBAEA,oBACE,CAAA,yBAGF,0BACE,CAAA,gBACA,CAAA,iBACA,CAAA,mBACA,CAAA,2BAEA,cACE,CAAA,qCAGF,YACE,CAAA,6BAIJ,YACE,CAAA,MAIJ,iBACE,CAAA,eACA,CAAA,eACA,CAAA,mBACA,CAAA,yBAEA,MANF,mBAOI,CAAA,CAAA,iBAGF,YACE,CAAA,uBAGF,WACE,CAAA,aAGF,YACE,CAAA,kBACA,CAAA,mBACA,CAAA,iBAEA,UAzDkB,CAAA,WAAA,CAAA,iBA4DhB,CAAA,kBAGF,oBACE,CAAA,qCACA,CAAA,oBAGF,cACE,CAAA,aACA,CAAA,oCAGF,cAEE,CAAA,aACA,CAAA,oBACA,CAAA,gBAKF,mBACE,CAAA,eACA,CAAA,oBACA,CAAA,yBAEA,gBALF,cAMI,CAAA,CAAA,kBAGF,wCACE,CAAA,oBACA,CAAA,wBAGF,yBACE,CAAA,eAMJ,WACE,CAAA,YACA,CAAA,kBACA,CAAA,iCAEA,YACE,CAAA,iBAIJ,cACE,CAAA,UACA,CAAA,WACA,CAAA,gBACA,CAAA,yBAGF,aAlBF,YAmBI,CAAA,mBACA,CAAA,gBACA,CAAA,iCAEA,aACE,CAAA,qBAGF,6BACE,CAAA,qBAGF,8BACE,CAAA,mCAEA,iBACE,CAAA,qBAIJ,8BACE,CAAA,mCAEA,iBACE,CAAA,CAAA,gBAMR,YACE,CAAA,wBACA,CAAA,UACA,CAAA,WACA,CAAA,qBACA,CAAA,QACA,CAAA,YACA,CAAA,oBACA,CAAA,YAGF,UACE,CAAA,WACA,CAAA,oBACA,CAAA,uBACA,CAAA,aAGF,kDACE,CAAA,gBACA,CAAA,iBACA,CAAA,oBACA,CAAA,YACA,CAAA,qBACA,CAAA,aACA,CAAA,cACA,CAAA,mBAEA,wBACE,CAAA,iCACA,CAAA,0EACA,CAAA,yBAIF,aAjBF,kBAkBI,CAAA,CAAA,iBAGF,cACE,CAAA,gBACA,CAAA,oBACA,CAAA,yBAEA,iBALF,YAMI,CAAA,WACA,CAAA,eACA,CAAA,CAAA,0BAIJ,eACE,CAAA,wBAGF,aACE,CAAA,yBAEA,wBAHF,YAII,CAAA,qBACA,CAAA,mBACA,CAAA,CAAA,gBAIJ,cACE,CAAA,eACA,CAAA,QACA,CAAA,kBACA,CAAA,eAGF,YACE,CAAA,yBAEA,eAHF,aAII,CAAA,WACA,CAAA,oBACA,CADA,YACA,CAAA,gBACA,CAAA,cACA,CAAA,QACA,CAAA,kBACA,CAAA,CAAA,kBAIJ,eACE,CAAA,UACA,CAAA,kBAIJ,gBACE,CAAA,aACA,CAAA,cACA,CAAA,UACA,CAAA,oBACA,CAAA,sBAEA,WACE,CAAA,qBACA",
                    sourceRoot: ""
                }
            ]);
            const a = r;
        },
        599: (t, e, A)=>{
            A.d(e, {
                A: ()=>a
            });
            var i = A(499), o = A.n(i), n = A(33), r = A.n(n)()(o());
            r.push([
                t.id,
                ':host{position:relative;overflow:hidden;display:block;width:100%;font-family:var(--embetty-font-family, Helvetica, Roboto, "Segoe UI", Calibri, sans-serif);border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;box-sizing:border-box;font-size:16px;line-height:1}#powered-by{position:absolute;z-index:3;right:-20px;bottom:0px;padding:20px 46px 5px 20px;font-size:14px;color:#777;text-decoration:none;opacity:.3}#powered-by:hover{opacity:1}#powered-by svg{position:absolute;right:10px;bottom:0;width:40px}:host(.answered){margin-top:0;margin-bottom:.5rem;border:0;padding:0}:host(.answered) header{padding-bottom:.5rem}:host(.answered) article{border-left:4px solid #bbb;margin-left:16px;padding-left:2rem;padding-bottom:1rem}:host(.answered) article p{font-size:14px}:host(.answered) article #created-at{display:none}:host(.answered) #powered-by{display:none}:host{position:relative;overflow:hidden;max-width:642px;padding:1rem 1.2rem}@media(min-width: 600px){:host{padding:1.5rem 2rem}}:host header{display:flex;align-items:center;margin-bottom:.5rem}:host header img{width:36px;height:36px;border-radius:50%}:host header>span{display:inline-block;margin:0 var(--embetty-spacing, 1rem)}:host header strong{font-size:16px;display:block}:host header a,:host header a:hover{font-size:14px;color:#697882;text-decoration:none}:host article span{display:block}:host article p{margin:0 auto .5rem;line-height:1.4;letter-spacing:.01em}@media(min-width: 600px){:host article p{font-size:18px}}:host article p a{color:var(--embetty-link-color, #012469);text-decoration:none}:host article p a:hover{text-decoration:underline}:host article .media-hint{background-color:#e8e8e8;padding:.5rem;margin-bottom:.5rem;border-radius:5px;border:1px solid #ddd}:host article .media-hint a{color:#444;font-size:14px;text-decoration:underline}:host #media a{height:100%;display:flex;align-items:center}:host #media a:not(:first-child){display:none}:host #media img{max-width:100%;width:100%;height:100%;object-fit:cover}@media(min-width: 600px){:host #media{display:grid;grid-column-gap:1px;grid-row-gap:1px}:host #media a:not(:first-child){display:block}:host #media.media-2{grid-template-columns:50% 50%}:host #media.media-3{grid-template-columns:auto 40%}:host #media.media-3 a:first-child{grid-row:1/span 2}:host #media.media-4{grid-template-columns:auto 20%}:host #media.media-4 a:first-child{grid-row:1/span 3}}:host #links{border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;text-decoration:none;display:flex;flex-direction:column;color:#14171a;font-size:14px}:host #links:hover{background-color:#f5f8fa;border-color:rgba(136,153,166,.5);transition:background-color .15s ease-in-out,border-color .15s ease-in-out}@media(min-width: 600px){:host #links{flex-direction:row}}:host #links img{max-width:100%;object-fit:cover;display:inline-block}@media(min-width: 600px){:host #links img{height:125px;width:125px;min-width:125px}}:host #links>*:last-child{margin-bottom:0}:host #links #link-body{padding:.5rem}@media(min-width: 600px){:host #links #link-body{display:flex;flex-direction:column;padding:.5rem .8rem}}:host #links h3{font-size:14px;line-height:1.3;margin:0;margin-bottom:.3em}:host #links p{display:none}@media(min-width: 600px){:host #links p{display:block;flex-grow:1;-webkit-hyphens:auto;hyphens:auto;line-height:18px;font-size:14px;margin:0;margin-bottom:.3em}}:host #links span{margin-top:auto;color:#999}:host #created-at{margin-top:.5rem;display:block;font-size:14px;color:#777;text-decoration:none}:host #created-at svg{height:22px;vertical-align:middle}',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://./src/_element.scss",
                        "webpack://./src/embed/_powered-by.scss",
                        "webpack://./src/embed/tweet.scss"
                    ],
                    names: [],
                    mappings: "AAEA,MACE,iBAAA,CACA,eAAA,CACA,aAAA,CACA,UAAA,CACA,0FAAA,CACA,kDAAA,CACA,gBAAA,CACA,iBAAA,CACA,qBAAA,CACA,cAAA,CACA,aAAA,CCbF,YACE,iBAAA,CACA,SAAA,CACA,WAAA,CACA,UAAA,CACA,0BAAA,CACA,cAAA,CACA,UAAA,CACA,oBAAA,CACA,UAAA,CAEA,kBACE,SAAA,CAGF,gBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,UAAA,CCbJ,iBACE,YAAA,CACA,mBAAA,CACA,QAAA,CACA,SAAA,CAEA,wBACE,oBAAA,CAGF,yBACE,0BAAA,CACA,gBAAA,CACA,iBAAA,CACA,mBAAA,CAEA,2BACE,cAAA,CAGF,qCACE,YAAA,CAIJ,6BACE,YAAA,CAIJ,MACE,iBAAA,CACA,eAAA,CACA,eAAA,CACA,mBAAA,CAEA,yBANF,MAOI,mBAAA,CAAA,CAGF,aACE,YAAA,CACA,kBAAA,CACA,mBAAA,CAEA,iBACE,UAjDgB,CAkDhB,WAlDgB,CAmDhB,iBAAA,CAGF,kBACE,oBAAA,CACA,qCAAA,CAGF,oBACE,cAAA,CACA,aAAA,CAGF,oCAEE,cAAA,CACA,aAAA,CACA,oBAAA,CAKF,mBACE,aAAA,CAGF,gBACE,mBAAA,CACA,eAAA,CACA,oBAAA,CAEA,yBALF,gBAMI,cAAA,CAAA,CAGF,kBACE,wCAAA,CACA,oBAAA,CAGF,wBACE,yBAAA,CAIJ,0BACE,wBAAA,CACA,aAAA,CACA,mBAAA,CACA,iBAAA,CACA,qBAAA,CAEA,4BACE,UAAA,CACA,cAAA,CACA,yBAAA,CAMJ,eACE,WAAA,CACA,YAAA,CACA,kBAAA,CAEA,iCACE,YAAA,CAIJ,iBACE,cAAA,CACA,UAAA,CACA,WAAA,CACA,gBAAA,CAGF,yBAlBF,aAmBI,YAAA,CACA,mBAAA,CACA,gBAAA,CAEA,iCACE,aAAA,CAGF,qBACE,6BAAA,CAGF,qBACE,8BAAA,CAEA,mCACE,iBAAA,CAIJ,qBACE,8BAAA,CAEA,mCACE,iBAAA,CAAA,CAMR,aACE,kDAAA,CACA,gBAAA,CACA,iBAAA,CACA,oBAAA,CACA,YAAA,CACA,qBAAA,CACA,aAAA,CACA,cAAA,CAEA,mBACE,wBAAA,CACA,iCAAA,CACA,0EAAA,CAIF,yBAjBF,aAkBI,kBAAA,CAAA,CAGF,iBACE,cAAA,CACA,gBAAA,CACA,oBAAA,CAEA,yBALF,iBAMI,YAAA,CACA,WAAA,CACA,eAAA,CAAA,CAIJ,0BACE,eAAA,CAGF,wBACE,aAAA,CAEA,yBAHF,wBAII,YAAA,CACA,qBAAA,CACA,mBAAA,CAAA,CAIJ,gBACE,cAAA,CACA,eAAA,CACA,QAAA,CACA,kBAAA,CAGF,eACE,YAAA,CAEA,yBAHF,eAII,aAAA,CACA,WAAA,CACA,oBAAA,CAAA,YAAA,CACA,gBAAA,CACA,cAAA,CACA,QAAA,CACA,kBAAA,CAAA,CAIJ,kBACE,eAAA,CACA,UAAA,CAIJ,kBACE,gBAAA,CACA,aAAA,CACA,cAAA,CACA,UAAA,CACA,oBAAA,CAEA,sBACE,WAAA,CACA,qBAAA",
                    sourceRoot: ""
                }
            ]);
            const a = r;
        },
        181: (t, e, A)=>{
            A.d(e, {
                A: ()=>a
            });
            var i = A(499), o = A.n(i), n = A(33), r = A.n(n)()(o());
            r.push([
                t.id,
                ':host{position:relative;overflow:hidden;display:block;width:100%;font-family:var(--embetty-font-family, Helvetica, Roboto, "Segoe UI", Calibri, sans-serif);border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;box-sizing:border-box;font-size:16px;line-height:1}#powered-by{position:absolute;z-index:3;right:-20px;bottom:0px;padding:20px 46px 5px 20px;font-size:14px;color:#777;text-decoration:none;opacity:.3}#powered-by:hover{opacity:1}#powered-by svg{position:absolute;right:10px;bottom:0;width:40px}:host{width:100%;position:relative;background-color:#333}:host #poster{position:relative;overflow:hidden}:host #poster::before{content:"";display:block;padding-top:56.25%}:host #poster img{position:absolute;top:0;bottom:0;left:0;height:100%;width:100%}:host #playbutton{box-sizing:border-box;display:block;position:absolute;z-index:1;width:100%;height:100%;border:0;opacity:.9;background:none;cursor:pointer;transition:opacity 150ms}:host .video-playbutton{min-width:3.75rem;width:13%;max-width:6rem;transition:transform 300ms ease-out;will-change:transform}:host .video-playbutton:hover{transform:scale(1.07)}:host #playicon{width:100px;height:100px}:host .wrapper{position:relative;padding-bottom:56.25%;padding-top:0px;height:0;overflow:hidden}:host iframe{position:absolute;top:0;left:0;width:100%;height:100%}:host #powered-by{-webkit-font-smoothing:antialiased;color:#fff;opacity:.6}:host #powered-by:hover{opacity:1}',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://./src/_element.scss",
                        "webpack://./src/embed/_powered-by.scss",
                        "webpack://./src/embed/_video.scss"
                    ],
                    names: [],
                    mappings: "AAEA,MACE,iBAAA,CACA,eAAA,CACA,aAAA,CACA,UAAA,CACA,0FAAA,CACA,kDAAA,CACA,gBAAA,CACA,iBAAA,CACA,qBAAA,CACA,cAAA,CACA,aAAA,CCbF,YACE,iBAAA,CACA,SAAA,CACA,WAAA,CACA,UAAA,CACA,0BAAA,CACA,cAAA,CACA,UAAA,CACA,oBAAA,CACA,UAAA,CAEA,kBACE,SAAA,CAGF,gBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,UAAA,CChBJ,MACE,UAAA,CACA,iBAAA,CACA,qBAAA,CAEA,cACE,iBAAA,CACA,eAAA,CAEA,sBACE,UAAA,CACA,aAAA,CACA,kBAAA,CAGF,kBACE,iBAAA,CACA,KAAA,CACA,QAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CAIJ,kBACE,qBAAA,CACA,aAAA,CACA,iBAAA,CACA,SAAA,CACA,UAAA,CACA,WAAA,CACA,QAAA,CACA,UAAA,CACA,eAAA,CACA,cAAA,CACA,wBAAA,CAGF,wBACE,iBAAA,CACA,SAAA,CACA,cAAA,CACA,mCAAA,CACA,qBAAA,CAEA,8BACE,qBAAA,CAIJ,gBACE,WAAA,CACA,YAAA,CAGF,eACE,iBAAA,CACA,qBAAA,CACA,eAAA,CACA,QAAA,CACA,eAAA,CAGF,aACE,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,WAAA,CAGF,kBACE,kCAAA,CAEA,UAAA,CACA,UAAA,CAEA,wBACE,SAAA",
                    sourceRoot: ""
                }
            ]);
            const a = r;
        },
        8: (t, e, A)=>{
            A.d(e, {
                A: ()=>a
            });
            var i = A(499), o = A.n(i), n = A(33), r = A.n(n)()(o());
            r.push([
                t.id,
                ':host{position:relative;overflow:hidden;display:block;width:100%;font-family:var(--embetty-font-family, Helvetica, Roboto, "Segoe UI", Calibri, sans-serif);border:1px solid var(--embetty-border-color, #ccc);border-width:1px;border-radius:4px;box-sizing:border-box;font-size:16px;line-height:1}#powered-by{position:absolute;z-index:3;right:-20px;bottom:0px;padding:20px 46px 5px 20px;font-size:14px;color:#777;text-decoration:none;opacity:.3}#powered-by:hover{opacity:1}#powered-by svg{position:absolute;right:10px;bottom:0;width:40px}:host{width:100%;position:relative;background-color:#333}:host #poster{position:relative;overflow:hidden}:host #poster::before{content:"";display:block;padding-top:56.25%}:host #poster img{position:absolute;top:0;bottom:0;left:0;height:100%;width:100%}:host #playbutton{box-sizing:border-box;display:block;position:absolute;z-index:1;width:100%;height:100%;border:0;opacity:.9;background:none;cursor:pointer;transition:opacity 150ms}:host .video-playbutton{min-width:3.75rem;width:13%;max-width:6rem;transition:transform 300ms ease-out;will-change:transform}:host .video-playbutton:hover{transform:scale(1.07)}:host #playicon{width:100px;height:100px}:host .wrapper{position:relative;padding-bottom:56.25%;padding-top:0px;height:0;overflow:hidden}:host iframe{position:absolute;top:0;left:0;width:100%;height:100%}:host #powered-by{-webkit-font-smoothing:antialiased;color:#fff;opacity:.6}:host #powered-by:hover{opacity:1}',
                "",
                {
                    version: 3,
                    sources: [
                        "webpack://./src/_element.scss",
                        "webpack://./src/embed/_powered-by.scss",
                        "webpack://./src/embed/_video.scss"
                    ],
                    names: [],
                    mappings: "AAEA,MACE,iBAAA,CACA,eAAA,CACA,aAAA,CACA,UAAA,CACA,0FAAA,CACA,kDAAA,CACA,gBAAA,CACA,iBAAA,CACA,qBAAA,CACA,cAAA,CACA,aAAA,CCbF,YACE,iBAAA,CACA,SAAA,CACA,WAAA,CACA,UAAA,CACA,0BAAA,CACA,cAAA,CACA,UAAA,CACA,oBAAA,CACA,UAAA,CAEA,kBACE,SAAA,CAGF,gBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,UAAA,CChBJ,MACE,UAAA,CACA,iBAAA,CACA,qBAAA,CAEA,cACE,iBAAA,CACA,eAAA,CAEA,sBACE,UAAA,CACA,aAAA,CACA,kBAAA,CAGF,kBACE,iBAAA,CACA,KAAA,CACA,QAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CAIJ,kBACE,qBAAA,CACA,aAAA,CACA,iBAAA,CACA,SAAA,CACA,UAAA,CACA,WAAA,CACA,QAAA,CACA,UAAA,CACA,eAAA,CACA,cAAA,CACA,wBAAA,CAGF,wBACE,iBAAA,CACA,SAAA,CACA,cAAA,CACA,mCAAA,CACA,qBAAA,CAEA,8BACE,qBAAA,CAIJ,gBACE,WAAA,CACA,YAAA,CAGF,eACE,iBAAA,CACA,qBAAA,CACA,eAAA,CACA,QAAA,CACA,eAAA,CAGF,aACE,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,WAAA,CAGF,kBACE,kCAAA,CAEA,UAAA,CACA,UAAA,CAEA,wBACE,SAAA",
                    sourceRoot: ""
                }
            ]);
            const a = r;
        },
        542: (t, e, A)=>{
            A.r(e), A.d(e, {
                default: ()=>i
            });
            const i = '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 76 146" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"><g><g id="Ebene_2"><g><g id="Ebene_1-2"><path d="M76.713,30.883c0.026,-6.353 -0.177,-24.72 -0.386,-29.832c-4.043,0.619 -6.366,4.183 -5.814,10.062c0.009,0.099 1.514,6.181 2.227,9.282c1.232,5.365 0.368,7.232 -0.835,10.908l4.808,-0.42Z" style="fill:#735aa3;fill-rule:nonzero;"/><path d="M71.482,24.098c-0.298,-1.794 -6.006,-7.977 -7.744,-8.824c-1.738,-0.846 -3.401,-1.883 -5.553,-0.841c-0.571,0.276 -0.916,0.991 -0.985,1.628c-0.065,0.597 -0.621,3.768 2.75,4.943c0,0 3.844,1.427 5.624,1.532c3.489,0.207 5.46,2.696 5.908,1.562Z" style="fill:#735aa3;fill-rule:nonzero;"/><path d="M75.969,32.521l0.326,113.779l-65.129,0.001c-1.842,-5.635 -2.965,-7.781 -4.453,-11.988c-14.1,-39.7 2.256,-101.792 69.256,-101.792Z" style="fill:#735aa3;fill-rule:nonzero;"/><path d="M75.881,32.187c0,0 -29.179,-1.203 -50.819,18.32c-11.885,10.723 -22.429,28.41 -22.632,55.262c-0.176,23.142 8.34,40.252 8.34,40.252" style="fill:none;stroke:#000;stroke-width:3.5px;"/><path d="M76.292,1.66c1.132,-1.087 0.119,-0.634 0.044,-1.433c-5.964,1.029 -7.323,7.086 -6.523,11.986c0.6,3.7 2.6,8.5 2.8,12.7c-0.757,-2.868 -2.402,-5.424 -4.7,-7.3c-2.4,-2.2 -7,-6.5 -10.4,-3.7c-3.1,2.5 -0.6,6.7 2.2,8.1c2.2,1 4.6,1.1 6.9,1.6c1.8,0.4 5.291,2.024 5.663,3.729c0.059,2.432 -2.13,4.677 -2.863,5.241c-0.6,0.5 -0.1,1.5 0.6,1.1c4.5,-2.8 4.6,-8.5 3.5,-13.1c-1.3,-5.5 -5.298,-15.808 2.779,-18.923Zm-16.279,18.753c-2.543,-1.124 -3.512,-4.873 -0.772,-5.81c2.4,-0.6 4.572,1.51 6.272,2.81c2.333,1.898 3.952,3.736 5.1,6.2c-3,-2.3 -6.109,-0.982 -10.6,-3.2Z" style="fill:#020204;fill-rule:nonzero;"/><ellipse cx="58.713" cy="54.013" rx="6.4" ry="2.2" style="fill:#6ac4cb;"/><path d="M38.281,44.677c3.384,-1.011 6.414,-0.888 6.762,0.275c0.348,1.164 -2.118,2.929 -5.502,3.941c-3.384,1.011 -6.414,0.888 -6.762,-0.275c-0.348,-1.164 2.118,-2.929 5.502,-3.941Z" style="fill:#6ac4cb;"/><path d="M62.181,35.816c4.506,-0.424 8.282,0.482 8.426,2.02c0.145,1.539 -3.396,3.132 -7.902,3.555c-4.505,0.424 -8.281,-0.481 -8.426,-2.02c-0.144,-1.538 3.396,-3.131 7.902,-3.555Z" style="fill:#6ac4cb;"/><path d="M35.263,101.642c7.212,-1.638 15.152,6.207 17.72,17.51c0.815,3.59 0.992,7.1 0.621,10.271c-6.304,1.956 -15.229,5.169 -21.255,7.475c-2.463,-3.064 -4.44,-7.142 -5.5,-11.809c-2.568,-11.302 1.203,-21.808 8.414,-23.447Z" style="fill:#fff;"/><path d="M37.754,111.472c4.951,-1.125 10.391,4.21 12.14,11.906c0.581,2.558 0.681,5.056 0.375,7.294c-4.349,1.476 -9.905,3.278 -14.438,4.968c-1.743,-2.1 -3.141,-4.932 -3.88,-8.185c-1.749,-7.696 0.852,-14.858 5.803,-15.983Z" style="fill:#1a1a1a;"/><path d="M43.531,117.378c1.893,-0.425 3.972,1.645 4.64,4.62c0.668,2.975 -0.327,5.735 -2.22,6.16c-1.893,0.425 -3.972,-1.645 -4.64,-4.62c-0.668,-2.975 0.327,-5.735 2.22,-6.16Z" style="fill:#fff;"/><path d="M76.114,127.826l0.002,-2.044c-16.6,0 -32.703,4.931 -44.403,10.831c-0.7,0.3 -0.4,1.7 0.3,1.4c11.9,-5.1 31.501,-10.087 44.101,-10.187Z" style="fill:#030304;fill-rule:nonzero;"/><path d="M42.913,79.313c-3.2,-2.7 -8.3,-2.8 -12.2,-1.7c-3.4,1 -8.1,3.5 -7.6,7.7c0.2,1.8 3.1,1.9 2.9,0c-0.4,-3.6 5.5,-5.2 8.1,-5.5c2.6,-0.3 5.1,0.6 7.7,1.2c1,0.3 2,-0.93 1.1,-1.7Z" style="fill:#020204;fill-rule:nonzero;"/></g></g></g></g></svg>';
        },
        698: function(t, e, A) {
            var i = this && this.__awaiter || function(t, e, A, i) {
                return new (A || (A = Promise))(function(o, n) {
                    function r(t) {
                        try {
                            s(i.next(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function a(t) {
                        try {
                            s(i.throw(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function s(t) {
                        var e;
                        t.done ? o(t.value) : (e = t.value, e instanceof A ? e : new A(function(t) {
                            t(e);
                        })).then(r, a);
                    }
                    s((i = i.apply(t, e || [])).next());
                });
            }, o = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.TEMPLATE_METADATA_KEY = void 0, e.webcomponent = function(t, A) {
                return (i)=>{
                    Reflect.defineProperty(i, e.TEMPLATE_METADATA_KEY, {
                        value: n.default.compile(A)
                    }), (0, r.defineElement)(t, i);
                };
            }, e.observable = function() {
                return (t)=>{
                    const e = t.prototype.connectedCallback;
                    t.prototype.initialized = !1, t.prototype.observableRootMargin = "0px 0px 10% 0px", t.prototype.connectedCallback = function() {
                        return i(this, void 0, void 0, function*() {
                            e.call(this), yield new Promise((t)=>{
                                new window.IntersectionObserver((e)=>i(this, [
                                        e
                                    ], void 0, function*([e]) {
                                        this.isVisible() && 0 !== (null == e ? void 0 : e.intersectionRatio) && (this.initialized || (this.initialized = !0, yield this.becomesVisible(), t()));
                                    }), {
                                    root: this.observableRoot,
                                    rootMargin: this.observableRootMargin,
                                    threshold: this.observableRootThreshold
                                }).observe(this);
                            });
                        });
                    };
                };
            };
            const n = o(A(747)), r = A(396);
            e.TEMPLATE_METADATA_KEY = "template";
        },
        531: function(t, e, A) {
            var i = this && this.__awaiter || function(t, e, A, i) {
                return new (A || (A = Promise))(function(o, n) {
                    function r(t) {
                        try {
                            s(i.next(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function a(t) {
                        try {
                            s(i.throw(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function s(t) {
                        var e;
                        t.done ? o(t.value) : (e = t.value, e instanceof A ? e : new A(function(t) {
                            t(e);
                        })).then(r, a);
                    }
                    s((i = i.apply(t, e || [])).next());
                });
            }, o = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.Embed = void 0;
            const n = o(A(542)), r = A(698);
            class a extends HTMLElement {
                constructor(){
                    super(...arguments), this._fetched = !1;
                }
                get serverUrl() {
                    const t = document.querySelector("meta[data-embetty-server]");
                    return this.getAttribute("server-url") || t && t.dataset.embettyServer || "";
                }
                isVisible() {
                    return "none" !== window.getComputedStyle(this).display;
                }
                _api(t) {
                    return this.serverUrl + t;
                }
                emit(t, e) {
                    this.dispatchEvent(new window.CustomEvent(t, e));
                }
                on(t, e) {
                    this.addEventListener(t, e, !1);
                }
                becomesVisible() {
                    return i(this, void 0, void 0, function*() {
                        this.url && (yield this.fetchData()), this.shadowRoot.innerHTML = this.render(), this.emit("initialized");
                    });
                }
                connectedCallback() {
                    this.attachShadow({
                        mode: "open"
                    });
                }
                get wrapper() {
                    return this.shadowRoot.querySelector(".wrapper");
                }
                get embettyLogo() {
                    return n.default;
                }
                fetchData() {
                    return i(this, void 0, void 0, function*() {
                        const t = yield window.fetch(this.url);
                        this._data = yield t.json(), this._fetched = !0;
                    });
                }
                render() {
                    const t = Reflect.get(this.constructor, r.TEMPLATE_METADATA_KEY);
                    if (!t) throw new Error(`Template not found for class ${this.constructor.name}`);
                    return t.render(this);
                }
            }
            e.Embed = a;
        },
        701: function(t, e, A) {
            var i = this && this.__decorate || function(t, e, A, i) {
                var o, n = arguments.length, r = n < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, A) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(t, e, A, i);
                else for(var a = t.length - 1; a >= 0; a--)(o = t[a]) && (r = (n < 3 ? o(r) : n > 3 ? o(e, A, r) : o(e, A)) || r);
                return n > 3 && r && Object.defineProperty(e, A, r), r;
            }, o = this && this.__metadata || function(t, e) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
            }, n = this && this.__awaiter || function(t, e, A, i) {
                return new (A || (A = Promise))(function(o, n) {
                    function r(t) {
                        try {
                            s(i.next(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function a(t) {
                        try {
                            s(i.throw(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function s(t) {
                        var e;
                        t.done ? o(t.value) : (e = t.value, e instanceof A ? e : new A(function(t) {
                            t(e);
                        })).then(r, a);
                    }
                    s((i = i.apply(t, e || [])).next());
                });
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.Mastodon = void 0;
            const r = A(698), a = A(531), s = A(396), l = `\n    <style>${A(221).A.toString()}</style>\n      <header>\n        <img src="{{profileImageUrl}}" />\n        <span>\n          <strong>{{userName}}</strong>\n          <a href="{{profileUrl}}" target="_blank" rel="noopener" >@{{screenName}}</a>\n        </span>\n      </header>\n      <article>\n        <p>{{{ fullText }}}</p>\n        {{#hasMedia}}\n          <section class="media-{{media.length}}" id="media">\n            {{#media}}\n              <a target="_blank" href="{{imageUrl}}"><img src="{{imageUrl}}"></a>\n            {{/media}}\n          </section>\n        {{/hasMedia}}\n        <section>\n          <a href="{{mastodonUrl}}" target="_blank" rel="noopener" class="meta-bar">\n            <span>\n              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-back-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 14l-4 -4l4 -4" /><path d="M5 10h11a4 4 0 1 1 0 8h-1" /></svg>\n              <span>{{repliesCount}}</span>\n            </span>\n            <span>\n              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-repeat" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" /><path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" /></svg>\n              <span>{{reblogCount}}</span>\n            </span>\n            <span>\n              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-star-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" stroke-width="0" fill="currentColor" /></svg>\n              <span>{{favouriteCount}}</spam>\n            </span>\n          </a>\n        </section>\n        {{#showLinkCard}}\n          <a href="{{card.url}}" target="_blank" rel="noopener" id="links">\n            <img src="{{linkImageUrl}}">\n            <section id="link-body">\n              <h3>{{card.title}}</h3>\n              <span>{{linkHostname}}</span>\n            </section>\n          </a>\n        {{/showLinkCard}}\n\n        <a href="{{mastodonUrl}}" target="_blank" rel="noopener" id="created-at" class="tweet__link">\n          <time datetime="{{createdAt.toISOString}}">{{createdAt.toLocaleString}}</time>\n          via Mastodon\n        </a>\n\n        <a href="https://www.heise.de/embetty?wt_mc=link.embetty.poweredby" target="_blank" rel="noopener" id="powered-by" title="embetty - displaying remote content without compromising your privacy.">\n          powered by {{{embettyLogo}}}</a>\n      </article>\n    `;
            let c = class extends a.Embed {
                constructor(t, e = {}){
                    super(), t && this.setAttribute("status", t);
                }
                get status() {
                    const t = this.getAttribute("status");
                    if (!t) throw new Error("Invalid status");
                    return t;
                }
                get url() {
                    return this._api(`/mastodon/${this.status}`);
                }
                get mastodonUrl() {
                    return this.status;
                }
                get card() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.card;
                }
                assertData(t) {
                    if (!t) throw new Error("Invalid mastodon status data");
                }
                get createdAt() {
                    const t = this._data;
                    return this.assertData(t), new Date(t.created_at);
                }
                get profileImageUrl() {
                    return `${this.url}/profile-image`;
                }
                get linkImageUrl() {
                    return `${this.url}/link-image`;
                }
                get fullText() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.content;
                }
                get profileUrl() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.account.url;
                }
                get userName() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.account.username;
                }
                get favouriteCount() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.favourites_count;
                }
                get reblogCount() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.reblogs_count;
                }
                get repliesCount() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.replies_count;
                }
                get screenName() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.account.display_name;
                }
                get media() {
                    var t, e;
                    return (null !== (e = null === (t = this._data) || void 0 === t ? void 0 : t.media_attachments) && void 0 !== e ? e : []).map((t, e)=>({
                            imageUrl: `${this.url}/images/${e}`
                        }));
                }
                get hasMedia() {
                    const t = this._data;
                    return this.assertData(t), t.media_attachments.length > 0;
                }
                get link() {
                    var t;
                    return null === (t = this._data) || void 0 === t ? void 0 : t.card.url;
                }
                get linkHostname() {
                    const t = this.link;
                    return t ? (0, s.parseHostname)(t) : void 0;
                }
                get showLinkCard() {
                    var t;
                    return (null === (t = this._data) || void 0 === t ? void 0 : t.card) && 0 === this._data.media_attachments.length;
                }
                becomesVisible() {
                    const t = Object.create(null, {
                        becomesVisible: {
                            get: ()=>super.becomesVisible
                        }
                    });
                    return n(this, void 0, void 0, function*() {
                        yield t.becomesVisible.call(this);
                        const e = this.shadowRoot.querySelector("#links img");
                        e && e.addEventListener("error", ()=>{
                            e.remove();
                        });
                    });
                }
            };
            e.Mastodon = c, e.Mastodon = c = i([
                (0, r.webcomponent)("embetty-mastodon", l),
                (0, r.observable)(),
                o("design:paramtypes", [
                    String,
                    Object
                ])
            ], c);
        },
        69: function(t, e, A) {
            var i, o = this && this.__decorate || function(t, e, A, i) {
                var o, n = arguments.length, r = n < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, A) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(t, e, A, i);
                else for(var a = t.length - 1; a >= 0; a--)(o = t[a]) && (r = (n < 3 ? o(r) : n > 3 ? o(e, A, r) : o(e, A)) || r);
                return n > 3 && r && Object.defineProperty(e, A, r), r;
            }, n = this && this.__metadata || function(t, e) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
            }, r = this && this.__awaiter || function(t, e, A, i) {
                return new (A || (A = Promise))(function(o, n) {
                    function r(t) {
                        try {
                            s(i.next(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function a(t) {
                        try {
                            s(i.throw(t));
                        } catch (t) {
                            n(t);
                        }
                    }
                    function s(t) {
                        var e;
                        t.done ? o(t.value) : (e = t.value, e instanceof A ? e : new A(function(t) {
                            t(e);
                        })).then(r, a);
                    }
                    s((i = i.apply(t, e || [])).next());
                });
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.Tweet = void 0;
            const a = A(698), s = A(531), l = A(396), c = `\n    <style>${A(599).A.toString()}</style>\n      <header>\n        <img src="{{profileImageUrl}}" />\n        <span>\n          <strong>{{userName}}</strong>\n          <a href="https://twitter.com/{{screenName}}" target="_blank" rel="noopener" >@{{screenName}}</a>\n        </span>\n      </header>\n      <article>\n        <p>{{{ fullText }}}</p>\n        {{#hasImages}}\n          <section class="media-{{images.length}}" id="media">\n            {{#images}}\n              <a target="_blank" href="{{imageUrl}}"><img src="{{imageUrl}}"></a>\n            {{/images}}\n          </section>\n        {{/hasImages}}\n        {{#hasAdditionalMedia}}\n          <section class="media-hint">\n            <a href="{{twitterUrl}}" target="_blank" rel="noopener">\n              Weitere Inhalte des Posts auf x.com\n            </a>\n          </section>\n        {{/hasAdditionalMedia}}\n\n        {{#hasLinks}}\n          <a href="{{link.url}}" target="_blank" rel="noopener" id="links">\n            <img src="{{linkImageUrl}}">\n            <section id="link-body">\n              <h3>{{link.title}}</h3>\n              {{#link.description}}<p>{{link.description}}</p>{{/link.description}}\n              <span>{{linkHostname}}</span>\n            </section>\n          </a>\n        {{/hasLinks}}\n\n        <a href="{{twitterUrl}}" target="_blank" rel="noopener" id="created-at" class="tweet__link">\n          <time datetime="{{createdAt.toISOString}}">{{createdAt.toLocaleString}}</time>\n          via X (Twitter)\n          <svg id="xcorp-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22.1 20" preserveAspectRatio="xMinYMin" style="height: 12px"><path id="path2" d="M17.4,0h3.4l-7.4,8.5L22.1,20h-6.8L10,13l-6.1,7H0.4l7.9-9.1L0,0h7l4.8,6.4L17.4,0z M16.2,18h1.9L6,1.9H4 L16.2,18z"/></svg>\n        </a>\n\n        <a href="https://www.heise.de/embetty?wt_mc=link.embetty.poweredby" target="_blank" rel="noopener" id="powered-by" title="embetty - displaying remote content without compromising your privacy.">\n          powered by {{{embettyLogo}}}</a>\n      </article>\n    `;
            let d = i = class extends s.Embed {
                constructor(t, e, A = {}){
                    super(), t && this.setAttribute("status", t), "include-thread" in A && this.setAttribute("include-thread", ""), this.parent = e, this.on("initialized", ()=>{
                        this.appendAnsweredTweet(), this.fitCardHeight();
                    });
                }
                appendAnsweredTweet() {
                    if (!this.isReply || !this.hasAttribute("include-thread") || !this.answeredTweetId) return;
                    const t = new i(this.answeredTweetId, this, {
                        "include-thread": ""
                    });
                    t.classList.add("answered"), this.shadowRoot.insertBefore(t, this.shadowRoot.firstChild);
                }
                fitCardHeight() {
                    var t, e;
                    if (!this.hasLinks) return;
                    const A = this.shadowRoot.querySelector("#links"), i = this.shadowRoot.querySelector("#link-body");
                    if (A.clientWidth === i.clientWidth) return;
                    const o = A.querySelector("p");
                    if (!o) return;
                    const n = (0, l.height)(A.querySelector("img"));
                    let r = 0, a = "";
                    for(; (0, l.height)(A) - 2 > n && !(++r > 200) && a !== o.textContent;)a = o.textContent, o.textContent = `${null !== (e = null === (t = o.textContent) || void 0 === t ? void 0 : t.replace(/\W*\s(\S)*$/, "")) && void 0 !== e ? e : ""}\u{2026}`;
                }
                get answeredTweets() {
                    var t;
                    return null === (t = this.shadowRoot) || void 0 === t ? void 0 : t.querySelectorAll("embetty-tweet");
                }
                get statusId() {
                    const t = this.getAttribute("status");
                    if (!t) throw new Error("Invalid status");
                    return t;
                }
                get url() {
                    return this._api(`/tweet/${this.statusId}`);
                }
                get twitterUrl() {
                    return `https://twitter.com/${this.user.username}/status/${this.statusId}`;
                }
                assertData(t) {
                    if (!t) throw new Error("Invalid tweet data");
                }
                get createdAt() {
                    return this.assertData(this._data), new Date(this._data.data.created_at);
                }
                get profileImageUrl() {
                    return `${this.url}/profile-image`;
                }
                get linkImageUrl() {
                    return `${this.url}/link-image`;
                }
                get fullText() {
                    var t, e, A;
                    const i = (null === (t = this._data) || void 0 === t ? void 0 : t.data.note_tweet) ? null === (e = this._data) || void 0 === e ? void 0 : e.data.note_tweet.text : null === (A = this._data) || void 0 === A ? void 0 : A.data.text;
                    return (null != i ? i : "").replaceAll(/#([^\s-]+)/g, (t, e)=>`<a href="https://twitter.com/hashtag/${e}">${t}</a>`).replaceAll(/@(\w+)/g, (t, e)=>`<a href="https://twitter.com/${e}">${t}</a>`);
                }
                get user() {
                    const t = this._data;
                    this.assertData(t);
                    const e = t.includes.users.find((e)=>e.id === t.data.author_id);
                    if (!e) throw new Error("Invalid user data");
                    return e;
                }
                get userName() {
                    var t;
                    return null === (t = this.user) || void 0 === t ? void 0 : t.name;
                }
                get screenName() {
                    var t;
                    return null === (t = this.user) || void 0 === t ? void 0 : t.username;
                }
                get images() {
                    var t, e;
                    const A = (null !== (e = null === (t = this._data) || void 0 === t ? void 0 : t.includes.media) && void 0 !== e ? e : []).filter((t)=>"photo" === t.type);
                    return (null != A ? A : []).map((t, e)=>({
                            imageUrl: `${this.url}/images/${e}`
                        }));
                }
                get hasAdditionalMedia() {
                    var t, e, A;
                    return this.images.length < (null !== (A = null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.data.attachments) || void 0 === e ? void 0 : e.media_keys.length) && void 0 !== A ? A : 0);
                }
                get hasImages() {
                    return this.images.length > 0;
                }
                get links() {
                    var t, e;
                    return null !== (e = null === (t = this._data) || void 0 === t ? void 0 : t.linkMetas) && void 0 !== e ? e : [];
                }
                get link() {
                    return this.links[0];
                }
                get linkHostname() {
                    var t;
                    const e = null === (t = this.link) || void 0 === t ? void 0 : t.url;
                    return e ? (0, l.parseHostname)(e) : void 0;
                }
                get hasLinks() {
                    return this.links.length > 0;
                }
                get answeredTweetId() {
                    var t, e, A;
                    return null === (A = null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.data.referenced_tweets) || void 0 === e ? void 0 : e.find((t)=>"replied_to" === t.type)) || void 0 === A ? void 0 : A.id;
                }
                get isReply() {
                    return !!this.answeredTweetId;
                }
                becomesVisible() {
                    const t = Object.create(null, {
                        becomesVisible: {
                            get: ()=>super.becomesVisible
                        }
                    });
                    return r(this, void 0, void 0, function*() {
                        yield t.becomesVisible.call(this);
                        const e = this.shadowRoot.querySelector("#links img");
                        e && e.addEventListener("error", ()=>{
                            e.remove();
                        });
                    });
                }
            };
            e.Tweet = d, e.Tweet = d = i = o([
                (0, a.webcomponent)("embetty-tweet", c),
                (0, a.observable)(),
                n("design:paramtypes", [
                    String,
                    d,
                    Object
                ])
            ], d);
        },
        955: function(t, e, A) {
            var i = this && this.__createBinding || (Object.create ? function(t, e, A, i) {
                void 0 === i && (i = A);
                var o = Object.getOwnPropertyDescriptor(e, A);
                o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
                    enumerable: !0,
                    get: function() {
                        return e[A];
                    }
                }), Object.defineProperty(t, i, o);
            } : function(t, e, A, i) {
                void 0 === i && (i = A), t[i] = e[A];
            }), o = this && this.__setModuleDefault || (Object.create ? function(t, e) {
                Object.defineProperty(t, "default", {
                    enumerable: !0,
                    value: e
                });
            } : function(t, e) {
                t.default = e;
            }), n = this && this.__decorate || function(t, e, A, i) {
                var o, n = arguments.length, r = n < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, A) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(t, e, A, i);
                else for(var a = t.length - 1; a >= 0; a--)(o = t[a]) && (r = (n < 3 ? o(r) : n > 3 ? o(e, A, r) : o(e, A)) || r);
                return n > 3 && r && Object.defineProperty(e, A, r), r;
            }, r = this && this.__importStar || function(t) {
                if (t && t.__esModule) return t;
                var e = {};
                if (null != t) for(var A in t)"default" !== A && Object.prototype.hasOwnProperty.call(t, A) && i(e, t, A);
                return o(e, t), e;
            }, a = this && this.__metadata || function(t, e) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            const s = A(698), l = A(531), c = r(A(669)), d = A(710).A.toString();
            let C = class extends l.Embed {
                constructor(){
                    super(), this.impl = new this.Type(this), this.on("initialized", ()=>{
                        var t;
                        null === (t = this.playButton) || void 0 === t || t.addEventListener("click", ()=>{
                            this.activate();
                        }, {
                            once: !0
                        });
                    });
                }
                activate() {
                    this.shadowRoot.innerHTML = this.impl.iframe, this.emit("activated");
                }
                get playButton() {
                    return this.shadowRoot.querySelector("#playbutton");
                }
                get url() {
                    return this.impl.url;
                }
                get Type() {
                    const t = this.typeClass;
                    if (!c[this.typeClass]) throw new Error(`"${t}" does not exist.`);
                    return c[t];
                }
                get typeClass() {
                    const t = this.type;
                    if (!t) throw new Error("No type specified.");
                    return `${t.charAt(0).toUpperCase() + t.slice(1)}Video`;
                }
                get type() {
                    return this.getAttribute("type");
                }
                get videoId() {
                    const t = this.getAttribute("video-id");
                    if (!t) throw new Error("No video ID specified.");
                    return t;
                }
                get posterImageUrl() {
                    return this.getAttribute("poster-image") || this.impl.posterImageUrl;
                }
                get startAt() {
                    return this.getAttribute("start-at") || 0;
                }
            };
            C = n([
                (0, s.webcomponent)("embetty-video", `\n      <style>${d}</style>\n      <button type="button" id="playbutton" aria-label="Abspielen">\n        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 2000 2000" fill="#fff" class="video-playbutton">\n            <g transform="matrix(1.05356,0,0,1.03089,24.9824,-12.7689)">\n              <ellipse cx="925.453" cy="982.42" rx="906.453" ry="926.382" style="fill:black;fill-opacity:0.65;stroke:white;stroke-width:70px;"></ellipse>\n            </g>\n            <g transform="matrix(1.6783e-16,2.74087,-2.70471,1.65616e-16,2834.26,-542.169)">\n              <path d="M552.398,514.228C554.346,510.792 557.954,508.67 561.865,508.661C565.775,508.652 569.393,510.758 571.356,514.186C599.993,564.195 685.165,712.931 713.834,762.997C715.799,766.428 715.806,770.661 713.852,774.099C711.898,777.537 708.282,779.655 704.367,779.655L420.852,779.655C416.946,779.655 413.336,777.546 411.379,774.12C409.422,770.694 409.415,766.471 411.361,763.039C439.708,713.029 524.019,564.293 552.398,514.228Z" style="fill:white;"></path>\n            </g>\n        </svg>\n      </button>\n      <div id="poster">\n      {{#posterImageUrl}}\n        <img src="{{posterImageUrl}}">\n      {{/posterImageUrl}}\n      </div>\n      <a href="https://www.heise.de/embetty" target="_blank" rel="noopener" id="powered-by" title="embetty - displaying remote content without compromising your privacy.">\n        powered by {{{embettyLogo}}}\n      </a>\n    `),
                (0, s.observable)(),
                a("design:paramtypes", [])
            ], C), e.default = C;
        },
        406: (t, e)=>{
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = class {
                constructor(t){
                    this.element = t;
                }
                get width() {
                    const t = this.element.getAttribute("width");
                    return t ? parseInt(t) : 1600;
                }
                get height() {
                    const t = this.element.getAttribute("height");
                    return t ? parseInt(t) : 900;
                }
            };
        },
        141: function(t, e, A) {
            var i = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.FacebookVideo = void 0;
            const o = i(A(406)), n = A(181).A.toString();
            class r extends o.default {
                get css() {
                    return n;
                }
                get url() {
                    return this.element._api(`/video/facebook/${this.element.videoId}`);
                }
                get posterImageUrl() {
                    return "";
                }
                get canonicalUrl() {
                    var t;
                    return null === (t = this.element._data) || void 0 === t ? void 0 : t.canonicalUrl;
                }
                get iframeSrc() {
                    if (!this.canonicalUrl) throw new Error("canonicalUrl is not available");
                    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(this.canonicalUrl)}&show_text=0&autoplay=1&mute=0&width=${this.width}`;
                }
                get iframe() {
                    return `\n      <style>${n}</style>\n      <div class="wrapper">\n        <iframe\n          src="${this.iframeSrc}"\n          width="${this.width}"\n          height="${this.height}"\n          style="border:none;overflow:hidden"\n          scrolling="no"\n          frameborder="0"\n          allowTransparency="true"\n          allowFullScreen="true"\n        ></iframe>\n      </div>\n    `;
                }
            }
            e.FacebookVideo = r;
        },
        29: function(t, e, A) {
            var i = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.VimeoVideo = void 0;
            const o = i(A(406)), n = A(181).A.toString();
            class r extends o.default {
                get css() {
                    return n;
                }
                get posterImageUrl() {
                    return this.element._api(`/video/vimeo/${this.element.videoId}-poster-image`);
                }
                get iframe() {
                    return `\n      <style>${n}</style>\n      <div class="wrapper">\n        <iframe\n          src="https://player.vimeo.com/video/${this.element.videoId}?autoplay=1#t=${this.element.startAt}"\n          width="${this.width}"\n          height="${this.height}"\n          frameborder="0"\n          webkitallowfullscreen\n          mozallowfullscreen\n          allowfullscreen\n        ></iframe>\n      </div>\n    `;
                }
            }
            e.VimeoVideo = r;
        },
        80: function(t, e, A) {
            var i = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.YoutubeVideo = void 0;
            const o = i(A(406)), n = A(8).A.toString();
            class r extends o.default {
                get css() {
                    return n;
                }
                get posterImageUrl() {
                    return this.element._api(`/video/youtube/${this.element.videoId}-poster-image`);
                }
                get iframe() {
                    return `\n      <style>${this.css}</style>\n      <div class="wrapper">\n        <iframe\n          id="ytplayer"\n          width="${this.width}"\n          height="${this.height}"\n          src="//www.youtube-nocookie.com/embed/${this.element.videoId}?autoplay=1&start=${this.element.startAt}"\n          frameborder="0"\n          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"\n          allowfullscreen\n        ></iframe>\n      </div>\n    `;
                }
            }
            e.YoutubeVideo = r;
        },
        669: function(t, e, A) {
            var i = this && this.__createBinding || (Object.create ? function(t, e, A, i) {
                void 0 === i && (i = A);
                var o = Object.getOwnPropertyDescriptor(e, A);
                o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
                    enumerable: !0,
                    get: function() {
                        return e[A];
                    }
                }), Object.defineProperty(t, i, o);
            } : function(t, e, A, i) {
                void 0 === i && (i = A), t[i] = e[A];
            }), o = this && this.__exportStar || function(t, e) {
                for(var A in t)"default" === A || Object.prototype.hasOwnProperty.call(e, A) || i(e, t, A);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), o(A(141), e), o(A(29), e), o(A(80), e);
        },
        144: function(t, e, A) {
            var i = this && this.__createBinding || (Object.create ? function(t, e, A, i) {
                void 0 === i && (i = A);
                var o = Object.getOwnPropertyDescriptor(e, A);
                o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
                    enumerable: !0,
                    get: function() {
                        return e[A];
                    }
                }), Object.defineProperty(t, i, o);
            } : function(t, e, A, i) {
                void 0 === i && (i = A), t[i] = e[A];
            }), o = this && this.__exportStar || function(t, e) {
                for(var A in t)"default" === A || Object.prototype.hasOwnProperty.call(e, A) || i(e, t, A);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), o(A(701), e), o(A(69), e), o(A(955), e), o(A(669), e);
        },
        422: function(t, e, A) {
            var i = this && this.__createBinding || (Object.create ? function(t, e, A, i) {
                void 0 === i && (i = A);
                var o = Object.getOwnPropertyDescriptor(e, A);
                o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
                    enumerable: !0,
                    get: function() {
                        return e[A];
                    }
                }), Object.defineProperty(t, i, o);
            } : function(t, e, A, i) {
                void 0 === i && (i = A), t[i] = e[A];
            }), o = this && this.__exportStar || function(t, e) {
                for(var A in t)"default" === A || Object.prototype.hasOwnProperty.call(e, A) || i(e, t, A);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), o(A(144), e);
        },
        396: (t, e)=>{
            function A(t, e) {
                return window.getComputedStyle(t)[e];
            }
            function i(t) {
                return Number.parseFloat(A(t, "marginTop")) + Number.parseFloat(A(t, "marginBottom"));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.computedStyle = A, e.marginHeight = i, e.height = function(t) {
                return Number.parseFloat(A(t, "height")) + i(t);
            }, e.parseHostname = function(t) {
                const e = document.createElement("a");
                return e.setAttribute("href", t), e.hostname;
            }, e.createTemplate = function(t, e) {
                const A = `<style>${e}</style>${t}`, i = document.createElement("template");
                return i.innerHTML = A, i;
            }, e.defineElement = function(t, e, A) {
                window.customElements.define(t, e, A);
            };
        },
        33: (t)=>{
            t.exports = function(t) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var A = "", i = void 0 !== e[5];
                        return e[4] && (A += "@supports (".concat(e[4], ") {")), e[2] && (A += "@media ".concat(e[2], " {")), i && (A += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), A += t(e), i && (A += "}"), e[2] && (A += "}"), e[4] && (A += "}"), A;
                    }).join("");
                }, e.i = function(t, A, i, o, n) {
                    "string" == typeof t && (t = [
                        [
                            null,
                            t,
                            void 0
                        ]
                    ]);
                    var r = {};
                    if (i) for(var a = 0; a < this.length; a++){
                        var s = this[a][0];
                        null != s && (r[s] = !0);
                    }
                    for(var l = 0; l < t.length; l++){
                        var c = [].concat(t[l]);
                        i && r[c[0]] || (void 0 !== n && (void 0 === c[5] || (c[1] = "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = n), A && (c[2] ? (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}"), c[2] = A) : c[2] = A), o && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = o) : c[4] = "".concat(o)), e.push(c));
                    }
                }, e;
            };
        },
        499: (t)=>{
            t.exports = function(t) {
                var e = t[1], A = t[3];
                if (!A) return e;
                if ("function" == typeof btoa) {
                    var i = btoa(unescape(encodeURIComponent(JSON.stringify(A)))), o = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(i), n = "/*# ".concat(o, " */");
                    return [
                        e
                    ].concat([
                        n
                    ]).join("\n");
                }
                return [
                    e
                ].join("\n");
            };
        },
        809: (t, e)=>{
            !function(t) {
                var e = /\S/, A = /\"/g, i = /\n/g, o = /\r/g, n = /\\/g, r = /\u2028/, a = /\u2029/;
                function s(t) {
                    return t.trim ? t.trim() : t.replace(/^\s*|\s*$/g, "");
                }
                function l(t, e, A) {
                    if (e.charAt(A) != t.charAt(0)) return !1;
                    for(var i = 1, o = t.length; i < o; i++)if (e.charAt(A + i) != t.charAt(i)) return !1;
                    return !0;
                }
                t.tags = {
                    "#": 1,
                    "^": 2,
                    "<": 3,
                    $: 4,
                    "/": 5,
                    "!": 6,
                    ">": 7,
                    "=": 8,
                    _v: 9,
                    "{": 10,
                    "&": 11,
                    _t: 12
                }, t.scan = function(A, i) {
                    var o, n = A.length, r = 0, a = null, c = null, d = "", C = [], h = !1, p = 0, u = 0, m = "{{", f = "}}";
                    function g() {
                        d.length > 0 && (C.push({
                            tag: "_t",
                            text: new String(d)
                        }), d = "");
                    }
                    function b(A, i) {
                        if (g(), A && function() {
                            for(var A = !0, i = u; i < C.length; i++)if (!(A = t.tags[C[i].tag] < t.tags._v || "_t" == C[i].tag && null === C[i].text.match(e))) return !1;
                            return A;
                        }()) for(var o, n = u; n < C.length; n++)C[n].text && ((o = C[n + 1]) && ">" == o.tag && (o.indent = C[n].text.toString()), C.splice(n, 1));
                        else i || C.push({
                            tag: "\n"
                        });
                        h = !1, u = C.length;
                    }
                    function v(t, e) {
                        var A = "=" + f, i = t.indexOf(A, e), o = s(t.substring(t.indexOf("=", e) + 1, i)).split(" ");
                        return m = o[0], f = o[o.length - 1], i + A.length - 1;
                    }
                    for(i && (i = i.split(" "), m = i[0], f = i[1]), p = 0; p < n; p++)0 == r ? l(m, A, p) ? (--p, g(), r = 1) : "\n" == A.charAt(p) ? b(h) : d += A.charAt(p) : 1 == r ? (p += m.length - 1, "=" == (a = (c = t.tags[A.charAt(p + 1)]) ? A.charAt(p + 1) : "_v") ? (p = v(A, p), r = 0) : (c && p++, r = 2), h = p) : l(f, A, p) ? (C.push({
                        tag: a,
                        n: s(d),
                        otag: m,
                        ctag: f,
                        i: "/" == a ? h - m.length : p + f.length
                    }), d = "", p += f.length - 1, r = 0, "{" == a && ("}}" == f ? p++ : "}" === (o = C[C.length - 1]).n.substr(o.n.length - 1) && (o.n = o.n.substring(0, o.n.length - 1)))) : d += A.charAt(p);
                    return b(h, !0), C;
                };
                var c = {
                    _t: !0,
                    "\n": !0,
                    $: !0,
                    "/": !0
                };
                function d(e, A, i, o) {
                    var n, r = [], a = null, s = null;
                    for(n = i[i.length - 1]; e.length > 0;){
                        if (s = e.shift(), n && "<" == n.tag && !(s.tag in c)) throw new Error("Illegal content in < super tag.");
                        if (t.tags[s.tag] <= t.tags.$ || C(s, o)) i.push(s), s.nodes = d(e, s.tag, i, o);
                        else {
                            if ("/" == s.tag) {
                                if (0 === i.length) throw new Error("Closing tag without opener: /" + s.n);
                                if (a = i.pop(), s.n != a.n && !h(s.n, a.n, o)) throw new Error("Nesting error: " + a.n + " vs. " + s.n);
                                return a.end = s.i, r;
                            }
                            "\n" == s.tag && (s.last = 0 == e.length || "\n" == e[0].tag);
                        }
                        r.push(s);
                    }
                    if (i.length > 0) throw new Error("missing closing tag: " + i.pop().n);
                    return r;
                }
                function C(t, e) {
                    for(var A = 0, i = e.length; A < i; A++)if (e[A].o == t.n) return t.tag = "#", !0;
                }
                function h(t, e, A) {
                    for(var i = 0, o = A.length; i < o; i++)if (A[i].c == t && A[i].o == e) return !0;
                }
                function p(t) {
                    var e = [];
                    for(var A in t.partials)e.push('"' + m(A) + '":{name:"' + m(t.partials[A].name) + '", ' + p(t.partials[A]) + "}");
                    return "partials: {" + e.join(",") + "}, subs: " + function(t) {
                        var e = [];
                        for(var A in t)e.push('"' + m(A) + '": function(c,p,t,i) {' + t[A] + "}");
                        return "{ " + e.join(",") + " }";
                    }(t.subs);
                }
                t.stringify = function(e, A, i) {
                    return "{code: function (c,p,i) { " + t.wrapMain(e.code) + " }," + p(e) + "}";
                };
                var u = 0;
                function m(t) {
                    return t.replace(n, "\\\\").replace(A, '\\"').replace(i, "\\n").replace(o, "\\r").replace(r, "\\u2028").replace(a, "\\u2029");
                }
                function f(t) {
                    return ~t.indexOf(".") ? "d" : "f";
                }
                function g(t, e) {
                    var A = "<" + (e.prefix || "") + t.n + u++;
                    return e.partials[A] = {
                        name: t.n,
                        partials: {}
                    }, e.code += 't.b(t.rp("' + m(A) + '",c,p,"' + (t.indent || "") + '"));', A;
                }
                function b(t, e) {
                    e.code += "t.b(t.t(t." + f(t.n) + '("' + m(t.n) + '",c,p,0)));';
                }
                function v(t) {
                    return "t.b(" + t + ");";
                }
                t.generate = function(e, A, i) {
                    u = 0;
                    var o = {
                        code: "",
                        subs: {},
                        partials: {}
                    };
                    return t.walk(e, o), i.asString ? this.stringify(o, A, i) : this.makeTemplate(o, A, i);
                }, t.wrapMain = function(t) {
                    return 'var t=this;t.b(i=i||"");' + t + "return t.fl();";
                }, t.template = t.Template, t.makeTemplate = function(t, e, A) {
                    var i = this.makePartials(t);
                    return i.code = new Function("c", "p", "i", this.wrapMain(t.code)), new this.template(i, e, this, A);
                }, t.makePartials = function(t) {
                    var e, A = {
                        subs: {},
                        partials: t.partials,
                        name: t.name
                    };
                    for(e in A.partials)A.partials[e] = this.makePartials(A.partials[e]);
                    for(e in t.subs)A.subs[e] = new Function("c", "p", "t", "i", t.subs[e]);
                    return A;
                }, t.codegen = {
                    "#": function(e, A) {
                        A.code += "if(t.s(t." + f(e.n) + '("' + m(e.n) + '",c,p,1),c,p,0,' + e.i + "," + e.end + ',"' + e.otag + " " + e.ctag + '")){t.rs(c,p,function(c,p,t){', t.walk(e.nodes, A), A.code += "});c.pop();}";
                    },
                    "^": function(e, A) {
                        A.code += "if(!t.s(t." + f(e.n) + '("' + m(e.n) + '",c,p,1),c,p,1,0,0,"")){', t.walk(e.nodes, A), A.code += "};";
                    },
                    ">": g,
                    "<": function(e, A) {
                        var i = {
                            partials: {},
                            code: "",
                            subs: {},
                            inPartial: !0
                        };
                        t.walk(e.nodes, i);
                        var o = A.partials[g(e, A)];
                        o.subs = i.subs, o.partials = i.partials;
                    },
                    $: function(e, A) {
                        var i = {
                            subs: {},
                            code: "",
                            partials: A.partials,
                            prefix: e.n
                        };
                        t.walk(e.nodes, i), A.subs[e.n] = i.code, A.inPartial || (A.code += 't.sub("' + m(e.n) + '",c,p,i);');
                    },
                    "\n": function(t, e) {
                        e.code += v('"\\n"' + (t.last ? "" : " + i"));
                    },
                    _v: function(t, e) {
                        e.code += "t.b(t.v(t." + f(t.n) + '("' + m(t.n) + '",c,p,0)));';
                    },
                    _t: function(t, e) {
                        e.code += v('"' + m(t.text) + '"');
                    },
                    "{": b,
                    "&": b
                }, t.walk = function(e, A) {
                    for(var i, o = 0, n = e.length; o < n; o++)(i = t.codegen[e[o].tag]) && i(e[o], A);
                    return A;
                }, t.parse = function(t, e, A) {
                    return d(t, 0, [], (A = A || {}).sectionTags || []);
                }, t.cache = {}, t.cacheKey = function(t, e) {
                    return [
                        t,
                        !!e.asString,
                        !!e.disableLambda,
                        e.delimiters,
                        !!e.modelGet
                    ].join("||");
                }, t.compile = function(e, A) {
                    A = A || {};
                    var i = t.cacheKey(e, A), o = this.cache[i];
                    if (o) {
                        var n = o.partials;
                        for(var r in n)delete n[r].instance;
                        return o;
                    }
                    return o = this.generate(this.parse(this.scan(e, A.delimiters), e, A), e, A), this.cache[i] = o;
                };
            }(e);
        },
        747: (t, e, A)=>{
            var i = A(809);
            i.Template = A(834).Template, i.template = i.Template, t.exports = i;
        },
        834: (t, e)=>{
            !function(t) {
                function e(t, e, A) {
                    var i;
                    return e && "object" == typeof e && (void 0 !== e[t] ? i = e[t] : A && e.get && "function" == typeof e.get && (i = e.get(t))), i;
                }
                t.Template = function(t, e, A, i) {
                    t = t || {}, this.r = t.code || this.r, this.c = A, this.options = i || {}, this.text = e || "", this.partials = t.partials || {}, this.subs = t.subs || {}, this.buf = "";
                }, t.Template.prototype = {
                    r: function(t, e, A) {
                        return "";
                    },
                    v: function(t) {
                        return t = s(t), a.test(t) ? t.replace(A, "&amp;").replace(i, "&lt;").replace(o, "&gt;").replace(n, "&#39;").replace(r, "&quot;") : t;
                    },
                    t: s,
                    render: function(t, e, A) {
                        return this.ri([
                            t
                        ], e || {}, A);
                    },
                    ri: function(t, e, A) {
                        return this.r(t, e, A);
                    },
                    ep: function(t, e) {
                        var A = this.partials[t], i = e[A.name];
                        if (A.instance && A.base == i) return A.instance;
                        if ("string" == typeof i) {
                            if (!this.c) throw new Error("No compiler available.");
                            i = this.c.compile(i, this.options);
                        }
                        if (!i) return null;
                        if (this.partials[t].base = i, A.subs) {
                            for(key in e.stackText || (e.stackText = {}), A.subs)e.stackText[key] || (e.stackText[key] = void 0 !== this.activeSub && e.stackText[this.activeSub] ? e.stackText[this.activeSub] : this.text);
                            i = function(t, e, A, i, o, n) {
                                function r() {}
                                function a() {}
                                var s;
                                r.prototype = t, a.prototype = t.subs;
                                var l = new r;
                                for(s in l.subs = new a, l.subsText = {}, l.buf = "", i = i || {}, l.stackSubs = i, l.subsText = n, e)i[s] || (i[s] = e[s]);
                                for(s in i)l.subs[s] = i[s];
                                for(s in o = o || {}, l.stackPartials = o, A)o[s] || (o[s] = A[s]);
                                for(s in o)l.partials[s] = o[s];
                                return l;
                            }(i, A.subs, A.partials, this.stackSubs, this.stackPartials, e.stackText);
                        }
                        return this.partials[t].instance = i, i;
                    },
                    rp: function(t, e, A, i) {
                        var o = this.ep(t, A);
                        return o ? o.ri(e, A, i) : "";
                    },
                    rs: function(t, e, A) {
                        var i = t[t.length - 1];
                        if (l(i)) for(var o = 0; o < i.length; o++)t.push(i[o]), A(t, e, this), t.pop();
                        else A(t, e, this);
                    },
                    s: function(t, e, A, i, o, n, r) {
                        var a;
                        return (!l(t) || 0 !== t.length) && ("function" == typeof t && (t = this.ms(t, e, A, i, o, n, r)), a = !!t, !i && a && e && e.push("object" == typeof t ? t : e[e.length - 1]), a);
                    },
                    d: function(t, A, i, o) {
                        var n, r = t.split("."), a = this.f(r[0], A, i, o), s = this.options.modelGet, c = null;
                        if ("." === t && l(A[A.length - 2])) a = A[A.length - 1];
                        else for(var d = 1; d < r.length; d++)void 0 !== (n = e(r[d], a, s)) ? (c = a, a = n) : a = "";
                        return !(o && !a) && (o || "function" != typeof a || (A.push(c), a = this.mv(a, A, i), A.pop()), a);
                    },
                    f: function(t, A, i, o) {
                        for(var n = !1, r = !1, a = this.options.modelGet, s = A.length - 1; s >= 0; s--)if (void 0 !== (n = e(t, A[s], a))) {
                            r = !0;
                            break;
                        }
                        return r ? (o || "function" != typeof n || (n = this.mv(n, A, i)), n) : !o && "";
                    },
                    ls: function(t, e, A, i, o) {
                        var n = this.options.delimiters;
                        return this.options.delimiters = o, this.b(this.ct(s(t.call(e, i)), e, A)), this.options.delimiters = n, !1;
                    },
                    ct: function(t, e, A) {
                        if (this.options.disableLambda) throw new Error("Lambda features disabled.");
                        return this.c.compile(t, this.options).render(e, A);
                    },
                    b: function(t) {
                        this.buf += t;
                    },
                    fl: function() {
                        var t = this.buf;
                        return this.buf = "", t;
                    },
                    ms: function(t, e, A, i, o, n, r) {
                        var a, s = e[e.length - 1], l = t.call(s);
                        return "function" == typeof l ? !!i || (a = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(l, s, A, a.substring(o, n), r)) : l;
                    },
                    mv: function(t, e, A) {
                        var i = e[e.length - 1], o = t.call(i);
                        return "function" == typeof o ? this.ct(s(o.call(i)), i, A) : o;
                    },
                    sub: function(t, e, A, i) {
                        var o = this.subs[t];
                        o && (this.activeSub = t, o(e, A, this, i), this.activeSub = !1);
                    }
                };
                var A = /&/g, i = /</g, o = />/g, n = /\'/g, r = /\"/g, a = /[&<>\"\']/;
                function s(t) {
                    return String(null == t ? "" : t);
                }
                var l = Array.isArray || function(t) {
                    return "[object Array]" === Object.prototype.toString.call(t);
                };
            }(e);
        }
    }, e = {};
    function A(i) {
        var o = e[i];
        if (void 0 !== o) return o.exports;
        var n = e[i] = {
            id: i,
            exports: {}
        };
        return t[i].call(n.exports, n, n.exports, A), n.exports;
    }
    A.n = (t)=>{
        var e = t && t.__esModule ? ()=>t.default : ()=>t;
        return A.d(e, {
            a: e
        }), e;
    }, A.d = (t, e)=>{
        for(var i in e)A.o(e, i) && !A.o(t, i) && Object.defineProperty(t, i, {
            enumerable: !0,
            get: e[i]
        });
    }, A.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), A.r = (t)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, A(422);
})();


/*!
* chartjs-plugin-annotation v3.1.0
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2024 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */ 



/**
 * @typedef { import("chart.js").ChartEvent } ChartEvent
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$interaction = {
    modes: {
        /**
     * Point mode returns all elements that hit test based on the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */ point (visibleElements, event) {
            return $4049e6bf31df43d6$var$filterElements(visibleElements, event, {
                intersect: true
            });
        },
        /**
     * Nearest mode returns the element closest to the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */ nearest (visibleElements, event, options) {
            return $4049e6bf31df43d6$var$getNearestItem(visibleElements, event, options);
        },
        /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ x (visibleElements, event, options) {
            return $4049e6bf31df43d6$var$filterElements(visibleElements, event, {
                intersect: options.intersect,
                axis: 'x'
            });
        },
        /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ y (visibleElements, event, options) {
            return $4049e6bf31df43d6$var$filterElements(visibleElements, event, {
                intersect: options.intersect,
                axis: 'y'
            });
        }
    }
};
/**
 * Returns all elements that hit test based on the event position
 * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
 * @param {ChartEvent} event - the event we are find things at
 * @param {Object} options - interaction options to use
 * @return {AnnotationElement[]} - elements that are found
 */ function $4049e6bf31df43d6$var$getElements(visibleElements, event, options) {
    const mode = $4049e6bf31df43d6$var$interaction.modes[options.mode] || $4049e6bf31df43d6$var$interaction.modes.nearest;
    return mode(visibleElements, event, options);
}
function $4049e6bf31df43d6$var$inRangeByAxis(element, event, axis) {
    if (axis !== 'x' && axis !== 'y') return element.inRange(event.x, event.y, 'x', true) || element.inRange(event.x, event.y, 'y', true);
    return element.inRange(event.x, event.y, axis, true);
}
function $4049e6bf31df43d6$var$getPointByAxis(event, center, axis) {
    if (axis === 'x') return {
        x: event.x,
        y: center.y
    };
    else if (axis === 'y') return {
        x: center.x,
        y: event.y
    };
    return center;
}
function $4049e6bf31df43d6$var$filterElements(visibleElements, event, options) {
    return visibleElements.filter((element)=>options.intersect ? element.inRange(event.x, event.y) : $4049e6bf31df43d6$var$inRangeByAxis(element, event, options.axis));
}
function $4049e6bf31df43d6$var$getNearestItem(visibleElements, event, options) {
    let minDistance = Number.POSITIVE_INFINITY;
    return $4049e6bf31df43d6$var$filterElements(visibleElements, event, options).reduce((nearestItems, element)=>{
        const center = element.getCenterPoint();
        const evenPoint = $4049e6bf31df43d6$var$getPointByAxis(event, center, options.axis);
        const distance = (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(event, evenPoint);
        if (distance < minDistance) {
            nearestItems = [
                element
            ];
            minDistance = distance;
        } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
        nearestItems.push(element);
        return nearestItems;
    }, []).sort((a, b)=>a._index - b._index).slice(0, 1); // return only the top item;
}
/**
 * @typedef {import('chart.js').Point} Point
 */ /**
 * Rotate a `point` relative to `center` point by `angle`
 * @param {Point} point - the point to rotate
 * @param {Point} center - center point for rotation
 * @param {number} angle - angle for rotation, in radians
 * @returns {Point} rotated point
 */ function $4049e6bf31df43d6$var$rotated(point, center, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const cx = center.x;
    const cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
const $4049e6bf31df43d6$var$isOlderPart = (act, req)=>req > act || act.length > req.length && act.slice(0, req.length) === req;
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('chart.js').InteractionAxis } InteractionAxis
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$EPSILON = 0.001;
const $4049e6bf31df43d6$var$clamp = (x, from, to)=>Math.min(to, Math.max(from, x));
/**
 * @param {{value: number, start: number, end: number}} limit
 * @param {number} hitSize
 * @returns {boolean}
 */ const $4049e6bf31df43d6$var$inLimit = (limit, hitSize)=>limit.value >= limit.start - hitSize && limit.value <= limit.end + hitSize;
/**
 * @param {Object} obj
 * @param {number} from
 * @param {number} to
 * @returns {Object}
 */ function $4049e6bf31df43d6$var$clampAll(obj, from, to) {
    for (const key of Object.keys(obj))obj[key] = $4049e6bf31df43d6$var$clamp(obj[key], from, to);
    return obj;
}
/**
 * @param {Point} point
 * @param {Point} center
 * @param {number} radius
 * @param {number} hitSize
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$inPointRange(point, center, radius, hitSize) {
    if (!point || !center || radius <= 0) return false;
    return Math.pow(point.x - center.x, 2) + Math.pow(point.y - center.y, 2) <= Math.pow(radius + hitSize, 2);
}
/**
 * @param {Point} point
 * @param {{x: number, y: number, x2: number, y2: number}} rect
 * @param {InteractionAxis} axis
 * @param {{borderWidth: number, hitTolerance: number}} hitsize
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$inBoxRange(point, { x: x, y: y, x2: x2, y2: y2 }, axis, { borderWidth: borderWidth, hitTolerance: hitTolerance }) {
    const hitSize = (borderWidth + hitTolerance) / 2;
    const inRangeX = point.x >= x - hitSize - $4049e6bf31df43d6$var$EPSILON && point.x <= x2 + hitSize + $4049e6bf31df43d6$var$EPSILON;
    const inRangeY = point.y >= y - hitSize - $4049e6bf31df43d6$var$EPSILON && point.y <= y2 + hitSize + $4049e6bf31df43d6$var$EPSILON;
    if (axis === 'x') return inRangeX;
    else if (axis === 'y') return inRangeY;
    return inRangeX && inRangeY;
}
/**
 * @param {Point} point
 * @param {rect: {x: number, y: number, x2: number, y2: number}, center: {x: number, y: number}} element
 * @param {InteractionAxis} axis
 * @param {{rotation: number, borderWidth: number, hitTolerance: number}}
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$inLabelRange(point, { rect: rect, center: center }, axis, { rotation: rotation, borderWidth: borderWidth, hitTolerance: hitTolerance }) {
    const rotPoint = $4049e6bf31df43d6$var$rotated(point, center, (0, $84f61e7391a78632$export$625550452a3fa3ec)(-rotation));
    return $4049e6bf31df43d6$var$inBoxRange(rotPoint, rect, axis, {
        borderWidth: borderWidth,
        hitTolerance: hitTolerance
    });
}
/**
 * @param {AnnotationElement} element
 * @param {boolean} useFinalPosition
 * @returns {Point}
 */ function $4049e6bf31df43d6$var$getElementCenterPoint(element, useFinalPosition) {
    const { centerX: centerX, centerY: centerY } = element.getProps([
        'centerX',
        'centerY'
    ], useFinalPosition);
    return {
        x: centerX,
        y: centerY
    };
}
/**
 * @param {string} pkg
 * @param {string} min
 * @param {string} ver
 * @param {boolean} [strict=true]
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$requireVersion(pkg, min, ver, strict = true) {
    const parts = ver.split('.');
    let i = 0;
    for (const req of min.split('.')){
        const act = parts[i++];
        if (parseInt(req, 10) < parseInt(act, 10)) break;
        if ($4049e6bf31df43d6$var$isOlderPart(act, req)) {
            if (strict) throw new Error(`${pkg} v${ver} is not supported. v${min} or newer is required.`);
            else return false;
        }
    }
    return true;
}
const $4049e6bf31df43d6$var$isPercentString = (s)=>typeof s === 'string' && s.endsWith('%');
const $4049e6bf31df43d6$var$toPercent = (s)=>parseFloat(s) / 100;
const $4049e6bf31df43d6$var$toPositivePercent = (s)=>$4049e6bf31df43d6$var$clamp($4049e6bf31df43d6$var$toPercent(s), 0, 1);
const $4049e6bf31df43d6$var$boxAppering = (x, y)=>({
        x: x,
        y: y,
        x2: x,
        y2: y,
        width: 0,
        height: 0
    });
const $4049e6bf31df43d6$var$defaultInitAnimation = {
    box: (properties)=>$4049e6bf31df43d6$var$boxAppering(properties.centerX, properties.centerY),
    doughnutLabel: (properties)=>$4049e6bf31df43d6$var$boxAppering(properties.centerX, properties.centerY),
    ellipse: (properties)=>({
            centerX: properties.centerX,
            centerY: properties.centerX,
            radius: 0,
            width: 0,
            height: 0
        }),
    label: (properties)=>$4049e6bf31df43d6$var$boxAppering(properties.centerX, properties.centerY),
    line: (properties)=>$4049e6bf31df43d6$var$boxAppering(properties.x, properties.y),
    point: (properties)=>({
            centerX: properties.centerX,
            centerY: properties.centerY,
            radius: 0,
            width: 0,
            height: 0
        }),
    polygon: (properties)=>$4049e6bf31df43d6$var$boxAppering(properties.centerX, properties.centerY)
};
/**
 * @typedef { import('chart.js').FontSpec } FontSpec
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('chart.js').Padding } Padding
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 * @typedef { import('../../types/options').AnnotationPointCoordinates } AnnotationPointCoordinates
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/label').LabelPositionObject } LabelPositionObject
 */ /**
 * @param {number} size
 * @param {number|string} position
 * @returns {number}
 */ function $4049e6bf31df43d6$var$getRelativePosition(size, position) {
    if (position === 'start') return 0;
    if (position === 'end') return size;
    if ($4049e6bf31df43d6$var$isPercentString(position)) return $4049e6bf31df43d6$var$toPositivePercent(position) * size;
    return size / 2;
}
/**
 * @param {number} size
 * @param {number|string} value
 * @param {boolean} [positivePercent=true]
 * @returns {number}
 */ function $4049e6bf31df43d6$var$getSize(size, value, positivePercent = true) {
    if (typeof value === 'number') return value;
    else if ($4049e6bf31df43d6$var$isPercentString(value)) return (positivePercent ? $4049e6bf31df43d6$var$toPositivePercent(value) : $4049e6bf31df43d6$var$toPercent(value)) * size;
    return size;
}
/**
 * @param {{x: number, width: number}} size
 * @param {CoreLabelOptions} options
 * @returns {number}
 */ function $4049e6bf31df43d6$var$calculateTextAlignment(size, options) {
    const { x: x, width: width } = size;
    const textAlign = options.textAlign;
    if (textAlign === 'center') return x + width / 2;
    else if (textAlign === 'end' || textAlign === 'right') return x + width;
    return x;
}
/**
 * @param {Point} point
 * @param {{height: number, width: number}} labelSize
 * @param {{borderWidth: number, position: {LabelPositionObject|string}, xAdjust: number, yAdjust: number}} options
 * @param {Padding|undefined} padding
 * @returns {{x: number, y: number, x2: number, y2: number, height: number, width: number, centerX: number, centerY: number}}
 */ function $4049e6bf31df43d6$var$measureLabelRectangle(point, labelSize, { borderWidth: borderWidth, position: position, xAdjust: xAdjust, yAdjust: yAdjust }, padding) {
    const hasPadding = (0, $84f61e7391a78632$export$23f2a1d2818174ef)(padding);
    const width = labelSize.width + (hasPadding ? padding.width : 0) + borderWidth;
    const height = labelSize.height + (hasPadding ? padding.height : 0) + borderWidth;
    const positionObj = $4049e6bf31df43d6$var$toPosition(position);
    const x = $4049e6bf31df43d6$var$calculateLabelPosition$1(point.x, width, xAdjust, positionObj.x);
    const y = $4049e6bf31df43d6$var$calculateLabelPosition$1(point.y, height, yAdjust, positionObj.y);
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2
    };
}
/**
 * @param {LabelPositionObject|string} value
 * @param {string|number} defaultValue
 * @returns {LabelPositionObject}
 */ function $4049e6bf31df43d6$var$toPosition(value, defaultValue = 'center') {
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) return {
        x: (0, $84f61e7391a78632$export$90a7f3efeed30595)(value.x, defaultValue),
        y: (0, $84f61e7391a78632$export$90a7f3efeed30595)(value.y, defaultValue)
    };
    value = (0, $84f61e7391a78632$export$90a7f3efeed30595)(value, defaultValue);
    return {
        x: value,
        y: value
    };
}
/**
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 * @returns {boolean}
 */ const $4049e6bf31df43d6$var$shouldFit = (options, fitRatio)=>options && options.autoFit && fitRatio < 1;
/**
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 * @returns {FontSpec[]}
 */ function $4049e6bf31df43d6$var$toFonts(options, fitRatio) {
    const optFont = options.font;
    const fonts = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(optFont) ? optFont : [
        optFont
    ];
    if ($4049e6bf31df43d6$var$shouldFit(options, fitRatio)) return fonts.map(function(f) {
        const font = (0, $84f61e7391a78632$export$34aec0b863436764)(f);
        font.size = Math.floor(f.size * fitRatio);
        font.lineHeight = f.lineHeight;
        return (0, $84f61e7391a78632$export$34aec0b863436764)(font);
    });
    return fonts.map((f)=>(0, $84f61e7391a78632$export$34aec0b863436764)(f));
}
/**
 * @param {AnnotationPointCoordinates} options
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$isBoundToPoint(options) {
    return options && ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(options.xValue) || (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(options.yValue));
}
function $4049e6bf31df43d6$var$calculateLabelPosition$1(start, size, adjust = 0, position) {
    return start - $4049e6bf31df43d6$var$getRelativePosition(size, position) + adjust;
}
/**
 * @param {Chart} chart
 * @param {AnnotationBoxModel} properties
 * @param {CoreAnnotationOptions} options
 * @returns {AnnotationElement}
 */ function $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options) {
    const initAnim = options.init;
    if (!initAnim) return;
    else if (initAnim === true) return $4049e6bf31df43d6$var$applyDefault(properties, options);
    return $4049e6bf31df43d6$var$execCallback(chart, properties, options);
}
/**
 * @param {Object} options
 * @param {Array} hooks
 * @param {Object} hooksContainer
 * @returns {boolean}
 */ function $4049e6bf31df43d6$var$loadHooks(options, hooks, hooksContainer) {
    let activated = false;
    hooks.forEach((hook)=>{
        if ((0, $84f61e7391a78632$export$a93c5207d687da10)(options[hook])) {
            activated = true;
            hooksContainer[hook] = options[hook];
        } else if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(hooksContainer[hook])) delete hooksContainer[hook];
    });
    return activated;
}
function $4049e6bf31df43d6$var$applyDefault(properties, options) {
    const type = options.type || 'line';
    return $4049e6bf31df43d6$var$defaultInitAnimation[type](properties);
}
function $4049e6bf31df43d6$var$execCallback(chart, properties, options) {
    const result = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.init, [
        {
            chart: chart,
            properties: properties,
            options: options
        }
    ]);
    if (result === true) return $4049e6bf31df43d6$var$applyDefault(properties, options);
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(result)) return result;
}
const $4049e6bf31df43d6$var$widthCache = new Map();
const $4049e6bf31df43d6$var$notRadius = (radius)=>isNaN(radius) || radius <= 0;
const $4049e6bf31df43d6$var$fontsKey = (fonts)=>fonts.reduce(function(prev, item) {
        prev += item.string;
        return prev;
    }, '');
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 */ /**
 * Determine if content is an image or a canvas.
 * @param {*} content
 * @returns boolean|undefined
 * @todo move this function to chart.js helpers
 */ function $4049e6bf31df43d6$var$isImageOrCanvas(content) {
    if (content && typeof content === 'object') {
        const type = content.toString();
        return type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]';
    }
}
/**
 * Set the translation on the canvas if the rotation must be applied.
 * @param {CanvasRenderingContext2D} ctx - chart canvas context
 * @param {Point} point - the point of translation
 * @param {number} rotation - rotation (in degrees) to apply
 */ function $4049e6bf31df43d6$var$translate(ctx, { x: x, y: y }, rotation) {
    if (rotation) {
        ctx.translate(x, y);
        ctx.rotate((0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation));
        ctx.translate(-x, -y);
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 * @returns {boolean|undefined}
 */ function $4049e6bf31df43d6$var$setBorderStyle(ctx, options) {
    if (options && options.borderWidth) {
        ctx.lineCap = options.borderCapStyle || 'butt';
        ctx.setLineDash(options.borderDash);
        ctx.lineDashOffset = options.borderDashOffset;
        ctx.lineJoin = options.borderJoinStyle || 'miter';
        ctx.lineWidth = options.borderWidth;
        ctx.strokeStyle = options.borderColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 */ function $4049e6bf31df43d6$var$setShadowStyle(ctx, options) {
    ctx.shadowColor = options.backgroundShadowColor;
    ctx.shadowBlur = options.shadowBlur;
    ctx.shadowOffsetX = options.shadowOffsetX;
    ctx.shadowOffsetY = options.shadowOffsetY;
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {CoreLabelOptions} options
 * @returns {{width: number, height: number}}
 */ function $4049e6bf31df43d6$var$measureLabelSize(ctx, options) {
    const content = options.content;
    if ($4049e6bf31df43d6$var$isImageOrCanvas(content)) {
        const size = {
            width: $4049e6bf31df43d6$var$getSize(content.width, options.width),
            height: $4049e6bf31df43d6$var$getSize(content.height, options.height)
        };
        return size;
    }
    const fonts = $4049e6bf31df43d6$var$toFonts(options);
    const strokeWidth = options.textStrokeWidth;
    const lines = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const mapKey = lines.join() + $4049e6bf31df43d6$var$fontsKey(fonts) + strokeWidth + (ctx._measureText ? '-spriting' : '');
    if (!$4049e6bf31df43d6$var$widthCache.has(mapKey)) $4049e6bf31df43d6$var$widthCache.set(mapKey, $4049e6bf31df43d6$var$calculateLabelSize(ctx, lines, fonts, strokeWidth));
    return $4049e6bf31df43d6$var$widthCache.get(mapKey);
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {Object} options
 */ function $4049e6bf31df43d6$var$drawBox(ctx, rect, options) {
    const { x: x, y: y, width: width, height: height } = rect;
    ctx.save();
    $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
    const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
    ctx.fillStyle = options.backgroundColor;
    ctx.beginPath();
    (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
        x: x,
        y: y,
        w: width,
        h: height,
        radius: $4049e6bf31df43d6$var$clampAll((0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(options.borderRadius), 0, Math.min(width, height) / 2)
    });
    ctx.closePath();
    ctx.fill();
    if (stroke) {
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
    }
    ctx.restore();
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 */ function $4049e6bf31df43d6$var$drawLabel(ctx, rect, options, fitRatio) {
    const content = options.content;
    if ($4049e6bf31df43d6$var$isImageOrCanvas(content)) {
        ctx.save();
        ctx.globalAlpha = $4049e6bf31df43d6$var$getOpacity(options.opacity, content.style.opacity);
        ctx.drawImage(content, rect.x, rect.y, rect.width, rect.height);
        ctx.restore();
        return;
    }
    const labels = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const fonts = $4049e6bf31df43d6$var$toFonts(options, fitRatio);
    const optColor = options.color;
    const colors = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(optColor) ? optColor : [
        optColor
    ];
    const x = $4049e6bf31df43d6$var$calculateTextAlignment(rect, options);
    const y = rect.y + options.textStrokeWidth / 2;
    ctx.save();
    ctx.textBaseline = 'middle';
    ctx.textAlign = options.textAlign;
    if ($4049e6bf31df43d6$var$setTextStrokeStyle(ctx, options)) $4049e6bf31df43d6$var$applyLabelDecoration(ctx, {
        x: x,
        y: y
    }, labels, fonts);
    $4049e6bf31df43d6$var$applyLabelContent(ctx, {
        x: x,
        y: y
    }, labels, {
        fonts: fonts,
        colors: colors
    });
    ctx.restore();
}
function $4049e6bf31df43d6$var$setTextStrokeStyle(ctx, options) {
    if (options.textStrokeWidth > 0) {
        // https://stackoverflow.com/questions/13627111/drawing-text-with-an-outer-stroke-with-html5s-canvas
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        ctx.lineWidth = options.textStrokeWidth;
        ctx.strokeStyle = options.textStrokeColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{radius: number, options: PointAnnotationOptions}} element
 * @param {number} x
 * @param {number} y
 */ function $4049e6bf31df43d6$var$drawPoint(ctx, element, x, y) {
    const { radius: radius, options: options } = element;
    const style = options.pointStyle;
    const rotation = options.rotation;
    let rad = (rotation || 0) * (0, $84f61e7391a78632$export$39c1cc7c062529d4);
    if ($4049e6bf31df43d6$var$isImageOrCanvas(style)) {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rad);
        ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
        ctx.restore();
        return;
    }
    if ($4049e6bf31df43d6$var$notRadius(radius)) return;
    $4049e6bf31df43d6$var$drawPointStyle(ctx, {
        x: x,
        y: y,
        radius: radius,
        rotation: rotation,
        style: style,
        rad: rad
    });
}
function $4049e6bf31df43d6$var$drawPointStyle(ctx, { x: x, y: y, radius: radius, rotation: rotation, style: style, rad: rad }) {
    let xOffset, yOffset, size, cornerRadius;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            ctx.arc(x, y, radius, 0, (0, $84f61e7391a78632$export$971d5caa766a69d7));
            ctx.closePath();
            break;
        case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $84f61e7391a78632$export$c18d01048907ea92);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $84f61e7391a78632$export$c18d01048907ea92);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88)) * size;
            yOffset = Math.sin(rad + (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88)) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - (0, $84f61e7391a78632$export$56c0d5a1e737357d), rad - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), rad + (0, $84f61e7391a78632$export$56c0d5a1e737357d));
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
        /* falls through */ case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
        /* falls through */ case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += (0, $84f61e7391a78632$export$7a0bdf7d4a91ea88);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
}
function $4049e6bf31df43d6$var$calculateLabelSize(ctx, lines, fonts, strokeWidth) {
    ctx.save();
    const count = lines.length;
    let width = 0;
    let height = strokeWidth;
    for(let i = 0; i < count; i++){
        const font = fonts[Math.min(i, fonts.length - 1)];
        ctx.font = font.string;
        const text = lines[i];
        width = Math.max(width, ctx.measureText(text).width + strokeWidth);
        height += font.lineHeight;
    }
    ctx.restore();
    return {
        width: width,
        height: height
    };
}
function $4049e6bf31df43d6$var$applyLabelDecoration(ctx, { x: x, y: y }, labels, fonts) {
    ctx.beginPath();
    let lhs = 0;
    labels.forEach(function(l, i) {
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.font = f.string;
        ctx.strokeText(l, x, y + lh / 2 + lhs);
        lhs += lh;
    });
    ctx.stroke();
}
function $4049e6bf31df43d6$var$applyLabelContent(ctx, { x: x, y: y }, labels, { fonts: fonts, colors: colors }) {
    let lhs = 0;
    labels.forEach(function(l, i) {
        const c = colors[Math.min(i, colors.length - 1)];
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.beginPath();
        ctx.font = f.string;
        ctx.fillStyle = c;
        ctx.fillText(l, x, y + lh / 2 + lhs);
        lhs += lh;
        ctx.fill();
    });
}
function $4049e6bf31df43d6$var$getOpacity(value, elementValue) {
    const opacity = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(value) ? value : elementValue;
    return (0, $84f61e7391a78632$export$d141bba7fdc215a3)(opacity) ? $4049e6bf31df43d6$var$clamp(opacity, 0, 1) : 1;
}
const $4049e6bf31df43d6$var$positions = [
    'left',
    'bottom',
    'top',
    'right'
];
/**
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ /**
 * Drawa the callout component for labels.
 * @param {CanvasRenderingContext2D} ctx - chart canvas context
 * @param {AnnotationElement} element - the label element
 */ function $4049e6bf31df43d6$var$drawCallout(ctx, element) {
    const { pointX: pointX, pointY: pointY, options: options } = element;
    const callout = options.callout;
    const calloutPosition = callout && callout.display && $4049e6bf31df43d6$var$resolveCalloutPosition(element, callout);
    if (!calloutPosition || $4049e6bf31df43d6$var$isPointInRange(element, callout, calloutPosition)) return;
    ctx.save();
    ctx.beginPath();
    const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, callout);
    if (!stroke) return ctx.restore();
    const { separatorStart: separatorStart, separatorEnd: separatorEnd } = $4049e6bf31df43d6$var$getCalloutSeparatorCoord(element, calloutPosition);
    const { sideStart: sideStart, sideEnd: sideEnd } = $4049e6bf31df43d6$var$getCalloutSideCoord(element, calloutPosition, separatorStart);
    if (callout.margin > 0 || options.borderWidth === 0) {
        ctx.moveTo(separatorStart.x, separatorStart.y);
        ctx.lineTo(separatorEnd.x, separatorEnd.y);
    }
    ctx.moveTo(sideStart.x, sideStart.y);
    ctx.lineTo(sideEnd.x, sideEnd.y);
    const rotatedPoint = $4049e6bf31df43d6$var$rotated({
        x: pointX,
        y: pointY
    }, element.getCenterPoint(), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-element.rotation));
    ctx.lineTo(rotatedPoint.x, rotatedPoint.y);
    ctx.stroke();
    ctx.restore();
}
function $4049e6bf31df43d6$var$getCalloutSeparatorCoord(element, position) {
    const { x: x, y: y, x2: x2, y2: y2 } = element;
    const adjust = $4049e6bf31df43d6$var$getCalloutSeparatorAdjust(element, position);
    let separatorStart, separatorEnd;
    if (position === 'left' || position === 'right') {
        separatorStart = {
            x: x + adjust,
            y: y
        };
        separatorEnd = {
            x: separatorStart.x,
            y: y2
        };
    } else {
        //  position 'top' or 'bottom'
        separatorStart = {
            x: x,
            y: y + adjust
        };
        separatorEnd = {
            x: x2,
            y: separatorStart.y
        };
    }
    return {
        separatorStart: separatorStart,
        separatorEnd: separatorEnd
    };
}
function $4049e6bf31df43d6$var$getCalloutSeparatorAdjust(element, position) {
    const { width: width, height: height, options: options } = element;
    const adjust = options.callout.margin + options.borderWidth / 2;
    if (position === 'right') return width + adjust;
    else if (position === 'bottom') return height + adjust;
    return -adjust;
}
function $4049e6bf31df43d6$var$getCalloutSideCoord(element, position, separatorStart) {
    const { y: y, width: width, height: height, options: options } = element;
    const start = options.callout.start;
    const side = $4049e6bf31df43d6$var$getCalloutSideAdjust(position, options.callout);
    let sideStart, sideEnd;
    if (position === 'left' || position === 'right') {
        sideStart = {
            x: separatorStart.x,
            y: y + $4049e6bf31df43d6$var$getSize(height, start)
        };
        sideEnd = {
            x: sideStart.x + side,
            y: sideStart.y
        };
    } else {
        //  position 'top' or 'bottom'
        sideStart = {
            x: separatorStart.x + $4049e6bf31df43d6$var$getSize(width, start),
            y: separatorStart.y
        };
        sideEnd = {
            x: sideStart.x,
            y: sideStart.y + side
        };
    }
    return {
        sideStart: sideStart,
        sideEnd: sideEnd
    };
}
function $4049e6bf31df43d6$var$getCalloutSideAdjust(position, options) {
    const side = options.side;
    if (position === 'left' || position === 'top') return -side;
    return side;
}
function $4049e6bf31df43d6$var$resolveCalloutPosition(element, options) {
    const position = options.position;
    if ($4049e6bf31df43d6$var$positions.includes(position)) return position;
    return $4049e6bf31df43d6$var$resolveCalloutAutoPosition(element, options);
}
function $4049e6bf31df43d6$var$resolveCalloutAutoPosition(element, options) {
    const { x: x, y: y, x2: x2, y2: y2, width: width, height: height, pointX: pointX, pointY: pointY, centerX: centerX, centerY: centerY, rotation: rotation } = element;
    const center = {
        x: centerX,
        y: centerY
    };
    const start = options.start;
    const xAdjust = $4049e6bf31df43d6$var$getSize(width, start);
    const yAdjust = $4049e6bf31df43d6$var$getSize(height, start);
    const xPoints = [
        x,
        x + xAdjust,
        x + xAdjust,
        x2
    ];
    const yPoints = [
        y + yAdjust,
        y2,
        y,
        y2
    ];
    const result = [];
    for(let index = 0; index < 4; index++){
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: xPoints[index],
            y: yPoints[index]
        }, center, (0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation));
        result.push({
            position: $4049e6bf31df43d6$var$positions[index],
            distance: (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(rotatedPoint, {
                x: pointX,
                y: pointY
            })
        });
    }
    return result.sort((a, b)=>a.distance - b.distance)[0].position;
}
function $4049e6bf31df43d6$var$isPointInRange(element, callout, position) {
    const { pointX: pointX, pointY: pointY } = element;
    const margin = callout.margin;
    let x = pointX;
    let y = pointY;
    if (position === 'left') x += margin;
    else if (position === 'right') x -= margin;
    else if (position === 'top') y += margin;
    else if (position === 'bottom') y -= margin;
    return element.inRange(x, y);
}
const $4049e6bf31df43d6$var$limitedLineScale = {
    xScaleID: {
        min: 'xMin',
        max: 'xMax',
        start: 'left',
        end: 'right',
        startProp: 'x',
        endProp: 'x2'
    },
    yScaleID: {
        min: 'yMin',
        max: 'yMax',
        start: 'bottom',
        end: 'top',
        startProp: 'y',
        endProp: 'y2'
    }
};
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import("chart.js").Point } Point
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 * @typedef { import('../../types/options').LineAnnotationOptions } LineAnnotationOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 * @typedef { import('../../types/options').PolygonAnnotationOptions } PolygonAnnotationOptions
 */ /**
 * @param {Scale} scale
 * @param {number|string} value
 * @param {number} fallback
 * @returns {number}
 */ function $4049e6bf31df43d6$var$scaleValue(scale, value, fallback) {
    value = typeof value === 'number' ? value : scale.parse(value);
    return (0, $84f61e7391a78632$export$39b482c5e57630a8)(value) ? scale.getPixelForValue(value) : fallback;
}
/**
 * Search the scale defined in chartjs by the axis related to the annotation options key.
 * @param {{ [key: string]: Scale }} scales
 * @param {CoreAnnotationOptions} options
 * @param {string} key
 * @returns {string}
 */ function $4049e6bf31df43d6$var$retrieveScaleID(scales, options, key) {
    const scaleID = options[key];
    if (scaleID || key === 'scaleID') return scaleID;
    const axis = key.charAt(0);
    const axes = Object.values(scales).filter((scale)=>scale.axis && scale.axis === axis);
    if (axes.length) return axes[0].id;
    return axis;
}
/**
 * @param {Scale} scale
 * @param {{min: number, max: number, start: number, end: number}} options
 * @returns {{start: number, end: number}|undefined}
 */ function $4049e6bf31df43d6$var$getDimensionByScale(scale, options) {
    if (scale) {
        const reverse = scale.options.reverse;
        const start = $4049e6bf31df43d6$var$scaleValue(scale, options.min, reverse ? options.end : options.start);
        const end = $4049e6bf31df43d6$var$scaleValue(scale, options.max, reverse ? options.start : options.end);
        return {
            start: start,
            end: end
        };
    }
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {Point}
 */ function $4049e6bf31df43d6$var$getChartPoint(chart, options) {
    const { chartArea: chartArea, scales: scales } = chart;
    const xScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'yScaleID')];
    let x = chartArea.width / 2;
    let y = chartArea.height / 2;
    if (xScale) x = $4049e6bf31df43d6$var$scaleValue(xScale, options.xValue, xScale.left + xScale.width / 2);
    if (yScale) y = $4049e6bf31df43d6$var$scaleValue(yScale, options.yValue, yScale.top + yScale.height / 2);
    return {
        x: x,
        y: y
    };
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveBoxProperties(chart, options) {
    const scales = chart.scales;
    const xScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, 'yScaleID')];
    if (!xScale && !yScale) return {};
    let { left: x, right: x2 } = xScale || chart.chartArea;
    let { top: y, bottom: y2 } = yScale || chart.chartArea;
    const xDim = $4049e6bf31df43d6$var$getChartDimensionByScale(xScale, {
        min: options.xMin,
        max: options.xMax,
        start: x,
        end: x2
    });
    x = xDim.start;
    x2 = xDim.end;
    const yDim = $4049e6bf31df43d6$var$getChartDimensionByScale(yScale, {
        min: options.yMin,
        max: options.yMax,
        start: y2,
        end: y
    });
    y = yDim.start;
    y2 = yDim.end;
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: x2 - x,
        height: y2 - y,
        centerX: x + (x2 - x) / 2,
        centerY: y + (y2 - y) / 2
    };
}
/**
 * @param {Chart} chart
 * @param {PointAnnotationOptions|PolygonAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolvePointProperties(chart, options) {
    if (!$4049e6bf31df43d6$var$isBoundToPoint(options)) {
        const box = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
        let radius = options.radius;
        if (!radius || isNaN(radius)) {
            radius = Math.min(box.width, box.height) / 2;
            options.radius = radius;
        }
        const size = radius * 2;
        const adjustCenterX = box.centerX + options.xAdjust;
        const adjustCenterY = box.centerY + options.yAdjust;
        return {
            x: adjustCenterX - radius,
            y: adjustCenterY - radius,
            x2: adjustCenterX + radius,
            y2: adjustCenterY + radius,
            centerX: adjustCenterX,
            centerY: adjustCenterY,
            width: size,
            height: size,
            radius: radius
        };
    }
    return $4049e6bf31df43d6$var$getChartCircle(chart, options);
}
/**
 * @param {Chart} chart
 * @param {LineAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveLineProperties(chart, options) {
    const { scales: scales, chartArea: chartArea } = chart;
    const scale = scales[options.scaleID];
    const area = {
        x: chartArea.left,
        y: chartArea.top,
        x2: chartArea.right,
        y2: chartArea.bottom
    };
    if (scale) $4049e6bf31df43d6$var$resolveFullLineProperties(scale, area, options);
    else $4049e6bf31df43d6$var$resolveLimitedLineProperties(scales, area, options);
    return area;
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @param {boolean} [centerBased=false]
 * @returns {AnnotationBoxModel}
 */ function $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options) {
    const properties = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
    properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
    properties.elements = [
        {
            type: 'label',
            optionScope: 'label',
            properties: $4049e6bf31df43d6$var$resolveLabelElementProperties$1(chart, properties, options),
            initProperties: properties.initProperties
        }
    ];
    return properties;
}
function $4049e6bf31df43d6$var$getChartCircle(chart, options) {
    const point = $4049e6bf31df43d6$var$getChartPoint(chart, options);
    const size = options.radius * 2;
    return {
        x: point.x - options.radius + options.xAdjust,
        y: point.y - options.radius + options.yAdjust,
        x2: point.x + options.radius + options.xAdjust,
        y2: point.y + options.radius + options.yAdjust,
        centerX: point.x + options.xAdjust,
        centerY: point.y + options.yAdjust,
        radius: options.radius,
        width: size,
        height: size
    };
}
function $4049e6bf31df43d6$var$getChartDimensionByScale(scale, options) {
    const result = $4049e6bf31df43d6$var$getDimensionByScale(scale, options) || options;
    return {
        start: Math.min(result.start, result.end),
        end: Math.max(result.start, result.end)
    };
}
function $4049e6bf31df43d6$var$resolveFullLineProperties(scale, area, options) {
    const min = $4049e6bf31df43d6$var$scaleValue(scale, options.value, NaN);
    const max = $4049e6bf31df43d6$var$scaleValue(scale, options.endValue, min);
    if (scale.isHorizontal()) {
        area.x = min;
        area.x2 = max;
    } else {
        area.y = min;
        area.y2 = max;
    }
}
function $4049e6bf31df43d6$var$resolveLimitedLineProperties(scales, area, options) {
    for (const scaleId of Object.keys($4049e6bf31df43d6$var$limitedLineScale)){
        const scale = scales[$4049e6bf31df43d6$var$retrieveScaleID(scales, options, scaleId)];
        if (scale) {
            const { min: min, max: max, start: start, end: end, startProp: startProp, endProp: endProp } = $4049e6bf31df43d6$var$limitedLineScale[scaleId];
            const dim = $4049e6bf31df43d6$var$getDimensionByScale(scale, {
                min: options[min],
                max: options[max],
                start: scale[start],
                end: scale[end]
            });
            area[startProp] = dim.start;
            area[endProp] = dim.end;
        }
    }
}
function $4049e6bf31df43d6$var$calculateX({ properties: properties, options: options }, labelSize, position, padding) {
    const { x: start, x2: end, width: size } = properties;
    return $4049e6bf31df43d6$var$calculatePosition({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.x,
        padding: {
            start: padding.left,
            end: padding.right
        },
        adjust: options.label.xAdjust,
        size: labelSize.width
    });
}
function $4049e6bf31df43d6$var$calculateY({ properties: properties, options: options }, labelSize, position, padding) {
    const { y: start, y2: end, height: size } = properties;
    return $4049e6bf31df43d6$var$calculatePosition({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.y,
        padding: {
            start: padding.top,
            end: padding.bottom
        },
        adjust: options.label.yAdjust,
        size: labelSize.height
    });
}
function $4049e6bf31df43d6$var$calculatePosition(boxOpts, labelOpts) {
    const { start: start, end: end, borderWidth: borderWidth } = boxOpts;
    const { position: position, padding: { start: padStart, end: padEnd }, adjust: adjust } = labelOpts;
    const availableSize = end - borderWidth - start - padStart - padEnd - labelOpts.size;
    return start + borderWidth / 2 + adjust + $4049e6bf31df43d6$var$getRelativePosition(availableSize, position);
}
function $4049e6bf31df43d6$var$resolveLabelElementProperties$1(chart, properties, options) {
    const label = options.label;
    label.backgroundColor = 'transparent';
    label.callout.display = false;
    const position = $4049e6bf31df43d6$var$toPosition(label.position);
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(label.padding);
    const labelSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, label);
    const x = $4049e6bf31df43d6$var$calculateX({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const y = $4049e6bf31df43d6$var$calculateY({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const width = labelSize.width + padding.width;
    const height = labelSize.height + padding.height;
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2,
        rotation: label.rotation
    };
}
const $4049e6bf31df43d6$var$moveHooks = [
    'enter',
    'leave'
];
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ const $4049e6bf31df43d6$var$eventHooks = $4049e6bf31df43d6$var$moveHooks.concat('click');
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $4049e6bf31df43d6$var$updateListeners(chart, state, options) {
    state.listened = $4049e6bf31df43d6$var$loadHooks(options, $4049e6bf31df43d6$var$eventHooks, state.listeners);
    state.moveListened = false;
    $4049e6bf31df43d6$var$moveHooks.forEach((hook)=>{
        if ((0, $84f61e7391a78632$export$a93c5207d687da10)(options[hook])) state.moveListened = true;
    });
    if (!state.listened || !state.moveListened) state.annotations.forEach((scope)=>{
        if (!state.listened && (0, $84f61e7391a78632$export$a93c5207d687da10)(scope.click)) state.listened = true;
        if (!state.moveListened) $4049e6bf31df43d6$var$moveHooks.forEach((hook)=>{
            if ((0, $84f61e7391a78632$export$a93c5207d687da10)(scope[hook])) {
                state.listened = true;
                state.moveListened = true;
            }
        });
    });
}
/**
 * @param {Object} state
 * @param {ChartEvent} event
 * @param {AnnotationPluginOptions} options
 * @return {boolean|undefined}
 */ function $4049e6bf31df43d6$var$handleEvent(state, event, options) {
    if (state.listened) switch(event.type){
        case 'mousemove':
        case 'mouseout':
            return $4049e6bf31df43d6$var$handleMoveEvents(state, event, options);
        case 'click':
            return $4049e6bf31df43d6$var$handleClickEvents(state, event, options);
    }
}
function $4049e6bf31df43d6$var$handleMoveEvents(state, event, options) {
    if (!state.moveListened) return;
    let elements;
    if (event.type === 'mousemove') elements = $4049e6bf31df43d6$var$getElements(state.visibleElements, event, options.interaction);
    else elements = [];
    const previous = state.hovered;
    state.hovered = elements;
    const context = {
        state: state,
        event: event
    };
    let changed = $4049e6bf31df43d6$var$dispatchMoveEvents(context, 'leave', previous, elements);
    return $4049e6bf31df43d6$var$dispatchMoveEvents(context, 'enter', elements, previous) || changed;
}
function $4049e6bf31df43d6$var$dispatchMoveEvents({ state: state, event: event }, hook, elements, checkElements) {
    let changed;
    for (const element of elements)if (checkElements.indexOf(element) < 0) changed = $4049e6bf31df43d6$var$dispatchEvent(element.options[hook] || state.listeners[hook], element, event) || changed;
    return changed;
}
function $4049e6bf31df43d6$var$handleClickEvents(state, event, options) {
    const listeners = state.listeners;
    const elements = $4049e6bf31df43d6$var$getElements(state.visibleElements, event, options.interaction);
    let changed;
    for (const element of elements)changed = $4049e6bf31df43d6$var$dispatchEvent(element.options.click || listeners.click, element, event) || changed;
    return changed;
}
function $4049e6bf31df43d6$var$dispatchEvent(handler, element, event) {
    return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(handler, [
        element.$context,
        event
    ]) === true;
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $4049e6bf31df43d6$var$elementHooks = [
    'afterDraw',
    'beforeDraw'
];
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $4049e6bf31df43d6$var$updateHooks(chart, state, options) {
    const visibleElements = state.visibleElements;
    state.hooked = $4049e6bf31df43d6$var$loadHooks(options, $4049e6bf31df43d6$var$elementHooks, state.hooks);
    if (!state.hooked) visibleElements.forEach((scope)=>{
        if (!state.hooked) $4049e6bf31df43d6$var$elementHooks.forEach((hook)=>{
            if ((0, $84f61e7391a78632$export$a93c5207d687da10)(scope.options[hook])) state.hooked = true;
        });
    });
}
/**
 * @param {Object} state
 * @param {AnnotationElement} element
 * @param {string} hook
 */ function $4049e6bf31df43d6$var$invokeHook(state, element, hook) {
    if (state.hooked) {
        const callbackHook = element.options[hook] || state.hooks[hook];
        return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(callbackHook, [
            element.$context
        ]);
    }
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 */ /**
 * @param {Chart} chart
 * @param {Scale} scale
 * @param {CoreAnnotationOptions[]} annotations
 */ function $4049e6bf31df43d6$var$adjustScaleRange(chart, scale, annotations) {
    const range = $4049e6bf31df43d6$var$getScaleLimits(chart.scales, scale, annotations);
    let changed = $4049e6bf31df43d6$var$changeScaleLimit(scale, range, 'min', 'suggestedMin');
    changed = $4049e6bf31df43d6$var$changeScaleLimit(scale, range, 'max', 'suggestedMax') || changed;
    if (changed && (0, $84f61e7391a78632$export$a93c5207d687da10)(scale.handleTickRangeOptions)) scale.handleTickRangeOptions();
}
/**
 * @param {CoreAnnotationOptions[]} annotations
 * @param {{ [key: string]: Scale }} scales
 */ function $4049e6bf31df43d6$var$verifyScaleOptions(annotations, scales) {
    for (const annotation of annotations)$4049e6bf31df43d6$var$verifyScaleIDs(annotation, scales);
}
function $4049e6bf31df43d6$var$changeScaleLimit(scale, range, limit, suggestedLimit) {
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(range[limit]) && !$4049e6bf31df43d6$var$scaleLimitDefined(scale.options, limit, suggestedLimit)) {
        const changed = scale[limit] !== range[limit];
        scale[limit] = range[limit];
        return changed;
    }
}
function $4049e6bf31df43d6$var$scaleLimitDefined(scaleOptions, limit, suggestedLimit) {
    return (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(scaleOptions[limit]) || (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(scaleOptions[suggestedLimit]);
}
function $4049e6bf31df43d6$var$verifyScaleIDs(annotation, scales) {
    for (const key of [
        'scaleID',
        'xScaleID',
        'yScaleID'
    ]){
        const scaleID = $4049e6bf31df43d6$var$retrieveScaleID(scales, annotation, key);
        if (scaleID && !scales[scaleID] && $4049e6bf31df43d6$var$verifyProperties(annotation, key)) console.warn(`No scale found with id '${scaleID}' for annotation '${annotation.id}'`);
    }
}
function $4049e6bf31df43d6$var$verifyProperties(annotation, key) {
    if (key === 'scaleID') return true;
    const axis = key.charAt(0);
    for (const prop of [
        'Min',
        'Max',
        'Value'
    ]){
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(annotation[axis + prop])) return true;
    }
    return false;
}
function $4049e6bf31df43d6$var$getScaleLimits(scales, scale, annotations) {
    const axis = scale.axis;
    const scaleID = scale.id;
    const scaleIDOption = axis + 'ScaleID';
    const limits = {
        min: (0, $84f61e7391a78632$export$90a7f3efeed30595)(scale.min, Number.NEGATIVE_INFINITY),
        max: (0, $84f61e7391a78632$export$90a7f3efeed30595)(scale.max, Number.POSITIVE_INFINITY)
    };
    for (const annotation of annotations){
        if (annotation.scaleID === scaleID) $4049e6bf31df43d6$var$updateLimits(annotation, scale, [
            'value',
            'endValue'
        ], limits);
        else if ($4049e6bf31df43d6$var$retrieveScaleID(scales, annotation, scaleIDOption) === scaleID) $4049e6bf31df43d6$var$updateLimits(annotation, scale, [
            axis + 'Min',
            axis + 'Max',
            axis + 'Value'
        ], limits);
    }
    return limits;
}
function $4049e6bf31df43d6$var$updateLimits(annotation, scale, props, limits) {
    for (const prop of props){
        const raw = annotation[prop];
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(raw)) {
            const value = scale.parse(raw);
            limits.min = Math.min(limits.min, value);
            limits.max = Math.max(limits.max, value);
        }
    }
}
class $4049e6bf31df43d6$var$BoxAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y } = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-this.options.rotation));
        return $4049e6bf31df43d6$var$inBoxRange({
            x: x,
            y: y
        }, this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition), axis, this.options);
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), this.options.rotation);
        $4049e6bf31df43d6$var$drawBox(ctx, this, this.options);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options);
    }
}
$4049e6bf31df43d6$var$BoxAnnotation.id = 'boxAnnotation';
$4049e6bf31df43d6$var$BoxAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    hitTolerance: 0,
    label: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        callout: {
            display: false
        },
        color: 'black',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        hitTolerance: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: undefined,
        textAlign: 'start',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$BoxAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$4049e6bf31df43d6$var$BoxAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
class $4049e6bf31df43d6$var$DoughnutLabelAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        return $4049e6bf31df43d6$var$inLabelRange({
            x: mouseX,
            y: mouseY
        }, {
            rect: this.getProps([
                'x',
                'y',
                'x2',
                'y2'
            ], useFinalPosition),
            center: this.getCenterPoint(useFinalPosition)
        }, axis, {
            rotation: this.rotation,
            borderWidth: 0,
            hitTolerance: this.options.hitTolerance
        });
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        if (!options.display || !options.content) return;
        $4049e6bf31df43d6$var$drawBackground(ctx, this);
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), this.rotation);
        $4049e6bf31df43d6$var$drawLabel(ctx, this, options, this._fitRatio);
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        const meta = $4049e6bf31df43d6$var$getDatasetMeta(chart, options);
        if (!meta) return {};
        const { controllerMeta: controllerMeta, point: point, radius: radius } = $4049e6bf31df43d6$var$getControllerMeta(chart, options, meta);
        let labelSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, options);
        const _fitRatio = $4049e6bf31df43d6$var$getFitRatio(labelSize, radius);
        if ($4049e6bf31df43d6$var$shouldFit(options, _fitRatio)) labelSize = {
            width: labelSize.width * _fitRatio,
            height: labelSize.height * _fitRatio
        };
        const { position: position, xAdjust: xAdjust, yAdjust: yAdjust } = options;
        const boxSize = $4049e6bf31df43d6$var$measureLabelRectangle(point, labelSize, {
            borderWidth: 0,
            position: position,
            xAdjust: xAdjust,
            yAdjust: yAdjust
        });
        return {
            initProperties: $4049e6bf31df43d6$var$initAnimationProperties(chart, boxSize, options),
            ...boxSize,
            ...controllerMeta,
            rotation: options.rotation,
            _fitRatio: _fitRatio
        };
    }
}
$4049e6bf31df43d6$var$DoughnutLabelAnnotation.id = 'doughnutLabelAnnotation';
$4049e6bf31df43d6$var$DoughnutLabelAnnotation.defaults = {
    autoFit: true,
    autoHide: true,
    backgroundColor: 'transparent',
    backgroundShadowColor: 'transparent',
    borderColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderShadowColor: 'transparent',
    borderWidth: 0,
    color: 'black',
    content: null,
    display: true,
    font: {
        family: undefined,
        lineHeight: undefined,
        size: undefined,
        style: undefined,
        weight: undefined
    },
    height: undefined,
    hitTolerance: 0,
    init: undefined,
    opacity: undefined,
    position: 'center',
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    spacing: 1,
    textAlign: 'center',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    width: undefined,
    xAdjust: 0,
    yAdjust: 0
};
$4049e6bf31df43d6$var$DoughnutLabelAnnotation.defaultRoutes = {};
function $4049e6bf31df43d6$var$getDatasetMeta(chart, options) {
    return chart.getSortedVisibleDatasetMetas().reduce(function(result, value) {
        const controller = value.controller;
        if (controller instanceof (0, $216d2bdc6f281bf6$export$e04603e7d8b77172) && $4049e6bf31df43d6$var$isControllerVisible(chart, options, value.data) && (!result || controller.innerRadius < result.controller.innerRadius) && controller.options.circumference >= 90) return value;
        return result;
    }, undefined);
}
function $4049e6bf31df43d6$var$isControllerVisible(chart, options, elements) {
    if (!options.autoHide) return true;
    for(let i = 0; i < elements.length; i++){
        if (!elements[i].hidden && chart.getDataVisibility(i)) return true;
    }
}
function $4049e6bf31df43d6$var$getControllerMeta({ chartArea: chartArea }, options, meta) {
    const { left: left, top: top, right: right, bottom: bottom } = chartArea;
    const { innerRadius: innerRadius, offsetX: offsetX, offsetY: offsetY } = meta.controller;
    const x = (left + right) / 2 + offsetX;
    const y = (top + bottom) / 2 + offsetY;
    const square = {
        left: Math.max(x - innerRadius, left),
        right: Math.min(x + innerRadius, right),
        top: Math.max(y - innerRadius, top),
        bottom: Math.min(y + innerRadius, bottom)
    };
    const point = {
        x: (square.left + square.right) / 2,
        y: (square.top + square.bottom) / 2
    };
    const space = options.spacing + options.borderWidth / 2;
    const _radius = innerRadius - space;
    const _counterclockwise = point.y > y;
    const side = _counterclockwise ? top + space : bottom - space;
    const angles = $4049e6bf31df43d6$var$getAngles(side, x, y, _radius);
    const controllerMeta = {
        _centerX: x,
        _centerY: y,
        _radius: _radius,
        _counterclockwise: _counterclockwise,
        ...angles
    };
    return {
        controllerMeta: controllerMeta,
        point: point,
        radius: Math.min(innerRadius, Math.min(square.right - square.left, square.bottom - square.top) / 2)
    };
}
function $4049e6bf31df43d6$var$getFitRatio({ width: width, height: height }, radius) {
    const hypo = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
    return radius * 2 / hypo;
}
function $4049e6bf31df43d6$var$getAngles(y, centerX, centerY, radius) {
    const yk2 = Math.pow(centerY - y, 2);
    const r2 = Math.pow(radius, 2);
    const b = centerX * -2;
    const c = Math.pow(centerX, 2) + yk2 - r2;
    const delta = Math.pow(b, 2) - 4 * c;
    if (delta <= 0) return {
        _startAngle: 0,
        _endAngle: (0, $84f61e7391a78632$export$971d5caa766a69d7)
    };
    const start = (-b - Math.sqrt(delta)) / 2;
    const end = (-b + Math.sqrt(delta)) / 2;
    return {
        _startAngle: (0, $84f61e7391a78632$export$96f57966bedc81b4)({
            x: centerX,
            y: centerY
        }, {
            x: start,
            y: y
        }).angle,
        _endAngle: (0, $84f61e7391a78632$export$96f57966bedc81b4)({
            x: centerX,
            y: centerY
        }, {
            x: end,
            y: y
        }).angle
    };
}
function $4049e6bf31df43d6$var$drawBackground(ctx, element) {
    const { _centerX: _centerX, _centerY: _centerY, _radius: _radius, _startAngle: _startAngle, _endAngle: _endAngle, _counterclockwise: _counterclockwise, options: options } = element;
    ctx.save();
    const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
    ctx.fillStyle = options.backgroundColor;
    ctx.beginPath();
    ctx.arc(_centerX, _centerY, _radius, _startAngle, _endAngle, _counterclockwise);
    ctx.closePath();
    ctx.fill();
    if (stroke) ctx.stroke();
    ctx.restore();
}
class $4049e6bf31df43d6$var$LabelAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        return $4049e6bf31df43d6$var$inLabelRange({
            x: mouseX,
            y: mouseY
        }, {
            rect: this.getProps([
                'x',
                'y',
                'x2',
                'y2'
            ], useFinalPosition),
            center: this.getCenterPoint(useFinalPosition)
        }, axis, {
            rotation: this.rotation,
            borderWidth: this.options.borderWidth,
            hitTolerance: this.options.hitTolerance
        });
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const visible = !(0, $84f61e7391a78632$export$dda1d9f60106f0e9)(this._visible) || this._visible;
        if (!options.display || !options.content || !visible) return;
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), this.rotation);
        $4049e6bf31df43d6$var$drawCallout(ctx, this);
        $4049e6bf31df43d6$var$drawBox(ctx, this, options);
        $4049e6bf31df43d6$var$drawLabel(ctx, $4049e6bf31df43d6$var$getLabelSize(this), options);
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        let point;
        if (!$4049e6bf31df43d6$var$isBoundToPoint(options)) {
            const { centerX: centerX, centerY: centerY } = $4049e6bf31df43d6$var$resolveBoxProperties(chart, options);
            point = {
                x: centerX,
                y: centerY
            };
        } else point = $4049e6bf31df43d6$var$getChartPoint(chart, options);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
        const labelSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, options);
        const boxSize = $4049e6bf31df43d6$var$measureLabelRectangle(point, labelSize, options, padding);
        return {
            initProperties: $4049e6bf31df43d6$var$initAnimationProperties(chart, boxSize, options),
            pointX: point.x,
            pointY: point.y,
            ...boxSize,
            rotation: options.rotation
        };
    }
}
$4049e6bf31df43d6$var$LabelAnnotation.id = 'labelAnnotation';
$4049e6bf31df43d6$var$LabelAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundColor: 'transparent',
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 0,
    callout: {
        borderCapStyle: 'butt',
        borderColor: undefined,
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 1,
        display: false,
        margin: 5,
        position: 'auto',
        side: 5,
        start: '50%'
    },
    color: 'black',
    content: null,
    display: true,
    font: {
        family: undefined,
        lineHeight: undefined,
        size: undefined,
        style: undefined,
        weight: undefined
    },
    height: undefined,
    hitTolerance: 0,
    init: undefined,
    opacity: undefined,
    padding: 6,
    position: 'center',
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: 'center',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    width: undefined,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$LabelAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $4049e6bf31df43d6$var$getLabelSize({ x: x, y: y, width: width, height: height, options: options }) {
    const hBorderWidth = options.borderWidth / 2;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    return {
        x: x + padding.left + hBorderWidth,
        y: y + padding.top + hBorderWidth,
        width: width - padding.left - padding.right - options.borderWidth,
        height: height - padding.top - padding.bottom - options.borderWidth
    };
}
const $4049e6bf31df43d6$var$pointInLine = (p1, p2, t)=>({
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    });
const $4049e6bf31df43d6$var$interpolateX = (y, p1, p2)=>$4049e6bf31df43d6$var$pointInLine(p1, p2, Math.abs((y - p1.y) / (p2.y - p1.y))).x;
const $4049e6bf31df43d6$var$interpolateY = (x, p1, p2)=>$4049e6bf31df43d6$var$pointInLine(p1, p2, Math.abs((x - p1.x) / (p2.x - p1.x))).y;
const $4049e6bf31df43d6$var$sqr = (v)=>v * v;
const $4049e6bf31df43d6$var$rangeLimit = (mouseX, mouseY, { x: x, y: y, x2: x2, y2: y2 }, axis)=>axis === 'y' ? {
        start: Math.min(y, y2),
        end: Math.max(y, y2),
        value: mouseY
    } : {
        start: Math.min(x, x2),
        end: Math.max(x, x2),
        value: mouseX
    };
// http://www.independent-software.com/determining-coordinates-on-a-html-canvas-bezier-curve.html
const $4049e6bf31df43d6$var$coordInCurve = (start, cp, end, t)=>(1 - t) * (1 - t) * start + 2 * (1 - t) * t * cp + t * t * end;
const $4049e6bf31df43d6$var$pointInCurve = (start, cp, end, t)=>({
        x: $4049e6bf31df43d6$var$coordInCurve(start.x, cp.x, end.x, t),
        y: $4049e6bf31df43d6$var$coordInCurve(start.y, cp.y, end.y, t)
    });
const $4049e6bf31df43d6$var$coordAngleInCurve = (start, cp, end, t)=>2 * (1 - t) * (cp - start) + 2 * t * (end - cp);
const $4049e6bf31df43d6$var$angleInCurve = (start, cp, end, t)=>-Math.atan2($4049e6bf31df43d6$var$coordAngleInCurve(start.x, cp.x, end.x, t), $4049e6bf31df43d6$var$coordAngleInCurve(start.y, cp.y, end.y, t)) + 0.5 * (0, $84f61e7391a78632$export$56c0d5a1e737357d);
class $4049e6bf31df43d6$var$LineAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') {
            const point = {
                mouseX: mouseX,
                mouseY: mouseY
            };
            const { path: path, ctx: ctx } = this;
            if (path) {
                $4049e6bf31df43d6$var$setBorderStyle(ctx, this.options);
                ctx.lineWidth += this.options.hitTolerance;
                const { chart: chart } = this.$context;
                const mx = mouseX * chart.currentDevicePixelRatio;
                const my = mouseY * chart.currentDevicePixelRatio;
                const result = ctx.isPointInStroke(path, mx, my) || $4049e6bf31df43d6$var$isOnLabel(this, point, useFinalPosition);
                ctx.restore();
                return result;
            }
            const epsilon = $4049e6bf31df43d6$var$sqr(hitSize);
            return $4049e6bf31df43d6$var$intersects(this, point, epsilon, useFinalPosition) || $4049e6bf31df43d6$var$isOnLabel(this, point, useFinalPosition);
        }
        return $4049e6bf31df43d6$var$inAxisRange(this, {
            mouseX: mouseX,
            mouseY: mouseY
        }, axis, {
            hitSize: hitSize,
            useFinalPosition: useFinalPosition
        });
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { x: x, y: y, x2: x2, y2: y2, cp: cp, options: options } = this;
        ctx.save();
        if (!$4049e6bf31df43d6$var$setBorderStyle(ctx, options)) // no border width, then line is not drawn
        return ctx.restore();
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const length = Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
        if (options.curve && cp) {
            $4049e6bf31df43d6$var$drawCurve(ctx, this, cp, length);
            return ctx.restore();
        }
        const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $4049e6bf31df43d6$var$getArrowHeads(this);
        const angle = Math.atan2(y2 - y, x2 - x);
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(0 + startAdjust, 0);
        ctx.lineTo(length - endAdjust, 0);
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
        $4049e6bf31df43d6$var$drawArrowHead(ctx, 0, startAdjust, startOpts);
        $4049e6bf31df43d6$var$drawArrowHead(ctx, length, -endAdjust, endOpts);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        const area = $4049e6bf31df43d6$var$resolveLineProperties(chart, options);
        const { x: x, y: y, x2: x2, y2: y2 } = area;
        const inside = $4049e6bf31df43d6$var$isLineInArea(area, chart.chartArea);
        const properties = inside ? $4049e6bf31df43d6$var$limitLineToArea({
            x: x,
            y: y
        }, {
            x: x2,
            y: y2
        }, chart.chartArea) : {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: Math.abs(x2 - x),
            height: Math.abs(y2 - y)
        };
        properties.centerX = (x2 + x) / 2;
        properties.centerY = (y2 + y) / 2;
        properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
        if (options.curve) {
            const p1 = {
                x: properties.x,
                y: properties.y
            };
            const p2 = {
                x: properties.x2,
                y: properties.y2
            };
            properties.cp = $4049e6bf31df43d6$var$getControlPoint(properties, options, (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(p1, p2));
        }
        const labelProperties = $4049e6bf31df43d6$var$resolveLabelElementProperties(chart, properties, options.label);
        // additonal prop to manage zoom/pan
        labelProperties._visible = inside;
        properties.elements = [
            {
                type: 'label',
                optionScope: 'label',
                properties: labelProperties,
                initProperties: properties.initProperties
            }
        ];
        return properties;
    }
}
$4049e6bf31df43d6$var$LineAnnotation.id = 'lineAnnotation';
const $4049e6bf31df43d6$var$arrowHeadsDefaults = {
    backgroundColor: undefined,
    backgroundShadowColor: undefined,
    borderColor: undefined,
    borderDash: undefined,
    borderDashOffset: undefined,
    borderShadowColor: undefined,
    borderWidth: undefined,
    display: undefined,
    fill: undefined,
    length: undefined,
    shadowBlur: undefined,
    shadowOffsetX: undefined,
    shadowOffsetY: undefined,
    width: undefined
};
$4049e6bf31df43d6$var$LineAnnotation.defaults = {
    adjustScaleRange: true,
    arrowHeads: {
        display: false,
        end: Object.assign({}, $4049e6bf31df43d6$var$arrowHeadsDefaults),
        fill: false,
        length: 12,
        start: Object.assign({}, $4049e6bf31df43d6$var$arrowHeadsDefaults),
        width: 6
    },
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 2,
    curve: false,
    controlPoint: {
        y: '-50%'
    },
    display: true,
    endValue: undefined,
    init: undefined,
    hitTolerance: 0,
    label: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        backgroundShadowColor: 'transparent',
        borderCapStyle: 'butt',
        borderColor: 'black',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderRadius: 6,
        borderShadowColor: 'transparent',
        borderWidth: 0,
        callout: Object.assign({}, $4049e6bf31df43d6$var$LabelAnnotation.defaults.callout),
        color: '#fff',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        hitTolerance: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: 0,
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        textAlign: 'center',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    scaleID: undefined,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    value: undefined,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$LineAnnotation.descriptors = {
    arrowHeads: {
        start: {
            _fallback: true
        },
        end: {
            _fallback: true
        },
        _fallback: true
    }
};
$4049e6bf31df43d6$var$LineAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $4049e6bf31df43d6$var$inAxisRange(element, { mouseX: mouseX, mouseY: mouseY }, axis, { hitSize: hitSize, useFinalPosition: useFinalPosition }) {
    const limit = $4049e6bf31df43d6$var$rangeLimit(mouseX, mouseY, element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition), axis);
    return $4049e6bf31df43d6$var$inLimit(limit, hitSize) || $4049e6bf31df43d6$var$isOnLabel(element, {
        mouseX: mouseX,
        mouseY: mouseY
    }, useFinalPosition, axis);
}
function $4049e6bf31df43d6$var$isLineInArea({ x: x, y: y, x2: x2, y2: y2 }, { top: top, right: right, bottom: bottom, left: left }) {
    return !(x < left && x2 < left || x > right && x2 > right || y < top && y2 < top || y > bottom && y2 > bottom);
}
function $4049e6bf31df43d6$var$limitPointToArea({ x: x, y: y }, p2, { top: top, right: right, bottom: bottom, left: left }) {
    if (x < left) {
        y = $4049e6bf31df43d6$var$interpolateY(left, {
            x: x,
            y: y
        }, p2);
        x = left;
    }
    if (x > right) {
        y = $4049e6bf31df43d6$var$interpolateY(right, {
            x: x,
            y: y
        }, p2);
        x = right;
    }
    if (y < top) {
        x = $4049e6bf31df43d6$var$interpolateX(top, {
            x: x,
            y: y
        }, p2);
        y = top;
    }
    if (y > bottom) {
        x = $4049e6bf31df43d6$var$interpolateX(bottom, {
            x: x,
            y: y
        }, p2);
        y = bottom;
    }
    return {
        x: x,
        y: y
    };
}
function $4049e6bf31df43d6$var$limitLineToArea(p1, p2, area) {
    const { x: x, y: y } = $4049e6bf31df43d6$var$limitPointToArea(p1, p2, area);
    const { x: x2, y: y2 } = $4049e6bf31df43d6$var$limitPointToArea(p2, p1, area);
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: Math.abs(x2 - x),
        height: Math.abs(y2 - y)
    };
}
function $4049e6bf31df43d6$var$intersects(element, { mouseX: mouseX, mouseY: mouseY }, epsilon = $4049e6bf31df43d6$var$EPSILON, useFinalPosition) {
    // Adapted from https://stackoverflow.com/a/6853926/25507
    const { x: x1, y: y1, x2: x2, y2: y2 } = element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lenSq = $4049e6bf31df43d6$var$sqr(dx) + $4049e6bf31df43d6$var$sqr(dy);
    const t = lenSq === 0 ? -1 : ((mouseX - x1) * dx + (mouseY - y1) * dy) / lenSq;
    let xx, yy;
    if (t < 0) {
        xx = x1;
        yy = y1;
    } else if (t > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + t * dx;
        yy = y1 + t * dy;
    }
    return $4049e6bf31df43d6$var$sqr(mouseX - xx) + $4049e6bf31df43d6$var$sqr(mouseY - yy) <= epsilon;
}
function $4049e6bf31df43d6$var$isOnLabel(element, { mouseX: mouseX, mouseY: mouseY }, useFinalPosition, axis) {
    const label = element.label;
    return label.options.display && label.inRange(mouseX, mouseY, axis, useFinalPosition);
}
function $4049e6bf31df43d6$var$resolveLabelElementProperties(chart, properties, options) {
    const borderWidth = options.borderWidth;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    const textSize = $4049e6bf31df43d6$var$measureLabelSize(chart.ctx, options);
    const width = textSize.width + padding.width + borderWidth;
    const height = textSize.height + padding.height + borderWidth;
    return $4049e6bf31df43d6$var$calculateLabelPosition(properties, options, {
        width: width,
        height: height,
        padding: padding
    }, chart.chartArea);
}
function $4049e6bf31df43d6$var$calculateAutoRotation(properties) {
    const { x: x, y: y, x2: x2, y2: y2 } = properties;
    const rotation = Math.atan2(y2 - y, x2 - x);
    // Flip the rotation if it goes > PI/2 or < -PI/2, so label stays upright
    return rotation > (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2 ? rotation - (0, $84f61e7391a78632$export$56c0d5a1e737357d) : rotation < (0, $84f61e7391a78632$export$56c0d5a1e737357d) / -2 ? rotation + (0, $84f61e7391a78632$export$56c0d5a1e737357d) : rotation;
}
function $4049e6bf31df43d6$var$calculateLabelPosition(properties, label, sizes, chartArea) {
    const { width: width, height: height, padding: padding } = sizes;
    const { xAdjust: xAdjust, yAdjust: yAdjust } = label;
    const p1 = {
        x: properties.x,
        y: properties.y
    };
    const p2 = {
        x: properties.x2,
        y: properties.y2
    };
    const rotation = label.rotation === 'auto' ? $4049e6bf31df43d6$var$calculateAutoRotation(properties) : (0, $84f61e7391a78632$export$625550452a3fa3ec)(label.rotation);
    const size = $4049e6bf31df43d6$var$rotatedSize(width, height, rotation);
    const t = $4049e6bf31df43d6$var$calculateT(properties, label, {
        labelSize: size,
        padding: padding
    }, chartArea);
    const pt = properties.cp ? $4049e6bf31df43d6$var$pointInCurve(p1, properties.cp, p2, t) : $4049e6bf31df43d6$var$pointInLine(p1, p2, t);
    const xCoordinateSizes = {
        size: size.w,
        min: chartArea.left,
        max: chartArea.right,
        padding: padding.left
    };
    const yCoordinateSizes = {
        size: size.h,
        min: chartArea.top,
        max: chartArea.bottom,
        padding: padding.top
    };
    const centerX = $4049e6bf31df43d6$var$adjustLabelCoordinate(pt.x, xCoordinateSizes) + xAdjust;
    const centerY = $4049e6bf31df43d6$var$adjustLabelCoordinate(pt.y, yCoordinateSizes) + yAdjust;
    return {
        x: centerX - width / 2,
        y: centerY - height / 2,
        x2: centerX + width / 2,
        y2: centerY + height / 2,
        centerX: centerX,
        centerY: centerY,
        pointX: pt.x,
        pointY: pt.y,
        width: width,
        height: height,
        rotation: (0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(rotation)
    };
}
function $4049e6bf31df43d6$var$rotatedSize(width, height, rotation) {
    const cos = Math.cos(rotation);
    const sin = Math.sin(rotation);
    return {
        w: Math.abs(width * cos) + Math.abs(height * sin),
        h: Math.abs(width * sin) + Math.abs(height * cos)
    };
}
function $4049e6bf31df43d6$var$calculateT(properties, label, sizes, chartArea) {
    let t;
    const space = $4049e6bf31df43d6$var$spaceAround(properties, chartArea);
    if (label.position === 'start') t = $4049e6bf31df43d6$var$calculateTAdjust({
        w: properties.x2 - properties.x,
        h: properties.y2 - properties.y
    }, sizes, label, space);
    else if (label.position === 'end') t = 1 - $4049e6bf31df43d6$var$calculateTAdjust({
        w: properties.x - properties.x2,
        h: properties.y - properties.y2
    }, sizes, label, space);
    else t = $4049e6bf31df43d6$var$getRelativePosition(1, label.position);
    return t;
}
function $4049e6bf31df43d6$var$calculateTAdjust(lineSize, sizes, label, space) {
    const { labelSize: labelSize, padding: padding } = sizes;
    const lineW = lineSize.w * space.dx;
    const lineH = lineSize.h * space.dy;
    const x = lineW > 0 && (labelSize.w / 2 + padding.left - space.x) / lineW;
    const y = lineH > 0 && (labelSize.h / 2 + padding.top - space.y) / lineH;
    return $4049e6bf31df43d6$var$clamp(Math.max(x, y), 0, 0.25);
}
function $4049e6bf31df43d6$var$spaceAround(properties, chartArea) {
    const { x: x, x2: x2, y: y, y2: y2 } = properties;
    const t = Math.min(y, y2) - chartArea.top;
    const l = Math.min(x, x2) - chartArea.left;
    const b = chartArea.bottom - Math.max(y, y2);
    const r = chartArea.right - Math.max(x, x2);
    return {
        x: Math.min(l, r),
        y: Math.min(t, b),
        dx: l <= r ? 1 : -1,
        dy: t <= b ? 1 : -1
    };
}
function $4049e6bf31df43d6$var$adjustLabelCoordinate(coordinate, labelSizes) {
    const { size: size, min: min, max: max, padding: padding } = labelSizes;
    const halfSize = size / 2;
    if (size > max - min) // if it does not fit, display as much as possible
    return (max + min) / 2;
    if (min >= coordinate - padding - halfSize) coordinate = min + padding + halfSize;
    if (max <= coordinate + padding + halfSize) coordinate = max - padding - halfSize;
    return coordinate;
}
function $4049e6bf31df43d6$var$getArrowHeads(line) {
    const options = line.options;
    const arrowStartOpts = options.arrowHeads && options.arrowHeads.start;
    const arrowEndOpts = options.arrowHeads && options.arrowHeads.end;
    return {
        startOpts: arrowStartOpts,
        endOpts: arrowEndOpts,
        startAdjust: $4049e6bf31df43d6$var$getLineAdjust(line, arrowStartOpts),
        endAdjust: $4049e6bf31df43d6$var$getLineAdjust(line, arrowEndOpts)
    };
}
function $4049e6bf31df43d6$var$getLineAdjust(line, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return 0;
    const { length: length, width: width } = arrowOpts;
    const adjust = line.options.borderWidth / 2;
    const p1 = {
        x: length,
        y: width + adjust
    };
    const p2 = {
        x: 0,
        y: adjust
    };
    return Math.abs($4049e6bf31df43d6$var$interpolateX(0, p1, p2));
}
function $4049e6bf31df43d6$var$drawArrowHead(ctx, offset, adjust, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    const { length: length, width: width, fill: fill, backgroundColor: backgroundColor, borderColor: borderColor } = arrowOpts;
    const arrowOffsetX = Math.abs(offset - length) + adjust;
    ctx.beginPath();
    $4049e6bf31df43d6$var$setShadowStyle(ctx, arrowOpts);
    $4049e6bf31df43d6$var$setBorderStyle(ctx, arrowOpts);
    ctx.moveTo(arrowOffsetX, -width);
    ctx.lineTo(offset + adjust, 0);
    ctx.lineTo(arrowOffsetX, width);
    if (fill === true) {
        ctx.fillStyle = backgroundColor || borderColor;
        ctx.closePath();
        ctx.fill();
        ctx.shadowColor = 'transparent';
    } else ctx.shadowColor = arrowOpts.borderShadowColor;
    ctx.stroke();
}
function $4049e6bf31df43d6$var$getControlPoint(properties, options, distance) {
    const { x: x, y: y, x2: x2, y2: y2, centerX: centerX, centerY: centerY } = properties;
    const angle = Math.atan2(y2 - y, x2 - x);
    const cp = $4049e6bf31df43d6$var$toPosition(options.controlPoint, 0);
    const point = {
        x: centerX + $4049e6bf31df43d6$var$getSize(distance, cp.x, false),
        y: centerY + $4049e6bf31df43d6$var$getSize(distance, cp.y, false)
    };
    return $4049e6bf31df43d6$var$rotated(point, {
        x: centerX,
        y: centerY
    }, angle);
}
function $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, { x: x, y: y }, { angle: angle, adjust: adjust }, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    $4049e6bf31df43d6$var$drawArrowHead(ctx, 0, -adjust, arrowOpts);
    ctx.restore();
}
function $4049e6bf31df43d6$var$drawCurve(ctx, element, cp, length) {
    const { x: x, y: y, x2: x2, y2: y2, options: options } = element;
    const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $4049e6bf31df43d6$var$getArrowHeads(element);
    const p1 = {
        x: x,
        y: y
    };
    const p2 = {
        x: x2,
        y: y2
    };
    const startAngle = $4049e6bf31df43d6$var$angleInCurve(p1, cp, p2, 0);
    const endAngle = $4049e6bf31df43d6$var$angleInCurve(p1, cp, p2, 1) - (0, $84f61e7391a78632$export$56c0d5a1e737357d);
    const ps = $4049e6bf31df43d6$var$pointInCurve(p1, cp, p2, startAdjust / length);
    const pe = $4049e6bf31df43d6$var$pointInCurve(p1, cp, p2, 1 - endAdjust / length);
    const path = new Path2D();
    ctx.beginPath();
    path.moveTo(ps.x, ps.y);
    path.quadraticCurveTo(cp.x, cp.y, pe.x, pe.y);
    ctx.shadowColor = options.borderShadowColor;
    ctx.stroke(path);
    element.path = path;
    element.ctx = ctx;
    $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, ps, {
        angle: startAngle,
        adjust: startAdjust
    }, startOpts);
    $4049e6bf31df43d6$var$drawArrowHeadOnCurve(ctx, pe, {
        angle: endAngle,
        adjust: endAdjust
    }, endOpts);
}
class $4049e6bf31df43d6$var$EllipseAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const rotation = this.options.rotation;
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') return $4049e6bf31df43d6$var$pointInEllipse({
            x: mouseX,
            y: mouseY
        }, this.getProps([
            'width',
            'height',
            'centerX',
            'centerY'
        ], useFinalPosition), rotation, hitSize);
        const { x: x, y: y, x2: x2, y2: y2 } = this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition);
        const limit = axis === 'y' ? {
            start: y,
            end: y2
        } : {
            start: x,
            end: x2
        };
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-rotation));
        return rotatedPoint[axis] >= limit.start - hitSize - $4049e6bf31df43d6$var$EPSILON && rotatedPoint[axis] <= limit.end + hitSize + $4049e6bf31df43d6$var$EPSILON;
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { width: width, height: height, centerX: centerX, centerY: centerY, options: options } = this;
        ctx.save();
        $4049e6bf31df43d6$var$translate(ctx, this.getCenterPoint(), options.rotation);
        $4049e6bf31df43d6$var$setShadowStyle(ctx, this.options);
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        ctx.ellipse(centerX, centerY, height / 2, width / 2, (0, $84f61e7391a78632$export$56c0d5a1e737357d) / 2, 0, 2 * (0, $84f61e7391a78632$export$56c0d5a1e737357d));
        ctx.fill();
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $4049e6bf31df43d6$var$resolveBoxAndLabelProperties(chart, options);
    }
}
$4049e6bf31df43d6$var$EllipseAnnotation.id = 'ellipseAnnotation';
$4049e6bf31df43d6$var$EllipseAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    label: Object.assign({}, $4049e6bf31df43d6$var$BoxAnnotation.defaults.label),
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$4049e6bf31df43d6$var$EllipseAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$4049e6bf31df43d6$var$EllipseAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
function $4049e6bf31df43d6$var$pointInEllipse(p, ellipse, rotation, hitSize) {
    const { width: width, height: height, centerX: centerX, centerY: centerY } = ellipse;
    const xRadius = width / 2;
    const yRadius = height / 2;
    if (xRadius <= 0 || yRadius <= 0) return false;
    // https://stackoverflow.com/questions/7946187/point-and-ellipse-rotated-position-test-algorithm
    const angle = (0, $84f61e7391a78632$export$625550452a3fa3ec)(rotation || 0);
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const a = Math.pow(cosAngle * (p.x - centerX) + sinAngle * (p.y - centerY), 2);
    const b = Math.pow(sinAngle * (p.x - centerX) - cosAngle * (p.y - centerY), 2);
    return a / Math.pow(xRadius + hitSize, 2) + b / Math.pow(yRadius + hitSize, 2) <= 1.0001;
}
class $4049e6bf31df43d6$var$PointAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y, x2: x2, y2: y2, width: width } = this.getProps([
            'x',
            'y',
            'x2',
            'y2',
            'width'
        ], useFinalPosition);
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') return $4049e6bf31df43d6$var$inPointRange({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), width / 2, hitSize);
        const limit = axis === 'y' ? {
            start: y,
            end: y2,
            value: mouseY
        } : {
            start: x,
            end: x2,
            value: mouseX
        };
        return $4049e6bf31df43d6$var$inLimit(limit, hitSize);
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const borderWidth = options.borderWidth;
        if (options.radius < 0.1) return;
        ctx.save();
        ctx.fillStyle = options.backgroundColor;
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        $4049e6bf31df43d6$var$drawPoint(ctx, this, this.centerX, this.centerY);
        if (stroke && !$4049e6bf31df43d6$var$isImageOrCanvas(options.pointStyle)) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
        options.borderWidth = borderWidth;
    }
    resolveElementProperties(chart, options) {
        const properties = $4049e6bf31df43d6$var$resolvePointProperties(chart, options);
        properties.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
        return properties;
    }
}
$4049e6bf31df43d6$var$PointAnnotation.id = 'pointAnnotation';
$4049e6bf31df43d6$var$PointAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    pointStyle: 'circle',
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$PointAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
class $4049e6bf31df43d6$var$PolygonAnnotation extends (0, $216d2bdc6f281bf6$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        if (axis !== 'x' && axis !== 'y') return this.options.radius >= 0.1 && this.elements.length > 1 && $4049e6bf31df43d6$var$pointIsInPolygon(this.elements, mouseX, mouseY, useFinalPosition);
        const rotatedPoint = $4049e6bf31df43d6$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $84f61e7391a78632$export$625550452a3fa3ec)(-this.options.rotation));
        const axisPoints = this.elements.map((point)=>axis === 'y' ? point.bY : point.bX);
        const start = Math.min(...axisPoints);
        const end = Math.max(...axisPoints);
        return rotatedPoint[axis] >= start && rotatedPoint[axis] <= end;
    }
    getCenterPoint(useFinalPosition) {
        return $4049e6bf31df43d6$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { elements: elements, options: options } = this;
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        $4049e6bf31df43d6$var$setShadowStyle(ctx, options);
        const stroke = $4049e6bf31df43d6$var$setBorderStyle(ctx, options);
        let first = true;
        for (const el of elements)if (first) {
            ctx.moveTo(el.x, el.y);
            first = false;
        } else ctx.lineTo(el.x, el.y);
        ctx.closePath();
        ctx.fill();
        // If no border, don't draw it
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        const properties = $4049e6bf31df43d6$var$resolvePointProperties(chart, options);
        const { sides: sides, rotation: rotation } = options;
        const elements = [];
        const angle = 2 * (0, $84f61e7391a78632$export$56c0d5a1e737357d) / sides;
        let rad = rotation * (0, $84f61e7391a78632$export$39c1cc7c062529d4);
        for(let i = 0; i < sides; i++, rad += angle){
            const elProps = $4049e6bf31df43d6$var$buildPointElement(properties, options, rad);
            elProps.initProperties = $4049e6bf31df43d6$var$initAnimationProperties(chart, properties, options);
            elements.push(elProps);
        }
        properties.elements = elements;
        return properties;
    }
}
$4049e6bf31df43d6$var$PolygonAnnotation.id = 'polygonAnnotation';
$4049e6bf31df43d6$var$PolygonAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    point: {
        radius: 0
    },
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    sides: 3,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$4049e6bf31df43d6$var$PolygonAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
function $4049e6bf31df43d6$var$buildPointElement({ centerX: centerX, centerY: centerY }, { radius: radius, borderWidth: borderWidth, hitTolerance: hitTolerance }, rad) {
    const hitSize = (borderWidth + hitTolerance) / 2;
    const sin = Math.sin(rad);
    const cos = Math.cos(rad);
    const point = {
        x: centerX + sin * radius,
        y: centerY - cos * radius
    };
    return {
        type: 'point',
        optionScope: 'point',
        properties: {
            x: point.x,
            y: point.y,
            centerX: point.x,
            centerY: point.y,
            bX: centerX + sin * (radius + hitSize),
            bY: centerY - cos * (radius + hitSize)
        }
    };
}
function $4049e6bf31df43d6$var$pointIsInPolygon(points, x, y, useFinalPosition) {
    let isInside = false;
    let A = points[points.length - 1].getProps([
        'bX',
        'bY'
    ], useFinalPosition);
    for (const point of points){
        const B = point.getProps([
            'bX',
            'bY'
        ], useFinalPosition);
        if (B.bY > y !== A.bY > y && x < (A.bX - B.bX) * (y - B.bY) / (A.bY - B.bY) + B.bX) isInside = !isInside;
        A = B;
    }
    return isInside;
}
const $4049e6bf31df43d6$var$annotationTypes = {
    box: $4049e6bf31df43d6$var$BoxAnnotation,
    doughnutLabel: $4049e6bf31df43d6$var$DoughnutLabelAnnotation,
    ellipse: $4049e6bf31df43d6$var$EllipseAnnotation,
    label: $4049e6bf31df43d6$var$LabelAnnotation,
    line: $4049e6bf31df43d6$var$LineAnnotation,
    point: $4049e6bf31df43d6$var$PointAnnotation,
    polygon: $4049e6bf31df43d6$var$PolygonAnnotation
};
/**
 * Register fallback for annotation elements
 * For example lineAnnotation options would be looked through:
 * - the annotation object (options.plugins.annotation.annotations[id])
 * - element options (options.elements.lineAnnotation)
 * - element defaults (defaults.elements.lineAnnotation)
 * - annotation plugin defaults (defaults.plugins.annotation, this is what we are registering here)
 */ Object.keys($4049e6bf31df43d6$var$annotationTypes).forEach((key)=>{
    (0, $84f61e7391a78632$export$4368d992c4eafac0).describe(`elements.${$4049e6bf31df43d6$var$annotationTypes[key].id}`, {
        _fallback: 'plugins.annotation.common'
    });
});
const $4049e6bf31df43d6$var$directUpdater = {
    update: Object.assign
};
const $4049e6bf31df43d6$var$hooks$1 = $4049e6bf31df43d6$var$eventHooks.concat($4049e6bf31df43d6$var$elementHooks);
const $4049e6bf31df43d6$var$resolve = (value, optDefs)=>(0, $84f61e7391a78632$export$23f2a1d2818174ef)(optDefs) ? $4049e6bf31df43d6$var$resolveObj(value, optDefs) : value;
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").UpdateMode } UpdateMode
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ /**
 * @param {string} prop
 * @returns {boolean}
 */ const $4049e6bf31df43d6$var$isIndexable = (prop)=>prop === 'color' || prop === 'font';
/**
 * Resolve the annotation type, checking if is supported.
 * @param {string} [type=line] - annotation type
 * @returns {string} resolved annotation type
 */ function $4049e6bf31df43d6$var$resolveType(type = 'line') {
    if ($4049e6bf31df43d6$var$annotationTypes[type]) return type;
    console.warn(`Unknown annotation type: '${type}', defaulting to 'line'`);
    return 'line';
}
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 * @param {UpdateMode} mode
 */ function $4049e6bf31df43d6$var$updateElements(chart, state, options, mode) {
    const animations = $4049e6bf31df43d6$var$resolveAnimations(chart, options.animations, mode);
    const annotations = state.annotations;
    const elements = $4049e6bf31df43d6$var$resyncElements(state.elements, annotations);
    for(let i = 0; i < annotations.length; i++){
        const annotationOptions = annotations[i];
        const element = $4049e6bf31df43d6$var$getOrCreateElement(elements, i, annotationOptions.type);
        const resolver = annotationOptions.setContext($4049e6bf31df43d6$var$getContext(chart, element, elements, annotationOptions));
        const properties = element.resolveElementProperties(chart, resolver);
        properties.skip = $4049e6bf31df43d6$var$toSkip(properties);
        if ('elements' in properties) {
            $4049e6bf31df43d6$var$updateSubElements(element, properties.elements, resolver, animations);
            // Remove the sub-element definitions from properties, so the actual elements
            // are not overwritten by their definitions
            delete properties.elements;
        }
        if (!(0, $84f61e7391a78632$export$dda1d9f60106f0e9)(element.x)) // If the element is newly created, assing the properties directly - to
        // make them readily awailable to any scriptable options. If we do not do this,
        // the properties retruned by `resolveElementProperties` are available only
        // after options resolution.
        Object.assign(element, properties);
        Object.assign(element, properties.initProperties);
        properties.options = $4049e6bf31df43d6$var$resolveAnnotationOptions(resolver);
        animations.update(element, properties);
    }
}
function $4049e6bf31df43d6$var$toSkip(properties) {
    return isNaN(properties.x) || isNaN(properties.y);
}
function $4049e6bf31df43d6$var$resolveAnimations(chart, animOpts, mode) {
    if (mode === 'reset' || mode === 'none' || mode === 'resize') return $4049e6bf31df43d6$var$directUpdater;
    return new (0, $216d2bdc6f281bf6$export$8ab227dac26677d)(chart, animOpts);
}
function $4049e6bf31df43d6$var$updateSubElements(mainElement, elements, resolver, animations) {
    const subElements = mainElement.elements || (mainElement.elements = []);
    subElements.length = elements.length;
    for(let i = 0; i < elements.length; i++){
        const definition = elements[i];
        const properties = definition.properties;
        const subElement = $4049e6bf31df43d6$var$getOrCreateElement(subElements, i, definition.type, definition.initProperties);
        const subResolver = resolver[definition.optionScope].override(definition);
        properties.options = $4049e6bf31df43d6$var$resolveAnnotationOptions(subResolver);
        animations.update(subElement, properties);
    }
}
function $4049e6bf31df43d6$var$getOrCreateElement(elements, index, type, initProperties) {
    const elementClass = $4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(type)];
    let element = elements[index];
    if (!element || !(element instanceof elementClass)) {
        element = elements[index] = new elementClass();
        Object.assign(element, initProperties);
    }
    return element;
}
function $4049e6bf31df43d6$var$resolveAnnotationOptions(resolver) {
    const elementClass = $4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(resolver.type)];
    const result = {};
    result.id = resolver.id;
    result.type = resolver.type;
    result.drawTime = resolver.drawTime;
    Object.assign(result, $4049e6bf31df43d6$var$resolveObj(resolver, elementClass.defaults), $4049e6bf31df43d6$var$resolveObj(resolver, elementClass.defaultRoutes));
    for (const hook of $4049e6bf31df43d6$var$hooks$1)result[hook] = resolver[hook];
    return result;
}
function $4049e6bf31df43d6$var$resolveObj(resolver, defs) {
    const result = {};
    for (const prop of Object.keys(defs)){
        const optDefs = defs[prop];
        const value = resolver[prop];
        if ($4049e6bf31df43d6$var$isIndexable(prop) && (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(value)) result[prop] = value.map((item)=>$4049e6bf31df43d6$var$resolve(item, optDefs));
        else result[prop] = $4049e6bf31df43d6$var$resolve(value, optDefs);
    }
    return result;
}
function $4049e6bf31df43d6$var$getContext(chart, element, elements, annotation) {
    return element.$context || (element.$context = Object.assign(Object.create(chart.getContext()), {
        element: element,
        get elements () {
            return elements.filter((el)=>el && el.options);
        },
        id: annotation.id,
        type: 'annotation'
    }));
}
function $4049e6bf31df43d6$var$resyncElements(elements, annotations) {
    const count = annotations.length;
    const start = elements.length;
    if (start < count) {
        const add = count - start;
        elements.splice(start, 0, ...new Array(add));
    } else if (start > count) elements.splice(count, start - count);
    return elements;
}
var $4049e6bf31df43d6$var$version = "3.1.0";
const $4049e6bf31df43d6$var$chartStates = new Map();
const $4049e6bf31df43d6$var$isNotDoughnutLabel = (annotation)=>annotation.type !== 'doughnutLabel';
const $4049e6bf31df43d6$var$hooks = $4049e6bf31df43d6$var$eventHooks.concat($4049e6bf31df43d6$var$elementHooks);
var $4049e6bf31df43d6$export$2e2bcd8739ae039 = {
    id: 'annotation',
    version: $4049e6bf31df43d6$var$version,
    beforeRegister () {
        $4049e6bf31df43d6$var$requireVersion('chart.js', '4.0', (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).version);
    },
    afterRegister () {
        (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register($4049e6bf31df43d6$var$annotationTypes);
    },
    afterUnregister () {
        (0, $216d2bdc6f281bf6$export$acaa6426d77a227e).unregister($4049e6bf31df43d6$var$annotationTypes);
    },
    beforeInit (chart) {
        $4049e6bf31df43d6$var$chartStates.set(chart, {
            annotations: [],
            elements: [],
            visibleElements: [],
            listeners: {},
            listened: false,
            moveListened: false,
            hooks: {},
            hooked: false,
            hovered: []
        });
    },
    beforeUpdate (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        const annotations = state.annotations = [];
        let annotationOptions = options.annotations;
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(annotationOptions)) Object.keys(annotationOptions).forEach((key)=>{
            const value = annotationOptions[key];
            if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) {
                value.id = key;
                annotations.push(value);
            }
        });
        else if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(annotationOptions)) annotations.push(...annotationOptions);
        $4049e6bf31df43d6$var$verifyScaleOptions(annotations.filter($4049e6bf31df43d6$var$isNotDoughnutLabel), chart.scales);
    },
    afterDataLimits (chart, args) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        $4049e6bf31df43d6$var$adjustScaleRange(chart, args.scale, state.annotations.filter($4049e6bf31df43d6$var$isNotDoughnutLabel).filter((a)=>a.display && a.adjustScaleRange));
    },
    afterUpdate (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        $4049e6bf31df43d6$var$updateListeners(chart, state, options);
        $4049e6bf31df43d6$var$updateElements(chart, state, options, args.mode);
        state.visibleElements = state.elements.filter((el)=>!el.skip && el.options.display);
        $4049e6bf31df43d6$var$updateHooks(chart, state, options);
    },
    beforeDatasetsDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'beforeDatasetsDraw', options.clip);
    },
    afterDatasetsDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'afterDatasetsDraw', options.clip);
    },
    beforeDatasetDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, _args.index, options.clip);
    },
    beforeDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'beforeDraw', options.clip);
    },
    afterDraw (chart, _args, options) {
        $4049e6bf31df43d6$var$draw(chart, 'afterDraw', options.clip);
    },
    beforeEvent (chart, args, options) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        if ($4049e6bf31df43d6$var$handleEvent(state, args.event, options)) args.changed = true;
    },
    afterDestroy (chart) {
        $4049e6bf31df43d6$var$chartStates.delete(chart);
    },
    getAnnotations (chart) {
        const state = $4049e6bf31df43d6$var$chartStates.get(chart);
        return state ? state.elements : [];
    },
    // only for testing
    _getAnnotationElementsAtEventForMode (visibleElements, event, options) {
        return $4049e6bf31df43d6$var$getElements(visibleElements, event, options);
    },
    defaults: {
        animations: {
            numbers: {
                properties: [
                    'x',
                    'y',
                    'x2',
                    'y2',
                    'width',
                    'height',
                    'centerX',
                    'centerY',
                    'pointX',
                    'pointY',
                    'radius'
                ],
                type: 'number'
            },
            colors: {
                properties: [
                    'backgroundColor',
                    'borderColor'
                ],
                type: 'color'
            }
        },
        clip: true,
        interaction: {
            mode: undefined,
            axis: undefined,
            intersect: undefined
        },
        common: {
            drawTime: 'afterDatasetsDraw',
            init: false,
            label: {}
        }
    },
    descriptors: {
        _indexable: false,
        _scriptable: (prop)=>!$4049e6bf31df43d6$var$hooks.includes(prop) && prop !== 'init',
        annotations: {
            _allKeys: false,
            _fallback: (prop, opts)=>`elements.${$4049e6bf31df43d6$var$annotationTypes[$4049e6bf31df43d6$var$resolveType(opts.type)].id}`
        },
        interaction: {
            _fallback: true
        },
        common: {
            label: {
                _indexable: $4049e6bf31df43d6$var$isIndexable,
                _fallback: true
            },
            _indexable: $4049e6bf31df43d6$var$isIndexable
        }
    },
    additionalOptionScopes: [
        ''
    ]
};
function $4049e6bf31df43d6$var$draw(chart, caller, clip) {
    const { ctx: ctx, chartArea: chartArea } = chart;
    const state = $4049e6bf31df43d6$var$chartStates.get(chart);
    if (clip) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, chartArea);
    const drawableElements = $4049e6bf31df43d6$var$getDrawableElements(state.visibleElements, caller).sort((a, b)=>a.element.options.z - b.element.options.z);
    for (const item of drawableElements)$4049e6bf31df43d6$var$drawElement(ctx, chartArea, state, item);
    if (clip) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
}
function $4049e6bf31df43d6$var$getDrawableElements(elements, caller) {
    const drawableElements = [];
    for (const el of elements){
        if (el.options.drawTime === caller) drawableElements.push({
            element: el,
            main: true
        });
        if (el.elements && el.elements.length) {
            for (const sub of el.elements)if (sub.options.display && sub.options.drawTime === caller) drawableElements.push({
                element: sub
            });
        }
    }
    return drawableElements;
}
function $4049e6bf31df43d6$var$drawElement(ctx, chartArea, state, item) {
    const el = item.element;
    if (item.main) {
        $4049e6bf31df43d6$var$invokeHook(state, el, 'beforeDraw');
        el.draw(ctx, chartArea);
        $4049e6bf31df43d6$var$invokeHook(state, el, 'afterDraw');
    } else el.draw(ctx, chartArea);
}


window.customElements.define('me4f-submit', (0, $426c06cb104d4dd1$export$2e2bcd8739ae039));
document.addEventListener("DOMContentLoaded", function() {
    $45ddceb881e03ada$var$updateSortSearchParams();
});
function $45ddceb881e03ada$var$updateSortSearchParams() {
    const url = new URL(document.location.href);
    const sortOrder = url.searchParams.get("mira_filter_form[sortorder]");
    const sortLinks = document.getElementsByClassName("sortlink");
    for(let i = 0; i < sortLinks.length; i++){
        const element = sortLinks[i];
        url.searchParams.set("mira_filter_form[sort]", element.getAttribute('title'));
        url.searchParams.set("mira_filter_form[sortorder]", 'ASC' === sortOrder ? 'DESC' : 'ASC');
        url.searchParams.set("mira_filter_form[offset]", url.searchParams.get("mira_filter_form[offset]") ?? '0');
        element.setAttribute('href', url.href);
    }
}
// Chart / Stats
(0, $e24bb3f4f01060dd$export$2e2bcd8739ae039).register((0, $4049e6bf31df43d6$export$2e2bcd8739ae039));
function $45ddceb881e03ada$var$getGraphWrapperCssClasses(chartJsData) {
    let classes;
    if (-1 != [
        'pie',
        'doughnut'
    ].indexOf(chartJsData.chartType)) classes = 'min-width-graph-container';
    else if (-1 != [
        'bar'
    ].indexOf(chartJsData.chartType)) classes = 'medium-width-graph-container';
    else classes = 'max-width-graph-container';
    return classes;
}
function $45ddceb881e03ada$var$renderGraphs(parentElement, datasetsArray, chartDivName = '') {
    let counter = 0;
    datasetsArray.forEach((chartJsData)=>{
        counter += 1;
        const elId = `graph-${counter}`;
        // console.log(chartJsData);
        parentElement.insertAdjacentHTML('beforeend', `<div class="graph-wrapper ${$45ddceb881e03ada$var$getGraphWrapperCssClasses(chartJsData)}">
                        <h3 id="h-${counter}">${chartJsData.title}</h3>
                        <div class="graph-container">
                          <canvas 
                            id="${chartDivName}${elId}" 
                            width="${chartJsData.width ?? 500}" 
                            height="${chartJsData.height ?? 250}"
                          >    
                          </canvas>
                        </div>
                      </div>`);
        const footer = (tooltipItems)=>{
            return chartJsData.comments[tooltipItems[0].label];
        };
        const chartConfig = {
            type: chartJsData.chartType,
            data: {
                labels: chartJsData.xLabels,
                datasets: chartJsData.datasets
            },
            options: {
                interaction: {
                    intersect: false,
                    mode: "index"
                },
                plugins: {
                    legend: {
                        // labels: {
                        //     generateLabels: (chart) => {
                        //         const datasets = chart.data.datasets;
                        //         return datasets[0].data.map((data, i) => ({
                        //             text: `${chart.data.labels[i]} ${data}`,
                        //             fillStyle: datasets[0].backgroundColor[i],
                        //             index: i
                        //         }))
                        //     }
                        // },
                        display: chartJsData.displayLegend,
                        position: 'left'
                    },
                    tooltip: {
                        callbacks: {
                            footer: footer
                        }
                    },
                    annotation: {
                        annotations: {
                        }
                    }
                },
                scales: chartJsData.scaleTypeY ? {
                    x: {
                        // type: chartJsData.scaleTypeX,
                        stacked: chartJsData.scaleStackedX ?? false
                    },
                    y: {
                        type: chartJsData.scaleTypeY,
                        stacked: chartJsData.scaleStackedY ?? false
                    }
                } : {}
            }
        };
        const chartElem = document.getElementById(chartDivName + elId);
        new (0, $e24bb3f4f01060dd$export$2e2bcd8739ae039)(chartElem, chartConfig);
    });
}
// @ts-ignore
window.Chart = (0, $e24bb3f4f01060dd$export$2e2bcd8739ae039);
// @ts-ignore
window.renderGraphs = $45ddceb881e03ada$var$renderGraphs;


//# sourceMappingURL=app.twig.4e09eaa5.js.map
